import {
    AllDefaultUserGroupIds,
    AllIntegrationCapabilities,
    AllObservabilityAndAnalyticsMetricTypes,
    AllPatternTokens,
    AllStabilityMetricTypes,
    AmazonAppStoreData,
    AmazonAppStoreState,
    AppEntity,
    AppGroup,
    AppleAppStoreData,
    AppleAppStoreDefaultSettings,
    AppleAppStorePhasedReleaseState,
    AppleAppStoreReleaseType,
    AppleAppStoreState,
    AppleExternalBetaBuildState,
    AppleInternalBetaBuildState,
    AppMonitoringHealthMetric,
    AppMonitoringHealthMetricCategory,
    AppMonitoringHealthMetrics,
    AppMonitoringHealthMetricType,
    AppNotificationCategory,
    AppNotificationType,
    AppPlatform,
    AppStoreAvailableBuild,
    AppStoreBuild,
    AppStoreBuildType,
    AppStoreDefaultSettings,
    AppStoreReviewSubmissionState,
    AppStoreState,
    AppStoreType,
    Automation,
    AutomationAutoStagedRollout,
    AutomationCategory,
    AutomationPromoteBuildsToTestTrackData,
    AutomationRun,
    AutomationStatus,
    AutomationType,
    AutoStagedRolloutBlackoutSegmentsByDay,
    BucketMember,
    BucketRule,
    BucketType,
    BuildArtifactType,
    BuildDistroBucketBase,
    BuildDistroBucketPRRule,
    BuildDistroBucketRuleType,
    BuildDistroBuild,
    BuildDistroBuildSharedWithMe,
    BuildDistroMemberPermissionLevel,
    BuildDistroMemberType,
    BuildDistroNotificationType,
    BuildStatus,
    CadenceTargetDateSet,
    ChecklistItem,
    ChecklistItemPlacement,
    ChecklistItemStatusType,
    ChecklistItemTemplate,
    ChecklistItemType,
    CodeType,
    CommsChannelDisallowedTokens,
    CommitItem,
    CrowdinIntegrationData,
    DayOfTheWeek,
    DefaultUserGroupId,
    EditViewPilot,
    Environment,
    EventAndParam,
    ExtendedStatisticType,
    ExternalCalendarEvent,
    FeatureAffiliationType,
    FeatureItem,
    FeatureItemCodeStatus,
    GoogleAppStoreSettings,
    GooglePlayReleaseLifecycleState,
    GooglePlayStoreData,
    GooglePlayStoreState,
    HuaweiAppStoreData,
    HuaweiAppStoreState,
    HuaweiPhasedReleaseState,
    Integration,
    IntegrationCapability,
    IntegrationErrorType,
    IntegrationInstallationId,
    IntegrationProvider,
    IntegrationProviderType,
    IntegrationType,
    JiraIntegrationData,
    KickoffActionStatus,
    LifecycleEventType,
    LifecycleFreezeSet,
    LifecycleStep,
    LinearIntegrationData,
    LocalizedMetadata,
    LokaliseIntegrationData,
    MetadataTranslationLocale,
    MetadataTranslationStatus,
    MetricConditionOperator,
    MonitoringAutomation,
    MonitoringAutomationConditionType,
    MonitoringMetricHealthStatus,
    MonitoringStatistic,
    NextReleaseSummary,
    NonErrorRunwayResponseTypes,
    ObservabilityAndAnalyticsMetricType,
    OrganizationEntity,
    OverviewSection,
    PatternToken,
    PhasedRelease,
    PhasedReleaseState,
    PRItem,
    ProvisioningProfileType,
    PullRequestStatus,
    RegressionStatus,
    Release,
    ReleaseAdoption,
    ReleaseCalendarData,
    ReleaseCalendarEventType,
    ReleaseCalendarLifecycleEvent,
    ReleaseMethod,
    ReleasePilotRotationItem,
    ReleaseScheduleCadenceSettings,
    ReleaseScheduleCadenceStyle,
    ReleaseStatus,
    ReleaseStep,
    ReleaseStepBlockingConfig,
    ReleaseStepStatus,
    ReleaseStepTakeoff,
    ReleaseStepType,
    ReleaseTagState,
    ReleaseTimelinePhase,
    ReleaseType,
    ReleaseTypesForNonBlockingSteps,
    SamsungAppStoreData,
    SamsungAppStoreState,
    StabilityInfo,
    StabilityMetricType,
    StatChangeStatus,
    Statistic,
    StatisticCategory,
    StatisticTimeSeriesDataPoint,
    StatisticType,
    StatisticUnit,
    StatisticWithAssociatedInfo,
    SubscriptionFeaturesAndCapabilities,
    SubscriptionFeatureType,
    SubscriptionStatus,
    ThirdPartyAuthError,
    TransactionType,
    TranslationStringStatus,
    TrendStatus,
    User,
    UserGroup,
    UserGroupId,
    UserPermissions,
    UserRatingsMetricType,
    WorkflowEnabledSteps,
    FixRequestStatusInfo,
    FixRequestStatusType,
    FixRequestFormFieldSettings,
    FixRequestFormFieldValue,
    TicketStatusCategory,
} from './types';
import { antBlue, antCyan, antGrey, runwayColors } from './components/styles/globalStyles';
import { getCurrentThemeMode } from './components/styles/themeMode';
import { RootState } from './reducers/reducers';
import { Updatable } from './actions/updatable';
import { compact, differenceBy, forEach, groupBy, isNil, reduce } from 'lodash';
import {
    categoryForMonitoringStatisticType,
    displayMonitoringStatisticTitle,
    displayMonitoringStatisticUnitLabel,
    displayUngroupedMonitoringStatisticTitle,
    GroupedMonitoringStatistic,
    groupKeyByMonitoringStatistic,
    stabilityMetricGroupKey,
    MonitoringStatisticAutomationUsage,
    MonitoringStatisticGroup,
    Nullable,
    StringKeyedDictionary,
    UserAppData,
    WorkflowAndBranchData,
} from './typescriptHelpers';
import { useSelector } from 'react-redux';
import {
    selectAllAppsIdsInOrg,
    selectApp,
    selectIsDemoInstance,
    selectProviderForIntegration,
    selectRelease,
    selectReleaseStep,
} from './selectors/selectors';
import { dayjs } from '@/extendedDayjs';
import {
    getLifecycleStepDisplayText,
    getLifecycleStepTargetDate,
    isLifecycleStepCompleted,
    isLifecycleStepCompletedDate,
} from './components/automations/automationHelperComponents';
import qs from 'qs';
import { OrgOverviewFilters } from './actions/entities';
import routes from './routes';
import { FormFieldData } from './helpers/formHelpers';
import { updateIntegrationFormDataForIntegration } from './helpers/integrationFormHelpers';
import { globalMessage } from './utils/globalMessage';
import { CreateEditReleaseType } from './actions/release';
import { displayLifecycleEventName, displayStringForRolloutPercentage } from './helpers/displayHelpers';
import { RolloutStepRunStatusData, StepRunStatusData } from '@/types/stepRunStatus';
import { OverviewDestinationStatus } from '@/types/workflowOverview';
import { DatetimeFormat } from '@/timeHelpers';
import { USER_FRIENDLY_ERRORS } from './constants';
import { UiConfig } from './actions/ui';

// Counts Unicode code points (runes), matching Go's utf8.RuneCountInString.
// Iterating a string yields code points, so surrogate pairs (e.g. emoji) count as 1,
// unlike String.prototype.length which counts UTF-16 code units.
export const runeCount = (str: string): number => [...str].length;

// Builds an identifier-friendly slug from a display name: lowercased, trimmed, with runs of
// whitespace collapsed to single hyphens. Used to derive readable, stable field ids from names.
export const slugify = (name: string): string => name.trim().toLowerCase().replace(/\s+/g, '-');

// Derives a fix request form field's id from its name. The id is not stored on the settings — this
// is the single source of truth for it (mirrors the backend's GetFieldId()).
export const getFixRequestFormFieldId = (field: FixRequestFormFieldSettings): string => slugify(field.name);

// Joins a fix request's form field values into a single human-readable summary line, skipping
// empty values. Used for compact displays (list rows, cards) where individual labels aren't shown.
export const getFixRequestFormFieldsSummary = (values?: FixRequestFormFieldValue[]): string =>
    values
        ?.map((v) => v.value?.trim())
        .filter(Boolean)
        .join(' • ') ?? '';

// UI state helpers

export const getError = (
    type: Updatable | string,
    state: RootState,
    id: number | string | null = null,
): string | null => {
    const failure = state.ui.failed.find((failure) => failure.type === type && failure.id === id);

    return failure?.error ?? null;
};

export const getIsLoading = (
    type: Updatable | string,
    state: RootState,
    id: number | string | null = null,
): boolean => {
    const isLoading = state.ui.loading.find((loading) => {
        return loading.actionName === type && loading.id === id;
    });

    return isLoading !== undefined;
};

export const getUpdated = (type: Updatable | string, state: RootState, id: number | string | null = null): boolean => {
    const didUpdate = state.ui.updated.find((updated) => {
        return updated.updatedType === type && updated.id === id;
    });

    return didUpdate !== undefined;
};

export const getResponseType = (
    type: Updatable | string,
    state: RootState,
    id: number | string | null = null,
): Nullable<NonErrorRunwayResponseTypes> => {
    const updatedAction = state.ui.updated.find((updated) => {
        return updated.updatedType === type && updated.id === id;
    });

    return updatedAction?.responseType;
};

export const getWillUpdate = (
    type: Updatable | string,
    state: RootState,
    id: number | string | null = null,
): boolean => {
    const willUpdate = state.ui.willUpdate.find((updated) => {
        return updated.updatedType === type && updated.id === id;
    });

    return willUpdate !== undefined;
};

export const getReleaseStepFromState = (
    releaseStepType: ReleaseStepType | string,
    releaseId: string,
    state: RootState,
): ReleaseStep => {
    return selectReleaseStep(state, releaseId, releaseStepType as ReleaseStepType);
};

// Entity helpers

export const getChecklistItemFromState = (
    appId: string,
    checklistItemId: string,
    state: RootState,
): ChecklistItemTemplate | undefined => {
    const app = selectApp(state, appId);
    const item = app.appSettings.stepChecklistItems.find((item) => item.id === checklistItemId);

    return item;
};

export const getAllReleaseIdsForAppId = (appId: string, state: RootState): string[] => {
    const uiConfig = state.ui.uiConfig as UiConfig;
    if (uiConfig.demoData && uiConfig.demoData.appsDemoData && uiConfig.demoData.appsDemoData[appId]) {
        return uiConfig.demoData.appsDemoData[appId].releaseIds;
    }

    const releasesInApp = state.relationships.releasesInApp[appId];

    if (releasesInApp) {
        return releasesInApp.releaseIds;
    }

    return [];
};

export const getAllReleasesForAppId = (appId: string, state: RootState): Release[] => {
    const allReleaseIds = getAllReleaseIdsForAppId(appId, state);
    const allReleases = allReleaseIds
        .map((releaseId) => {
            return selectRelease(state, releaseId);
        })
        .filter((release) => release.status !== ReleaseStatus.Deleted)
        .sort((releaseA, releaseB) => {
            return compareVersions(releaseA.version, releaseB.version);
        });

    return allReleases;
};

export const getAllAppsInOrg = (orgId: string, state: RootState): AppEntity[] => {
    const allAppIds = selectAllAppsIdsInOrg(state, orgId);
    const apps = allAppIds.map((appId) => {
        return selectApp(state, appId);
    });

    return apps;
};

export const compareVersions: (versionA: string, versionB: string) => number = (versionA, versionB) => {
    const partsA = versionA.split('.').map((p) => +p || 0);
    const partsB = versionB.split('.').map((p) => +p || 0);
    const maxLen = Math.max(partsA.length, partsB.length);

    for (let i = 0; i < maxLen; i++) {
        const a = partsA[i] ?? 0;
        const b = partsB[i] ?? 0;
        if (b !== a) {
            return b - a;
        }
    }

    return 0;
};

export const getAllAppsForOrgId = (orgId: string, state: RootState): AppEntity[] => {
    const allAppIds = selectAllAppsIdsInOrg(state, orgId);
    const apps = allAppIds.map((appId) => {
        return state.entities.apps.byId[appId];
    });

    return apps;
};

export const getAllOrgs = (state: RootState): OrganizationEntity[] => {
    const allOrgs = state.entities.orgs.allIds.map((orgId) => {
        return state.entities.orgs.byId[orgId];
    });

    return allOrgs;
};

export const getAppGroupById = (appGroupId: string, state: RootState): AppGroup => {
    const appGroup = state.entities.appGroups.byId[appGroupId];

    return appGroup;
};

export const getAppGroupsForOrgId = (orgId: string, state: RootState): AppGroup[] | null => {
    const uiConfig = state.ui.uiConfig as UiConfig;
    if (uiConfig.demoData?.appGroupsDemoData?.length) {
        return uiConfig.demoData.appGroupsDemoData;
    }

    const appGroupsForOrg = state.relationships.appGroupsInOrg[orgId];

    if (appGroupsForOrg) {
        const appGroups = appGroupsForOrg.appGroupIds.map((appGroupId) => getAppGroupById(appGroupId, state));

        return compact(appGroups);
    }

    return null;
};

// UUID Mapping helpers

const RELEASE_ID_PARAM_NEXT = 'next';
const RELEASE_ID_PARAM_LIVE = 'live';

const SPECIAL_RELEASE_ID_PARAMS = new Set([RELEASE_ID_PARAM_NEXT, RELEASE_ID_PARAM_LIVE]);

const resolveSpecialReleaseIdParamToInternalId = (
    appId: string,
    releaseIdParam: string,
    state: RootState,
): string | null => {
    const normalized = releaseIdParam.toLowerCase();

    if (!SPECIAL_RELEASE_ID_PARAMS.has(normalized)) {
        return null;
    }

    const releases = getAllReleasesForAppId(appId, state);
    const { currentReleases, completedReleases } = groupReleasesByTimelinePhase(releases);

    if (normalized === RELEASE_ID_PARAM_NEXT) {
        const nextRelease =
            currentReleases.find((release) => release.type !== ReleaseType.Rollback) ?? currentReleases[0];

        return nextRelease?.id ?? null;
    }

    const liveReleaseId = selectApp(state, appId)?.liveReleaseId;
    if (liveReleaseId && selectRelease(state, liveReleaseId)) {
        return liveReleaseId;
    }

    return completedReleases[0]?.id ?? null;
};

export const getIdFromReleaseId = (
    orgId: string,
    appId: string,
    releaseId: string,
    state: RootState,
): string | null => {
    const uiConfig = state.ui.uiConfig as UiConfig;
    if (uiConfig.demoData && uiConfig.demoData.releaseDemoData) {
        const releaseDemoData = uiConfig.demoData.releaseDemoData;

        if (releaseDemoData[releaseId]) {
            return releaseId;
        }

        if (selectIsDemoInstance(state, orgId)) {
            const matchingKey = Object.keys(releaseDemoData).find(
                (key) =>
                    releaseDemoData[key]?.release?.releaseId === releaseId ||
                    releaseDemoData[key]?.release?.displayableVersion === releaseId,
            );
            return matchingKey ?? null;
        }
        return null;
    }

    const specialResolvedInternalId = resolveSpecialReleaseIdParamToInternalId(appId, releaseId, state);
    if (specialResolvedInternalId) {
        return specialResolvedInternalId;
    }

    const org = state.uuidMappings[orgId] as
        | { id: string; apps: Record<string, { id: string; releases: Record<string, { id: string }> }> }
        | undefined;

    if (org) {
        const app = org.apps[appId];

        if (app) {
            const release = app.releases[releaseId];

            if (release) {
                return release.id;
            }
        }
    }

    return null;
};

export const getIdFromAppId = (orgId: string, appId: string, state: RootState): string | null => {
    const uiConfig = state.ui.uiConfig as UiConfig;
    if (uiConfig.demoData && uiConfig.demoData.appsDemoData) {
        const allMockAppIds = Object.keys(uiConfig.demoData.appsDemoData);

        if (allMockAppIds.includes(appId)) {
            return appId;
        }

        return null;
    }

    const org = state.uuidMappings[orgId] as { id: string; apps: Record<string, { id: string }> } | undefined;

    if (org) {
        const app = org.apps[appId];

        if (app) {
            return app.id;
        }
    }

    return null;
};

export const getIdFromOrgId = (orgId: string, state: RootState): string | null => {
    const org = state.uuidMappings[orgId] as { id: string } | undefined;

    if (org) {
        return org.id;
    }

    return null;
};

// UI Helpers

export const statusColorForReleaseStatus: (status: ReleaseStatus) => string = (status: ReleaseStatus) => {
    let backgroundColor;
    const theme = getCurrentThemeMode();
    switch (status) {
        case ReleaseStatus.Active:
            backgroundColor = runwayColors.statusYellow;
            break;
        case ReleaseStatus.Completed:
            backgroundColor = runwayColors.statusGreen;
            break;
        case ReleaseStatus.Skipped:
            backgroundColor = theme === 'light' ? antGrey.grey7 : antGrey.grey8;
            break;

        default:
            break;
    }

    return backgroundColor;
};

export const statusColorForReleaseStepStatus: (status: ReleaseStepStatus) => string = (status: ReleaseStepStatus) => {
    let backgroundColor;

    switch (status) {
        case ReleaseStepStatus.Pending:
        case ReleaseStepStatus.PendingChecklistOnly:
            backgroundColor = runwayColors.statusYellow;
            break;
        case ReleaseStepStatus.Blocked:
            backgroundColor = runwayColors.statusRed;
            break;
        case ReleaseStepStatus.Ready:
            backgroundColor = runwayColors.statusGreen;
            break;
        case ReleaseStepStatus.Inactive:
        case ReleaseStepStatus.Skipped:
            backgroundColor = runwayColors.statusGrey;
            break;

        default:
            break;
    }

    return backgroundColor;
};

export const innerStepStatusColorForReleaseStepStatus: (status: ReleaseStepStatus) => string = (
    status: ReleaseStepStatus,
) => {
    let backgroundColor;
    // colors map to antd's Timeline.Item colors, which are red, green, blue, and gray

    switch (status) {
        // Incomplete checklist items keep a step out of "ready", so it should not render green.
        case ReleaseStepStatus.Pending:
        case ReleaseStepStatus.PendingChecklistOnly:
            backgroundColor = runwayColors.statusYellow;
            break;
        case ReleaseStepStatus.Blocked:
            backgroundColor = runwayColors.statusRed;
            break;
        case ReleaseStepStatus.Ready:
            backgroundColor = runwayColors.statusGreen;
            break;
        case ReleaseStepStatus.Inactive:
        case ReleaseStepStatus.Skipped:
            backgroundColor = runwayColors.statusGrey;
            break;

        default:
            break;
    }

    return backgroundColor;
};

export const statusColorForRegressionStatus: (status: RegressionStatus, isReleaseFromScraper: boolean) => string = (
    status,
    isReleaseFromScraper,
) => {
    if (isReleaseFromScraper) {
        return runwayColors.statusGrey;
    }

    switch (status) {
        case RegressionStatus.Passed:
            return runwayColors.statusGreen;
        case RegressionStatus.Failed:
            return runwayColors.statusRed;
        case RegressionStatus.InProgress:
            return runwayColors.statusYellow;
        case RegressionStatus.NotStarted:
            return runwayColors.statusGrey;
        default:
            return runwayColors.statusGrey;
    }
};

export const isReleaseSkipped: (status: ReleaseStatus) => boolean = (status) => {
    return status === ReleaseStatus.Skipped;
};

export const isReleaseComplete: (status: ReleaseStatus) => boolean = (status) => {
    return status === ReleaseStatus.Completed;
};

export const displayStatusForPRStatus: (status: PullRequestStatus) => string = (status) => {
    switch (status) {
        case PullRequestStatus.Merged:
            return 'Merged';
        case PullRequestStatus.Open:
            return 'Open PR';
        case PullRequestStatus.Closed:
            return 'Closed';
        case PullRequestStatus.Unknown:
            return 'Unknown';
    }
};

export const tagColorForPullRequestStatus = (status: PullRequestStatus): string | null => {
    switch (status) {
        case PullRequestStatus.Open:
            return runwayColors.statusYellow;
        case PullRequestStatus.Merged:
            return runwayColors.statusGreen;
        case PullRequestStatus.Closed:
            return runwayColors.statusRed;
        default:
            return null;
    }
};

export const tagColorForFeatureItemCodeStatus: (
    isAutoMergeEnabled: boolean,
    status?: FeatureItemCodeStatus,
) => string = (isAutoMergeEnabled, status) => {
    if (status) {
        switch (status) {
            case FeatureItemCodeStatus.Merged:
            case FeatureItemCodeStatus.CherryPickMerged:
                return runwayColors.statusGreen;
            case FeatureItemCodeStatus.OpenPR:
            case FeatureItemCodeStatus.CherryPickQueued:
            case FeatureItemCodeStatus.Unmerged:
                return runwayColors.statusYellow;
            case FeatureItemCodeStatus.CherryPickOpen:
                return isAutoMergeEnabled ? runwayColors.info : runwayColors.statusYellow;
            case FeatureItemCodeStatus.CherryPickPending:
                return runwayColors.info;
            case FeatureItemCodeStatus.CherryPickClosed:
                return antGrey.grey8;
            case FeatureItemCodeStatus.CherryPickFailed:
                return runwayColors.statusRed;
            case FeatureItemCodeStatus.CherryPickSkipped:
            case FeatureItemCodeStatus.CherryPickManuallyResolved:
                return antGrey.grey7;
        }
    } else {
        return runwayColors.statusGrey;
    }
};

export const tagColorForTicketStatus: (isDone?: boolean) => string = (isDone) => {
    if (isDone) {
        return isDone ? runwayColors.statusGreen : runwayColors.statusYellow;
    } else {
        return runwayColors.statusGrey;
    }
};

export const tagColorForStatusCategory: (category?: TicketStatusCategory) => string = (category) => {
    switch (category) {
        case TicketStatusCategory.Done:
            return runwayColors.statusGreen;
        case TicketStatusCategory.InProgress:
            return runwayColors.statusYellow;
        case TicketStatusCategory.Cancelled:
            return antGrey.grey5;
        case TicketStatusCategory.Todo:
        default:
            return runwayColors.statusGrey;
    }
};

export const isNonBlockingStepForReleaseType: (
    nonBlockingStepsConfig: Record<ReleaseStepType, ReleaseStepBlockingConfig>,
    step: ReleaseStepType,
) => boolean = (nonBlockingStepsConfig: Record<ReleaseStepType, ReleaseStepBlockingConfig>, step: ReleaseStepType) => {
    if (nonBlockingStepsConfig[step] === undefined) {
        return false;
    }

    return nonBlockingStepsConfig[step] == ReleaseStepBlockingConfig.NonBlocking;
};

export const populateUndefinedNonBlockingStepsConfig: (
    nonBlockingStepsConfig: Record<ReleaseTypesForNonBlockingSteps, Record<ReleaseStepType, ReleaseStepBlockingConfig>>,
    releaseStepsByReleaseType: StringKeyedDictionary<ReleaseStepType[]>,
) => Record<ReleaseTypesForNonBlockingSteps, Record<ReleaseStepType, ReleaseStepBlockingConfig>> = (
    nonBlockingStepsConfig: Record<ReleaseTypesForNonBlockingSteps, Record<ReleaseStepType, ReleaseStepBlockingConfig>>,
    releaseStepsByReleaseType: StringKeyedDictionary<ReleaseStepType[]>,
) => {
    for (const releaseType in releaseStepsByReleaseType) {
        const releaseTypesForNonBlockingSteps = getReleaseTypeForNonBlockingSteps(releaseType as ReleaseType);
        const steps = releaseStepsByReleaseType[releaseType];

        for (const step of steps) {
            if (nonBlockingStepsConfig[releaseTypesForNonBlockingSteps][step] === undefined) {
                nonBlockingStepsConfig[releaseTypesForNonBlockingSteps][step] = ReleaseStepBlockingConfig.Blocking;
            }
        }
    }
    return nonBlockingStepsConfig;
};

export const getReleaseTypeForNonBlockingSteps: (releaseType: ReleaseType) => ReleaseTypesForNonBlockingSteps = (
    releaseType: ReleaseType,
) => {
    switch (releaseType) {
        case ReleaseType.Hotfix:
            return ReleaseTypesForNonBlockingSteps.Hotfix;
        case ReleaseType.Rollback:
            return ReleaseTypesForNonBlockingSteps.Rollback;
        default:
            return ReleaseTypesForNonBlockingSteps.Standard;
    }
};

export const getReleaseTypeFromReleaseTypeForNonBlockingSteps: (
    releaseType: ReleaseTypesForNonBlockingSteps,
) => ReleaseType = (releaseType: ReleaseTypesForNonBlockingSteps) => {
    switch (releaseType) {
        case ReleaseTypesForNonBlockingSteps.Hotfix:
            return ReleaseType.Hotfix;
        case ReleaseTypesForNonBlockingSteps.Rollback:
            return ReleaseType.Rollback;
        default:
            return ReleaseType.Minor;
    }
};

export const tokensDisplayableString: (tokens: PatternToken[]) => string = (tokens: PatternToken[]) => {
    let str = '';

    for (const token of tokens) {
        if (str != '') {
            str += ', ';
        }
        str += `'` + token + `'`;
    }

    return str;
};

export const validatePattern: (
    pattern: string,
    patternTypeString: string,
    requireAtLeastOneOfTokens: PatternToken[],
    disallowedTokens: PatternToken[],
) => Promise<unknown> = (
    pattern: string,
    patternTypeString: string,
    requireAtLeastOneOfTokens: PatternToken[],
    disallowedTokens: PatternToken[],
) => {
    for (const token of disallowedTokens) {
        if (pattern.includes(token)) {
            return Promise.reject(
                patternTypeString +
                    ' pattern cannot contain the following tokens: ' +
                    tokensDisplayableString(disallowedTokens),
            );
        }
    }

    // check for malformed or invalid tokens
    let stripped = pattern;
    for (const token of AllPatternTokens) {
        stripped = stripped.replace(token, '');
    }
    for (const token of AllPatternTokens) {
        if (stripped.includes(token)) {
            return Promise.reject('Pattern contains duplicate token(s) ');
        }
    }
    if (stripped.includes('{') || stripped.includes('}')) {
        return Promise.reject('Incomplete or invalid token ');
    }

    if (requireAtLeastOneOfTokens.length == 0) {
        return Promise.resolve();
    }

    for (const token of requireAtLeastOneOfTokens) {
        if (pattern.includes(token)) {
            return Promise.resolve();
        }
    }

    return Promise.reject(
        patternTypeString +
            ' pattern must contain at least one of these tokens: ' +
            tokensDisplayableString(requireAtLeastOneOfTokens) +
            ' ',
    );
};

const INLINE_MENTION_TOKEN_REGEX = /@\{(user|group):[^|}]*\|[^}]*\}/g;

export const patternTokenSyntaxValidation = () => [
    {
        validator: async (_: unknown, value: string) => {
            if (!value) return;
            const stripped = value.replace(INLINE_MENTION_TOKEN_REGEX, '');
            const tokensInText = (stripped.match(/\{[^\s{}]+\}/g) ?? []).map((m) => m.slice(1, -1));
            const invalidTokens = tokensInText.filter(
                (t: string) => !AllPatternTokens.includes(`{${t}}` as PatternToken),
            );
            if (invalidTokens.length) {
                const label = invalidTokens.length > 1 ? 'patterns' : 'pattern';
                throw new Error(`Invalid ${label}: ${invalidTokens.map((t) => `{${t}}`).join(', ')}`);
            }
        },
    },
    {
        warningOnly: true,
        validator: async (_: unknown, value: string) => {
            if (!value) return;
            const stripped = value.replace(INLINE_MENTION_TOKEN_REGEX, '');
            let depth = 0;
            let hasIssue = false;
            for (const char of stripped) {
                if (char === '{') depth++;
                if (char === '}') depth--;
                if (depth > 1 || depth < 0) {
                    hasIssue = true;
                    break;
                }
            }
            if (hasIssue || depth !== 0) {
                throw new Error(
                    "You may have an invalid pattern token: check your braces for an unclosed or nested '{' or '}'",
                );
            }
        },
    },
];

export const appleAppIsReleased: (state: AppleAppStoreState) => boolean = (state: AppleAppStoreState) => {
    let isReleased: boolean;
    switch (state) {
        case AppleAppStoreState.ReadyForSale:
        case AppleAppStoreState.PreorderReadyForSale:
        case AppleAppStoreState.ReplacedWithNewVersion:
        case AppleAppStoreState.RemovedFromSale:
        case AppleAppStoreState.DeveloperRemovedFromSale:
            isReleased = true;
            break;
        default:
            isReleased = false;
    }

    return isReleased;
};

export const appleAppIsReadyToRelease: (state: AppleAppStoreState) => boolean = (state: AppleAppStoreState) => {
    return state === AppleAppStoreState.PendingDeveloperRelease;
};

export const isPhasedRelease: (
    platform: AppPlatform,
    appleAppStoreData?: AppleAppStoreData,
    googleAppStoreData?: GooglePlayStoreData,
) => boolean = (platform, appleAppStoreData, googleAppStoreData) => {
    switch (platform) {
        case AppPlatform.TvOS:
        case AppPlatform.Ios:
        case AppPlatform.VisionOS:
            return appleAppStoreData ? !!appleAppStoreData.phasedRelease : false;
        case AppPlatform.WearOS:
        case AppPlatform.Android:
            return googleAppStoreData ? !!googleAppStoreData.phasedRelease : false;
        default:
            return false;
    }
};

export const isPhasedReleasePausedByRunway: (appStoreType: AppStoreType, phasedRelease?: PhasedRelease) => boolean = (
    appStoreType,
    phasedRelease,
) => {
    switch (appStoreType) {
        case AppStoreType.Apple: {
            const isPaused = phasedRelease?.state === AppleAppStorePhasedReleaseState.Paused;
            return phasedRelease ? isPaused && phasedRelease.isRunwayPaused : false;
        }
        case AppStoreType.Google: {
            const isPaused = phasedRelease?.state === GooglePlayStoreState.Halted;
            return phasedRelease ? isPaused && phasedRelease.isRunwayPaused : false;
        }
        default:
            return false;
    }
};

export const isPhasedReleaseAcceleratedByRunway: (phasedRelease?: PhasedRelease) => boolean = (phasedRelease) => {
    const phasedReleaseComplete = isPhasedReleaseComplete(phasedRelease);

    return phasedRelease ? phasedReleaseComplete && phasedRelease.isRunwayAcceleratedRollout : false;
};

export const isPhasedReleaseComplete = (phasedRelease?: PhasedRelease): boolean => {
    return isPhasedReleaseStateOrPercentageComplete(phasedRelease?.state, phasedRelease?.userFraction);
};

export const isPhasedReleaseSuperseded = (phasedRelease?: PhasedRelease): boolean => {
    return !!phasedRelease?.isSuperseded;
};

const isPhasedReleaseStateOrPercentageComplete = (
    state: PhasedReleaseState | undefined,
    percentage: number | undefined,
): boolean => {
    switch (state) {
        case AppleAppStorePhasedReleaseState.Complete:
        case GooglePlayStoreState.Completed:
            return true;
        case HuaweiPhasedReleaseState.Released:
            return (percentage ?? 0) >= 1;
        default:
            return false;
    }
};

export const isPhasedReleasePaused: (state: PhasedReleaseState) => boolean = (state) => {
    switch (state) {
        case HuaweiPhasedReleaseState.Suspended:
        case AppleAppStorePhasedReleaseState.Paused:
        case GooglePlayStoreState.Halted:
            return true;
        default:
            return false;
    }
};

export const googleAppIsReleased: (state: GooglePlayStoreState) => boolean = (state: GooglePlayStoreState) => {
    switch (state) {
        case GooglePlayStoreState.Completed:
        case GooglePlayStoreState.Halted:
        case GooglePlayStoreState.InProgress:
            return true;
        default:
            return false;
    }
};

export const huaweiAppIsSubmitted: (state: HuaweiAppStoreState) => boolean = (state: HuaweiAppStoreState) => {
    return state === HuaweiAppStoreState.Reviewing || huaweiAppIsReleased(state);
};

export const samsungAppIsSubmitted: (state: SamsungAppStoreState) => boolean = (state: SamsungAppStoreState) => {
    switch (state) {
        case SamsungAppStoreState.Registering:
        case SamsungAppStoreState.ReadyToPreExamination:
        case SamsungAppStoreState.Canceled:
            return false;
        default:
            return true;
    }
};

export const amazonAppIsSubmitted: (state: AmazonAppStoreState) => boolean = (state: AmazonAppStoreState) => {
    switch (state) {
        case AmazonAppStoreState.Submitted:
        case AmazonAppStoreState.Review:
        case AmazonAppStoreState.Live:
        case AmazonAppStoreState.Completed:
            return true;
        default:
            return false;
    }
};

export const huaweiAppIsReleased: (state: HuaweiAppStoreState) => boolean = (state: HuaweiAppStoreState) => {
    return state === HuaweiAppStoreState.Released;
};

export const samsungAppIsReleased: (state: SamsungAppStoreState) => boolean = (state: SamsungAppStoreState) => {
    return state === SamsungAppStoreState.ForSale;
};

export const amazonAppIsReleased: (state: AmazonAppStoreState) => boolean = (state: AmazonAppStoreState) => {
    return state === AmazonAppStoreState.Completed || state === AmazonAppStoreState.Live;
};

export const appleAppIsSubmitted: (
    state: AppleAppStoreState,
    reviewSubmissionState?: AppStoreReviewSubmissionState,
) => boolean = (state: AppleAppStoreState, reviewSubmissionState?: AppStoreReviewSubmissionState) => {
    switch (state) {
        case AppleAppStoreState.PrepareForSubmission:
        case AppleAppStoreState.ReadyForReview:
        case AppleAppStoreState.InvalidBinary:
        case AppleAppStoreState.DeveloperRejected:
        case AppleAppStoreState.MetadataRejected:
            return false;
        case AppleAppStoreState.Rejected:
            return reviewSubmissionState === AppStoreReviewSubmissionState.UnresolvedIssues;
        default:
            return true;
    }
};

export const appleAppCanBeDeveloperRejected: (state: AppleAppStoreState) => boolean = (state: AppleAppStoreState) => {
    // see: https://help.apple.com/app-store-connect/#/dev04f55d711
    return (
        state === AppleAppStoreState.WaitingForReview ||
        state === AppleAppStoreState.WaitingForExportCompliance ||
        state === AppleAppStoreState.InReview ||
        state === AppleAppStoreState.PendingDeveloperRelease ||
        state === AppleAppStoreState.PendingAppleRelease ||
        state === AppleAppStoreState.Rejected ||
        state === AppleAppStoreState.Accepted
    );
};

export const isAppReleased: (
    appStoreType: AppStoreType,
    appleReleaseState?: AppleAppStoreState,
    googleReleaseState?: GooglePlayStoreState,
    amazonReleaseState?: AmazonAppStoreState,
    huaweiReleaseState?: HuaweiAppStoreState,
    samsungReleaseState?: SamsungAppStoreState,
) => boolean = (
    appStoreType: AppStoreType,
    appleReleaseState?: AppleAppStoreState,
    googleReleaseState?: GooglePlayStoreState,
    amazonReleaseState?: AmazonAppStoreState,
    huaweiReleaseState?: HuaweiAppStoreState,
    samsungReleaseState?: SamsungAppStoreState,
) => {
    switch (appStoreType) {
        case AppStoreType.Apple:
            return appleReleaseState ? appleAppIsReleased(appleReleaseState) : false;
        case AppStoreType.Google:
            return googleReleaseState ? googleAppIsReleased(googleReleaseState) : false;
        case AppStoreType.Huawei:
            // HuaweiAppStoreState enum is backed by int, and 0 is a valid state. Need to explicitly compare to null|undefined
            return huaweiReleaseState !== null && huaweiReleaseState !== undefined ?
                    huaweiAppIsReleased(huaweiReleaseState)
                :   false;
        case AppStoreType.Amazon:
            return amazonReleaseState ? amazonAppIsReleased(amazonReleaseState) : false;
        case AppStoreType.Samsung:
            return samsungReleaseState ? samsungAppIsReleased(samsungReleaseState) : false;
        default:
            return false;
    }
};

export const isAppSubmitted: (
    appStoreType: AppStoreType,
    appleReleaseState?: AppleAppStoreState,
    reviewSubmissionState?: AppStoreReviewSubmissionState,
    googleReleaseState?: GooglePlayStoreState,
    amazonReleaseState?: AmazonAppStoreState,
    huaweiReleaseState?: HuaweiAppStoreState,
    samsungReleaseState?: SamsungAppStoreState,
) => boolean = (
    appStoreType,
    appleReleaseState,
    reviewSubmissionState,
    googleReleaseState,
    amazonReleaseState,
    huaweiReleaseState,
    samsungReleaseState,
) => {
    switch (appStoreType) {
        case AppStoreType.Apple:
            return appleReleaseState ? appleAppIsSubmitted(appleReleaseState, reviewSubmissionState) : false;
        case AppStoreType.Google:
            return googleReleaseState ? googleAppIsReleased(googleReleaseState) : false; // we don't know when a gplay app has been submitted for review, only when it's actively rolling out and can assume it's been submitted and approved
        case AppStoreType.Amazon:
            return amazonReleaseState ? amazonAppIsSubmitted(amazonReleaseState) : false;
        case AppStoreType.Huawei:
            // HuaweiAppStoreState enum is backed by int, and 0 is a valid state. Need to explicitly compare to null|undefined
            return huaweiReleaseState !== null && huaweiReleaseState !== undefined ?
                    huaweiAppIsSubmitted(huaweiReleaseState)
                :   false;
        case AppStoreType.Samsung:
            return samsungReleaseState ? samsungAppIsSubmitted(samsungReleaseState) : false;
        default:
            return false;
    }
};

// Approved and ready to be released, or already released

export const appleAppIsApprovedOrReleased: (state: AppleAppStoreState) => boolean = (state: AppleAppStoreState) => {
    switch (state) {
        case AppleAppStoreState.ReadyForSale:
        case AppleAppStoreState.PreorderReadyForSale:
        case AppleAppStoreState.PendingContract:
        case AppleAppStoreState.ProcessingForAppStore:
        case AppleAppStoreState.PendingAppleRelease:
        case AppleAppStoreState.PendingDeveloperRelease:
        case AppleAppStoreState.ReplacedWithNewVersion:
        case AppleAppStoreState.RemovedFromSale:
        case AppleAppStoreState.DeveloperRemovedFromSale:
            return true;
        default:
            return false;
    }
};

export const sharedIntegrationExistsForIntegration: (
    integrationType: IntegrationType,
    allInstalledIntegrations: IntegrationType[],
) => boolean = (integrationType, allInstalledIntegrations) => {
    return allInstalledIntegrations.some((installedIntegrationType) =>
        sisterIntegrationsForIntegrationType(integrationType).includes(installedIntegrationType),
    );
};

export const sisterIntegrationsForIntegrationType: (integrationType: IntegrationType) => IntegrationType[] = (
    integrationType: IntegrationType,
) => {
    switch (integrationType) {
        case IntegrationType.GitLabVCS:
            return [IntegrationType.GitLabCI];
        case IntegrationType.GitLabCI:
            return [IntegrationType.GitLabVCS];
        default:
            return [];
    }
};

export const isHalfFilledStep = (stepStatusData: StepRunStatusData): boolean => {
    let isHalfFilledStep = false;
    if (stepStatusData.type === ReleaseStepType.Takeoff) {
        isHalfFilledStep =
            stepStatusData.status !== ReleaseStepStatus.Inactive &&
            !!(
                stepStatusData.extraData?.isPhasedReleaseInProgress ||
                stepStatusData.extraData?.isPhasedReleaseSuperseded ||
                stepStatusData.extraData?.isPhasedReleasePaused
            ); // TODO-RUN-10901: handle null extraData pre-TUI if possible, nice-to-have though
    }

    if (stepStatusData.type === ReleaseStepType.Rollout) {
        isHalfFilledStep =
            stepStatusData.status !== ReleaseStepStatus.Inactive &&
            !!stepStatusData.extraData?.phasedReleaseState &&
            !isPhasedReleaseStateOrPercentageComplete(
                stepStatusData.extraData.phasedReleaseState,
                stepStatusData.extraData.phasedReleasePercentage,
            );
    }

    return isHalfFilledStep;
};

export const isStepHaltedByRunway = (stepStatusData: StepRunStatusData): boolean => {
    if (stepStatusData.type === ReleaseStepType.Rollout) {
        return (
            (stepStatusData as RolloutStepRunStatusData).extraData?.status === OverviewDestinationStatus.RolloutHalted
        );
    }
    return false;
};

export const isStepHalted = (stepStatusData: StepRunStatusData): boolean => {
    if (stepStatusData.type === ReleaseStepType.Rollout) {
        return (
            (stepStatusData as RolloutStepRunStatusData).extraData?.status === OverviewDestinationStatus.RolloutHalted
        );
    }
    if (stepStatusData.type === ReleaseStepType.Takeoff) {
        return !!stepStatusData.extraData?.isPhasedReleasePaused;
    }
    return false;
};

export const isHalfFilledStepForReleaseStep: (
    step: ReleaseStep,
    appStoreType: AppStoreType,
    phasedRelease?: PhasedRelease,
) => boolean = (step, appStoreType, phasedRelease) => {
    let isHalfFilledStep = false;
    if (step.type === ReleaseStepType.Takeoff) {
        const takeoffStep = step as ReleaseStepTakeoff;
        const appleAppStoreData = takeoffStep.data.appStoreData as AppleAppStoreData;
        const googlePlayStoreData = takeoffStep.data.appStoreData as GooglePlayStoreData;
        const amazonStoreData = takeoffStep.data.appStoreData as AmazonAppStoreData;
        const huaweiStoreData = takeoffStep.data.appStoreData as HuaweiAppStoreData;
        const samsungStoreData = takeoffStep.data.appStoreData as SamsungAppStoreData;

        const isPhased = !!phasedRelease;
        const phasedReleaseComplete = isPhasedReleaseComplete(phasedRelease);

        const isReleased = isAppReleased(
            appStoreType,
            appleAppStoreData?.versionReviewSubmissionItem?.state,
            googlePlayStoreData?.state,
            amazonStoreData?.state,
            huaweiStoreData?.state,
            samsungStoreData?.state,
        );

        isHalfFilledStep =
            step.status !== ReleaseStepStatus.Inactive && isReleased && isPhased && !phasedReleaseComplete;
    }

    return isHalfFilledStep;
};

export const isInnerFilledStepForReleaseStep: (releaseStep: ReleaseStep) => boolean = (releaseStep) => {
    switch (releaseStep.type) {
        case ReleaseStepType.Takeoff:
        case ReleaseStepType.VCSDistribution:
        case ReleaseStepType.CIDistribution:
            if (releaseStep.data.tagData) {
                if (
                    releaseStep.data.tagData.releaseTagState === ReleaseTagState.TagNeeded ||
                    releaseStep.data.tagData.releaseTagState === ReleaseTagState.TagNeededNameUnresolved
                ) {
                    // unable to tag, tag needed
                    return true;
                }
            }

            return false;
        default:
            return false;
    }
};

export const isInnerFilledStep: (stepStatusData: StepRunStatusData) => boolean = (stepStatusData) => {
    switch (stepStatusData.type) {
        case ReleaseStepType.Takeoff:
        case ReleaseStepType.VCSDistribution:
        case ReleaseStepType.CIDistribution:
            if (stepStatusData.extraData && stepStatusData.extraData.releaseTagState) {
                if (
                    stepStatusData.extraData.releaseTagState === ReleaseTagState.TagNeeded ||
                    stepStatusData.extraData.releaseTagState === ReleaseTagState.TagNeededNameUnresolved
                ) {
                    // unable to tag, tag needed
                    return true;
                }
            }

            return false;
        default:
            return false;
    }
};

export const getIsApplePlatform: (platform: AppPlatform) => boolean = (platform: AppPlatform) => {
    return platform === AppPlatform.Ios || platform === AppPlatform.TvOS || platform === AppPlatform.VisionOS;
};

export const isGooglePlatform: (platform: AppPlatform) => boolean = (platform: AppPlatform) => {
    return platform === AppPlatform.Android || platform === AppPlatform.WearOS || platform === AppPlatform.AndroidTV;
};

export const getIsOTAPlatform: (platform: AppPlatform) => boolean = (platform: AppPlatform) => {
    return platform === AppPlatform.ReactNativeOTA;
};

export const isIosPlatform: (platform: AppPlatform) => boolean = (platform: AppPlatform) => {
    return platform === AppPlatform.Ios;
};

export const isAndroidPlatform: (platform: AppPlatform) => boolean = (platform: AppPlatform) => {
    return platform === AppPlatform.Android;
};

export const getIsAppleAppStore: (store: AppStoreType) => boolean = (store: AppStoreType) => {
    return store === AppStoreType.Apple;
};

export const getIsGooglePlayStore: (store: AppStoreType) => boolean = (store: AppStoreType) => {
    return store === AppStoreType.Google;
};

export const getIsAmazonAppStore: (store: AppStoreType) => boolean = (store: AppStoreType) => {
    return store === AppStoreType.Amazon;
};

export const getIsHuaweiAppGallery: (store: AppStoreType) => boolean = (store: AppStoreType) => {
    return store === AppStoreType.Huawei;
};

export const getIsSamsungGalaxyStore: (store: AppStoreType) => boolean = (store: AppStoreType) => {
    return store === AppStoreType.Samsung;
};

export const getMetadataReleaseNotesMaxLength = (appStoreType: AppStoreType): number => {
    switch (appStoreType) {
        case AppStoreType.Apple:
        case AppStoreType.Samsung:
        case AppStoreType.Amazon:
            return 4000;
        default:
            return 500;
    }
};

export const getMetadataShortDescriptionMaxLength = (appStoreType: AppStoreType): number => {
    switch (appStoreType) {
        case AppStoreType.Apple:
            return 100;
        case AppStoreType.Samsung:
            return 240;
        case AppStoreType.Amazon:
            return 1200;
        default:
            return 80;
    }
};

export const getMetadataAppNameMaxLength = (appStoreType: AppStoreType): number => {
    switch (appStoreType) {
        case AppStoreType.Samsung:
            return 150;
        case AppStoreType.Amazon:
            return 200;
        default:
            return 30;
    }
};

export const getMetadataDescriptionMaxLength = (appStoreType: AppStoreType): number => {
    switch (appStoreType) {
        case AppStoreType.Samsung:
            return 12000;
        default:
            return 4000;
    }
};

export const hasSupportForPhasedRelease: (store: AppStoreType) => boolean = (store: AppStoreType) => {
    return [AppStoreType.Apple, AppStoreType.Google, AppStoreType.Huawei].includes(store);
};

export const hasSupportForAutoRelease: (store: AppStoreType) => boolean = (store: AppStoreType) => {
    return store === AppStoreType.Apple;
};

export const getIntegrationTypeForAppStoreType: (store: AppStoreType) => IntegrationType | null = (
    store: AppStoreType,
) => {
    switch (store) {
        case AppStoreType.Apple:
            return IntegrationType.Apple;
        case AppStoreType.Google:
            return IntegrationType.Google;
        case AppStoreType.Amazon:
            return IntegrationType.Amazon;
        case AppStoreType.Huawei:
            return IntegrationType.HuaweiAppGallery;
        case AppStoreType.Samsung:
            return IntegrationType.Samsung;
        default:
            return null;
    }
};

export const isAppPlatform: (platform: AppPlatform) => boolean = (platform: AppPlatform) => {
    switch (platform) {
        case AppPlatform.TvOS:
        case AppPlatform.WearOS:
        case AppPlatform.Android:
        case AppPlatform.AndroidTV:
        case AppPlatform.Ios:
        case AppPlatform.VisionOS:
            return true;
        default:
            return false;
    }
};

export const displayAppStoreBuildType: (type: AppStoreBuildType) => string = (type) => {
    switch (type) {
        case AppStoreBuildType.IosBinary:
            return 'binary';
        case AppStoreBuildType.AndroidAAB:
            return '.aab';
        case AppStoreBuildType.AndroidAPK:
            return '.apk';
    }
};

export const defaultBuildFileTypesByAppStoreType: (appStoreType: AppStoreType) => string[] = (appStoreType) => {
    const isAppleAppStore = getIsAppleAppStore(appStoreType);
    return isAppleAppStore ? ['.ipa'] : ['.apk'];
};

export const supportedBuildFileTypesByAppStoreType: (appStoreType: AppStoreType) => string[] = (appStoreType) => {
    const isAppleAppStore = getIsAppleAppStore(appStoreType);
    return isAppleAppStore ? ['.ipa'] : ['.apk', '.aab'];
};

export const appStoreSupportsRollbacks: (appStoreType: AppStoreType) => boolean = (appStoreType) => {
    return appStoreType !== AppStoreType.Huawei && appStoreType !== AppStoreType.Samsung;
};

export const extractSubdomainFromHostname = (hostname: string) => {
    const parts = hostname.split('.');

    if (parts && parts.length > 0) {
        return parts[0];
    }

    return null;
};

export const openLinkInNewTab: (url: string) => void = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) {
        newWindow.opener = null;
    }
};

export const getTestingTrackFromAutoPromoteBuildToTestTrackAutomationWithState = (
    state: RootState,
    appId: string,
): string => {
    const appSettings = selectApp(state, appId).appSettings;
    const automationData = appSettings.automations.find(
        (automation) => automation.type === AutomationType.AutoPromoteBuildsToTestTrack,
    )?.data as AutomationPromoteBuildsToTestTrackData;

    return automationData?.testingTrack ?? '';
};

export const getURLforASCBetaBuild = (appId: number, buildId: string): string => {
    return `https://appstoreconnect.apple.com/apps/${appId}/testflight/ios/${buildId}`;
};

export const canSubmitBuildForBetaReview = (status: AppleExternalBetaBuildState) => {
    return status == AppleExternalBetaBuildState.ReadyForBetaSubmission;
};

export const isExternalBuildBetaTesting = (status: AppleExternalBetaBuildState) => {
    return status === AppleExternalBetaBuildState.InBetaTesting;
};

export const isInternalBuildBetaTesting = (status: AppleInternalBetaBuildState) => {
    return status === AppleInternalBetaBuildState.InBetaTesting;
};

export const isTestFlightBetaIntegration: (integrationType: IntegrationType) => boolean = (integrationType) => {
    return integrationType === IntegrationType.TestFlight;
};

export const isGoogleBetaIntegration: (integrationType: IntegrationType) => boolean = (integrationType) => {
    return integrationType === IntegrationType.GoogleBeta;
};

export const isAppCenterBetaIntegration: (integrationType: IntegrationType) => boolean = (integrationType) => {
    return integrationType === IntegrationType.AppCenterBeta;
};

export const isRunwayBuildDistroBetaIntegration: (integrationType: IntegrationType) => boolean = (integrationType) => {
    return integrationType === IntegrationType.RunwayBuildDistroBeta;
};

export const isFirebaseBetaIntegration: (integrationType: IntegrationType) => boolean = (integrationType) => {
    return integrationType === IntegrationType.FirebaseBeta;
};

const googleServiceAccountJsonIntegrationTypes = new Set<IntegrationType>([
    IntegrationType.Google,
    IntegrationType.GoogleBeta,
    IntegrationType.Firebase,
    IntegrationType.FirebaseBeta,
    IntegrationType.GoogleAnalytics,
    IntegrationType.GoogleCalendar,
    IntegrationType.AndroidVitals,
]);

export const integrationTypeRequiresGoogleServiceAccountJson = (integrationType: IntegrationType): boolean => {
    return googleServiceAccountJsonIntegrationTypes.has(integrationType);
};

export const validateGoogleServiceAccountJsonFile = async (file: File): Promise<string | null> => {
    let contents: string;
    try {
        contents = await file.text();
    } catch {
        return 'Unable to read uploaded file. Please try again.';
    }

    const trimmed = contents.trim();
    if (!trimmed) {
        return 'Uploaded file is empty.';
    }

    let parsed: Record<string, unknown>;
    try {
        parsed = JSON.parse(trimmed) as Record<string, unknown>;
    } catch {
        return 'Uploaded file is not valid JSON. Please upload the JSON key file downloaded from the Google Play Console.';
    }

    if (parsed.type !== 'service_account') {
        return 'Invalid service account key: expected a Google service account JSON key file.';
    }
    if (typeof parsed.client_email !== 'string' || !parsed.client_email) {
        return 'Invalid service account key: missing client_email field.';
    }
    if (typeof parsed.private_key !== 'string' || !parsed.private_key) {
        return 'Invalid service account key: missing private_key field.';
    }

    return null;
};

export const uploadFileTypeForIntegrationType: (integrationType: IntegrationType) => string = (integrationType) => {
    switch (integrationType) {
        case IntegrationType.Apple:
        case IntegrationType.TestFlight:
            return '.p8';
        case IntegrationType.Google:
        case IntegrationType.GoogleBeta:
        case IntegrationType.Firebase:
        case IntegrationType.FirebaseBeta:
        case IntegrationType.GoogleAnalytics:
        case IntegrationType.GoogleCalendar:
        case IntegrationType.AndroidVitals:
            return '.json';
        default:
            return '';
    }
};

export const userIsRunwayAdmin: (user: User) => boolean = (user) => {
    return user.permissions.includes(UserPermissions.RunwayAdmin);
};

export const userIsRunwayAdminReadOnly: (user: User) => boolean = (user) => {
    return user.permissions.includes(UserPermissions.RunwayAdminReadOnly);
};

export const userIsAdmin: (user: User) => boolean = (user) => {
    return user.permissions.includes(UserPermissions.Admin);
};

export const shouldShowLastUploadedBuilds: (
    appStoreSelectedBuilds: AppStoreAvailableBuild[],
    appStoreType: AppStoreType,
) => boolean = (appStoreSelectedBuilds, appStoreType) => {
    if (getIsHuaweiAppGallery(appStoreType)) {
        return appStoreSelectedBuilds.length == 0;
    }
    return false;
};

export const automationIsEnabledAndActiveAndScheduled: (automation: AutomationRun) => boolean = (automation) => {
    const pendingStatuses = [AutomationStatus.Active, AutomationStatus.Pending];

    return pendingStatuses.includes(automation.status) && automation.scheduledAt !== null;
};

export const automationIsCompleted: (automation: AutomationRun) => boolean = (automation) => {
    return automation.status === AutomationStatus.Success;
};

export const automationIsInactive: (automation: AutomationRun) => boolean = (automation) => {
    return automation.status === AutomationStatus.Inactive;
};

export const automationIsActive: (automation: AutomationRun) => boolean = (automation) => {
    return automation.status === AutomationStatus.Active;
};

export const automationIsPending: (automation: AutomationRun) => boolean = (automation) => {
    return automation.status === AutomationStatus.Pending;
};

export const automationIsFailed: (automation: AutomationRun) => boolean = (automation) => {
    return automation.status === AutomationStatus.Failed;
};

export const automationIsBlocked: (automation: AutomationRun) => boolean = (automation) => {
    return automation.status === AutomationStatus.Blocked;
};

export const getAutomationRunByType: (
    automations: AutomationRun[],
    type: AutomationType,
) => AutomationRun | undefined = (automations, type) => {
    return automations.find((automation) => automation.type === type);
};

export const getAutomationIdByType: (automations: AutomationRun[], type: AutomationType) => string | undefined = (
    automations,
    type,
) => {
    const automation = getAutomationRunByType(automations, type);
    return automation?.id;
};

export const getRolloutDaysToPercentageFromAutomation = (
    automation: Nullable<AutomationAutoStagedRollout>,
): number[] | undefined => {
    if ((automation?.data?.daysToPercent?.length ?? 0) > 0) {
        return automation!.data!.daysToPercent;
    }
    return undefined;
};

// Stopgap, to deprecate after WFs migration of rollouts step; delete once deprecated
export const tryDeterminePhasedReleaseDaysToPercentageSchedule = (
    havePhasedReleaseData: boolean,
    appStoreType: AppStoreType,
    maybeRolloutAutomation: Nullable<AutomationAutoStagedRollout>,
): Nullable<number[]> => {
    const maybeAutoDaysToPercent = getRolloutDaysToPercentageFromAutomation(maybeRolloutAutomation);
    const haveAutoDaysToPercent = (maybeAutoDaysToPercent?.length ?? 0) > 0;
    const isAppleAppStore = getIsAppleAppStore(appStoreType);

    return (
        haveAutoDaysToPercent ? maybeAutoDaysToPercent
        : havePhasedReleaseData && isAppleAppStore ? [1, 2, 5, 10, 20, 50, 100]
        : null
    );
};

export const getDayPairsFromDaysToPercent = (daysToPercent: number[]): [number, number][] => {
    return daysToPercent.map((percent, index) => [index + 1, percent] as [number, number]);
};

export const automationNotInactiveOrSkipped: (automation: AutomationRun) => boolean = (automation) => {
    const statuses = [
        AutomationStatus.Pending,
        AutomationStatus.Incomplete,
        AutomationStatus.Failed,
        AutomationStatus.Active,
        AutomationStatus.Paused,
        AutomationStatus.Success,
        AutomationStatus.Blocked,
    ];

    return statuses.includes(automation.status);
};

export const platformDifferentiatedAppId: (appId: string, platform: AppPlatform) => string = (appId, platform) => {
    return appId + '-' + platform;
};

export const isStepChecklistPlacement: (placement: ChecklistItemPlacement) => boolean = (placement) => {
    return placement === ChecklistItemPlacement.StepChecklist;
};

export const isCompleteChecklistItemStatus: (status: ChecklistItemStatusType) => boolean = (status) => {
    return [ChecklistItemStatusType.Approved, ChecklistItemStatusType.Passed].includes(status);
};

export const colorForChecklistItemStatus: (status?: ChecklistItemStatusType) => string = (status) => {
    switch (status) {
        case ChecklistItemStatusType.Passed:
        case ChecklistItemStatusType.Approved:
            return runwayColors.statusGreen;
        case ChecklistItemStatusType.Blocked:
        case ChecklistItemStatusType.Rejected:
        case ChecklistItemStatusType.Failed:
            return runwayColors.statusRed;
        case ChecklistItemStatusType.InProgress:
            return runwayColors.statusYellow;
        default:
            return antGrey.grey5;
    }
};

export const checklistItemTypeForPlacement: (placement: ChecklistItemPlacement) => ChecklistItemType = (placement) => {
    switch (placement) {
        case ChecklistItemPlacement.Approvals:
        case ChecklistItemPlacement.RegressionTesting:
            return ChecklistItemType.Multi;
        case ChecklistItemPlacement.StepChecklist:
            return ChecklistItemType.Binary;
    }
};

export const displayTextForThirdPartyAuthError: (error: ThirdPartyAuthError) => string = (error) => {
    switch (error) {
        case ThirdPartyAuthError.SsoEnabled:
            return 'SSO is enabled for your organization. Please sign in or create an account via SSO.';
        case ThirdPartyAuthError.Unauthorized:
            return 'Authentication failed.';
        case ThirdPartyAuthError.MCPAccountRequired:
            return "MCP access requires an existing Runway account on Runway's Enterprise plan. Reach out to us at hello@runway.team if you're interested in a trial!";
        case ThirdPartyAuthError.General:
            return 'Something went wrong. Please try again.';
        default:
            return 'Something went wrong. Please try again.';
    }
};

export function hubSpotUserToken(document: Document): string {
    return document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, '$1');
}

export const requiredCapabilitiesForPlatform: (platform: AppPlatform) => IntegrationCapability[] = (platform) => {
    const baseAppCapabilities = [
        IntegrationCapability.VersionControl,
        // IntegrationCapability.FeatureManagement,
        IntegrationCapability.BuildSystem,
        IntegrationCapability.AppStore,
        // IntegrationCapability.Notifications,
    ];
    switch (platform) {
        case AppPlatform.TvOS:
        case AppPlatform.WearOS:
        case AppPlatform.Android:
        case AppPlatform.Ios:
        case AppPlatform.VisionOS:
        case AppPlatform.AndroidSDK:
        case AppPlatform.IosSDK:
        case AppPlatform.AndroidTV:
            return baseAppCapabilities;
        case AppPlatform.ReactNativeOTA:
            return [
                IntegrationCapability.VersionControl,
                // IntegrationCapability.FeatureManagement,
                IntegrationCapability.BuildSystem,
                // IntegrationCapability.Notifications,
            ];
        default:
            return baseAppCapabilities;
    }
};

export const allSupportedIntegrationTypesForCapability = (
    capability: IntegrationCapability,
    isRunwayOrg: boolean,
    orgId: string,
    includeComingSoonIntegrations = false,
): IntegrationType[] => {
    let supportedIntegrations: IntegrationType[] = [];
    const comingSoonIntegrations = comingSoonIntegrationsForCapability(capability, isRunwayOrg, orgId);
    switch (capability) {
        case IntegrationCapability.AppStore:
            supportedIntegrations = [
                IntegrationType.Apple,
                IntegrationType.Google,
                IntegrationType.Amazon,
                IntegrationType.HuaweiAppGallery,
                IntegrationType.Samsung,
            ];
            break;
        case IntegrationCapability.FeatureManagement: {
            const issueTrackingIntegrations = [
                IntegrationType.Asana,
                IntegrationType.AzureIT,
                IntegrationType.GitHubIT,
                IntegrationType.Jira,
                IntegrationType.Linear,
                IntegrationType.Pivotal,
                IntegrationType.Shortcut,
                IntegrationType.Monday,
            ];

            supportedIntegrations = issueTrackingIntegrations;

            break;
        }
        case IntegrationCapability.VersionControl:
            supportedIntegrations = [
                IntegrationType.Bitbucket,
                IntegrationType.GitHubVCS,
                IntegrationType.GitLabVCS,
                IntegrationType.AzureVCS,
            ];

            break;
        case IntegrationCapability.BetaTesting:
            supportedIntegrations = [
                IntegrationType.TestFlight,
                IntegrationType.GoogleBeta,
                IntegrationType.FirebaseBeta,
                IntegrationType.RunwayBuildDistroBeta,
            ];
            break;
        case IntegrationCapability.BuildSystem:
            supportedIntegrations = [
                IntegrationType.AppCenterCI,
                IntegrationType.AzureCI,
                IntegrationType.Codemagic,
                IntegrationType.BitbucketCI,
                IntegrationType.Bitrise,
                IntegrationType.Buildkite,
                IntegrationType.CircleCI,
                IntegrationType.GitHubCI,
                IntegrationType.GitLabCI,
                IntegrationType.Jenkins,
                IntegrationType.TravisCI,
                IntegrationType.XcodeCloud,
                IntegrationType.CustomCI,
                //IntegrationType.GenericCI, not user-facing for now
            ];
            break;
        case IntegrationCapability.SDKDistribution:
            supportedIntegrations = [IntegrationType.GitHubVCSDistribution];
            break;
        case IntegrationCapability.Notifications:
            supportedIntegrations = [IntegrationType.Slack, IntegrationType.MicrosoftTeams];
            break;
        case IntegrationCapability.StabilityMonitoring:
            supportedIntegrations = [
                IntegrationType.Bugsnag,
                IntegrationType.Firebase,
                IntegrationType.Sentry,
                IntegrationType.EmbraceStabilityMonitoring,
                IntegrationType.DatadogStabilityMonitoring,
                IntegrationType.NewRelicStabilityMonitoring,
                IntegrationType.DynatraceStabilityMonitoring,
            ];
            break;
        case IntegrationCapability.RegressionTesting:
            supportedIntegrations = [
                IntegrationType.Qase,
                IntegrationType.TestRail,
                IntegrationType.BrowserStack,
                IntegrationType.Xray,
            ];
            break;
        case IntegrationCapability.ObservabilityAndAnalytics:
            supportedIntegrations = [
                IntegrationType.Amplitude,
                IntegrationType.DatadogAnalytics,
                IntegrationType.MixpanelAnalytics,
                IntegrationType.GoogleAnalytics,
                IntegrationType.ApplePowerPerformanceMetrics,
                IntegrationType.AndroidVitals,
                IntegrationType.NewRelicAnalytics,
                IntegrationType.CustomAnalytics,
            ];
            break;
        case IntegrationCapability.FeatureFlagging:
            supportedIntegrations = [IntegrationType.Optimizely, IntegrationType.LaunchDarkly, IntegrationType.Statsig];
            break;
        case IntegrationCapability.Translations:
            supportedIntegrations = [IntegrationType.Crowdin, IntegrationType.Lokalise];
            break;
        case IntegrationCapability.Scheduling:
            supportedIntegrations = [
                IntegrationType.PagerDutyScheduling,
                IntegrationType.OpsgenieScheduling,
                IntegrationType.JiraServiceManagementScheduling,
                IntegrationType.RootlyScheduling,
                IntegrationType.IncidentIoScheduling,
            ];
            break;
        case IntegrationCapability.Calendar:
            supportedIntegrations = [IntegrationType.GoogleCalendar, IntegrationType.GooglePersonalCalendar];
            break;
    }

    if (includeComingSoonIntegrations) {
        return [...supportedIntegrations, ...comingSoonIntegrations];
    }

    return supportedIntegrations;
};

export const comingSoonIntegrationsForCapability = (
    capability: IntegrationCapability,
    _isRunwayOrg: boolean,
    _orgId: string,
): IntegrationType[] => {
    switch (capability) {
        case IntegrationCapability.AppStore:
            return [];
        case IntegrationCapability.FeatureManagement:
            return [];
        case IntegrationCapability.VersionControl:
            return [];
        case IntegrationCapability.BetaTesting:
            return [];
        case IntegrationCapability.BuildSystem:
            return [];
        case IntegrationCapability.SDKDistribution:
            return [];
        case IntegrationCapability.Notifications:
            return [];
        case IntegrationCapability.StabilityMonitoring:
            return [];
        case IntegrationCapability.RegressionTesting:
            return [];
        case IntegrationCapability.ObservabilityAndAnalytics:
            return [];
        case IntegrationCapability.FeatureFlagging:
            return [];
        case IntegrationCapability.Translations:
            return [IntegrationType.Smartling];
        case IntegrationCapability.Scheduling:
            return [];
        case IntegrationCapability.Calendar:
            return [];
    }
};

export const allComingSoonIntegrations = (isRunwayOrg: boolean, orgId: string): IntegrationType[] => {
    let allComingSoonIntegrations: IntegrationType[] = [];

    forEach(AllIntegrationCapabilities, (capability) => {
        const integrations = comingSoonIntegrationsForCapability(capability, isRunwayOrg, orgId);

        allComingSoonIntegrations = allComingSoonIntegrations.concat(integrations);
    });

    return allComingSoonIntegrations;
};

export const recommendedCapabilitiesForReleaseStepType = (
    releaseStepType: ReleaseStepType,
    onlyTheMinimumRequired = false,
): IntegrationCapability[] | null => {
    switch (releaseStepType) {
        case ReleaseStepType.Kickoff:
            return [IntegrationCapability.VersionControl];
        case ReleaseStepType.FeatureReadiness:
            if (onlyTheMinimumRequired) {
                return [IntegrationCapability.VersionControl];
            }
            return [IntegrationCapability.VersionControl, IntegrationCapability.FeatureManagement];
        case ReleaseStepType.BetaTesting:
            return [IntegrationCapability.BuildSystem];
        case ReleaseStepType.RegressionTesting:
            return [IntegrationCapability.BuildSystem];
        case ReleaseStepType.ReleaseCandidate:
            return [IntegrationCapability.BuildSystem];
        case ReleaseStepType.Metadata:
            return [IntegrationCapability.AppStore];
        case ReleaseStepType.Screenshots:
            return [IntegrationCapability.AppStore];
        case ReleaseStepType.Approvals:
            return [];
        case ReleaseStepType.Submission:
            return [IntegrationCapability.AppStore];
        case ReleaseStepType.StoreReview:
            return [IntegrationCapability.AppStore];
        case ReleaseStepType.Takeoff:
            return [IntegrationCapability.AppStore];
        case ReleaseStepType.VCSDistribution:
            return [IntegrationCapability.VersionControl];
        case ReleaseStepType.CIDistribution:
            return [IntegrationCapability.BuildSystem];
        case ReleaseStepType.Translations:
            return [IntegrationCapability.Translations, IntegrationCapability.VersionControl];
        default:
            return null;
    }
};

export const descriptionForCapability = (capability: IntegrationCapability) => {
    switch (capability) {
        case IntegrationCapability.AppStore:
            return 'Quickly see where your release stands in the app store.';
        case IntegrationCapability.FeatureManagement:
            return "Import tickets from your project management tool to see at-a-glance what's going into your releases.";
        case IntegrationCapability.VersionControl:
            return 'Automatically detect release branches, surface code-to-feature matches, and more.';
        case IntegrationCapability.BetaTesting:
            return 'Manage beta testing builds, testers, and testing groups.';
        case IntegrationCapability.BuildSystem:
            return "Keep up to date with the status of the latest CI builds as they're made available.";
        case IntegrationCapability.Notifications:
            return 'Send release activity notifications at the right time, to the right people.';
        case IntegrationCapability.SDKDistribution:
            return 'See the status of your publicly-available SDK.';
        case IntegrationCapability.StabilityMonitoring:
            return 'Monitor the stability and adoption of your release.';
        case IntegrationCapability.RegressionTesting:
            return 'Automatically pull in status and details from regression test runs.';
        case IntegrationCapability.ObservabilityAndAnalytics:
            return 'Monitor key events across releases.';
        case IntegrationCapability.FeatureFlagging:
            return 'View the status of relevant feature flags in a release.';
        case IntegrationCapability.Translations:
            return 'View the status of your translations.';
        case IntegrationCapability.Scheduling:
            return 'Sync your release pilot rotation to your external on-call schedule, and create incidents when issues arise.';
        case IntegrationCapability.Calendar:
            return "Sync release calendar events to and from your team's external calendars.";
    }
};

export const descriptionForCapabilityOnStep = (capability: IntegrationCapability, step: ReleaseStepType) => {
    switch (capability) {
        case IntegrationCapability.BuildSystem: {
            switch (step) {
                case ReleaseStepType.BetaTesting:
                    return 'Monitor beta testing progress as soon as CI builds are available.';
                default:
                    return descriptionForCapability(capability);
            }
        }
        default:
            return descriptionForCapability(capability);
    }
};

export const displayNameForCapability = (capability: IntegrationCapability) => {
    switch (capability) {
        case IntegrationCapability.AppStore:
            return 'App store';
        case IntegrationCapability.FeatureManagement:
            return 'Project management';
        case IntegrationCapability.VersionControl:
            return 'Version control';
        case IntegrationCapability.BetaTesting:
            return 'Beta testing';
        case IntegrationCapability.Notifications:
            return 'Notifications';
        case IntegrationCapability.BuildSystem:
            return 'CI/CD';
        case IntegrationCapability.SDKDistribution:
            return 'SDK distribution';
        case IntegrationCapability.StabilityMonitoring:
            return 'Stability monitoring';
        case IntegrationCapability.RegressionTesting:
            return 'Regression testing';
        case IntegrationCapability.ObservabilityAndAnalytics:
            return 'Observability & analytics';
        case IntegrationCapability.FeatureFlagging:
            return 'Feature flagging';
        case IntegrationCapability.Translations:
            return 'Translations';
        case IntegrationCapability.Scheduling:
            return 'Incident management & scheduling';
        case IntegrationCapability.Calendar:
            return 'Calendar';
    }
};

export const bannerDisplayNameForCapability = (capability: IntegrationCapability) => {
    switch (capability) {
        case IntegrationCapability.AppStore:
            return 'App Store';
        case IntegrationCapability.FeatureManagement:
            return 'Project Management';
        case IntegrationCapability.VersionControl:
            return 'Version Control';
        case IntegrationCapability.BetaTesting:
            return 'Beta Testing';
        case IntegrationCapability.Notifications:
            return 'Notifications';
        case IntegrationCapability.BuildSystem:
            return 'CI/CD';
        case IntegrationCapability.SDKDistribution:
            return 'SDK Distribution';
        case IntegrationCapability.StabilityMonitoring:
            return 'Stability Monitoring';
        case IntegrationCapability.RegressionTesting:
            return 'Regression Testing';
        case IntegrationCapability.ObservabilityAndAnalytics:
            return 'Observability & Analytics';
        case IntegrationCapability.FeatureFlagging:
            return 'Feature flagging';
        case IntegrationCapability.Translations:
            return 'Translations';
        case IntegrationCapability.Scheduling:
            return 'Incident Management & Scheduling';
        case IntegrationCapability.Calendar:
            return 'Calendar';
    }
};

export const displayTextForCapability = (capability: IntegrationCapability) => {
    switch (capability) {
        case IntegrationCapability.AppStore:
            return 'Connect to the App Store.';
        case IntegrationCapability.FeatureManagement:
            return 'Connect a project management tool.';
        case IntegrationCapability.VersionControl:
            return 'Connect your version control system.';
        case IntegrationCapability.BetaTesting:
            return 'Connect your beta testing solution.';
        case IntegrationCapability.Notifications:
            return 'Connect your notification provider.';
        case IntegrationCapability.BuildSystem:
            return 'Connect a CI provider.';
        case IntegrationCapability.SDKDistribution:
            return 'Connect a SDK distribution system.';
        case IntegrationCapability.StabilityMonitoring:
            return 'Connect a stability monitoring provider.';
        case IntegrationCapability.RegressionTesting:
            return 'Connect a regression testing provider.';
        case IntegrationCapability.ObservabilityAndAnalytics:
            return 'Connect an observability & analytics provider.';
        case IntegrationCapability.FeatureFlagging:
            return 'Connect a feature flagging provider.';
        case IntegrationCapability.Translations:
            return 'Connect a translations provider.';
        case IntegrationCapability.Scheduling:
            return 'Connect an incident management & scheduling provider.';
        case IntegrationCapability.Calendar:
            return 'Connect a calendar provider';
    }
};

export const appIsSDKPlatform: (platform: AppPlatform) => boolean = (platform) => {
    return [AppPlatform.AndroidSDK, AppPlatform.IosSDK].includes(platform);
};

const redactedCommsChannelString = '<private>';

export const commsChannelsValidatorFunction: (integration: IntegrationProviderType, values: any) => Promise<unknown> = (
    integration: IntegrationProviderType,
    values,
) => {
    if (values && values.length > 0 && integration === IntegrationProviderType.Slack) {
        const invalidValueFound = reduce(
            values,
            (invalidFound, value) => {
                if (invalidFound) {
                    return invalidFound;
                } else {
                    return value.match(/[^\w-#{}]/);
                }
            },
            false,
        );
        if (invalidValueFound) {
            const redactedValueFound = reduce(
                values,
                (redactedFound, value) => {
                    if (redactedFound) {
                        return redactedFound;
                    } else {
                        return value == redactedCommsChannelString;
                    }
                },
                false,
            );
            if (redactedValueFound) {
                return Promise.reject('You cannot update channels with a private channel you are not a member of.');
            }

            return Promise.reject(
                'Channel name cannot contain any special characters, with the exception of # and supported pattern token strings (e.g. {version}, {releaseName}) for release-specific channels.',
            );
        }

        for (const value of values) {
            if (value.includes('{') || value.includes('}')) {
                const tokenValidation = validatePattern(value, 'Channel name', [], CommsChannelDisallowedTokens);
                let isRejected = false;
                tokenValidation.catch(() => {
                    isRejected = true;
                });
                if (isRejected) {
                    return tokenValidation;
                }
            }
        }
    }

    return Promise.resolve();
};

export const testRunNamingKeywordsValidatorFunction: (values: any) => Promise<any> = (values) => {
    if (values && values.length > 0) {
        const invalidValueFound = reduce(
            values,
            (invalidFound, value) => {
                if (invalidFound) {
                    return invalidFound;
                } else {
                    return (
                        value.toLowerCase().includes(PatternToken.Version) ||
                        value.toLowerCase().includes(PatternToken.VersionConcise)
                    );
                }
            },
            false,
        );

        if (invalidValueFound) {
            return Promise.reject('Runway already matches on version string.');
        }
    }

    return Promise.resolve();
};

export const ticketCustomFieldsValidatorFunction: (values: any) => Promise<any> = (values) => {
    if (values && values.length > 0) {
        if (new Set(values).size !== values.length) {
            return Promise.reject('Duplicate fields');
        }
    }

    return Promise.resolve();
};

export const cherryPickPatternValidator: (value: string[]) => Promise<any> = (value) => {
    if (value?.length > 0) {
        for (const pattern of value) {
            const versionTokenCount = (pattern.match(/{version}/g) || []).length;
            const versionConciseTokenCount = (pattern.match(/{versionConcise}/g) || []).length;

            if (
                versionTokenCount > 1 ||
                versionConciseTokenCount > 1 ||
                (versionTokenCount === 1 && versionConciseTokenCount === 1)
            ) {
                return Promise.reject(
                    'Pattern must contain either a {version} token, a {versionConcise} token, or no tokens.',
                );
            }
        }

        return Promise.resolve();
    }

    return Promise.reject('Pattern must contain either a {version} token, a {versionConcise} token, or no tokens.');
};

export const buildTimeStampPrefixForBuildStatus: (buildStatus: BuildStatus) => string = (buildStatus) => {
    switch (buildStatus) {
        case BuildStatus.InProgress:
            return 'started';
        case BuildStatus.Stopped:
        case BuildStatus.Failure:
        case BuildStatus.Success:
            return 'finished';
    }
};

export function codeIsCommit(code: PRItem | CommitItem | undefined): code is CommitItem {
    if (!code) return false;

    return (code as CommitItem).type === CodeType.Commit;
}

export const colorForFeatureAffiliationTags: (featureAffiliationType?: FeatureAffiliationType) => string = (
    featureAffiliationType,
) => {
    switch (featureAffiliationType) {
        case FeatureAffiliationType.GitHubMilestone:
            return antBlue.blue1;
        case FeatureAffiliationType.JiraFixVersion:
            return antCyan.cyan1;
        case FeatureAffiliationType.JiraLabel:
        case FeatureAffiliationType.LinearLabel:
        case FeatureAffiliationType.PivotalLabel:
        case FeatureAffiliationType.AsanaTag:
        case FeatureAffiliationType.ShortcutLabel:
        case FeatureAffiliationType.AzureBoardsTag:
        case FeatureAffiliationType.GitHubLabel:
            return antGrey.grey4;
        default:
            return antGrey.grey4;
    }
};

export const displayNameForFeatureAffiliation: (featureAffiliationType: FeatureAffiliationType) => string = (
    featureAffiliationType,
) => {
    switch (featureAffiliationType) {
        case FeatureAffiliationType.GitHubMilestone:
            return 'Milestone';
        case FeatureAffiliationType.JiraFixVersion:
            return 'Fix version';
        case FeatureAffiliationType.JiraLabel:
        case FeatureAffiliationType.LinearLabel:
        case FeatureAffiliationType.PivotalLabel:
        case FeatureAffiliationType.ShortcutLabel:
        case FeatureAffiliationType.GitHubLabel:
            return 'Label';
        case FeatureAffiliationType.AsanaTag:
        case FeatureAffiliationType.AzureBoardsTag:
            return 'Tag';
        case FeatureAffiliationType.MondayColumn:
            return 'Column';
    }
};

export const featureAffiliationTypeForIntegrationType: (
    integrationType: IntegrationType,
) => FeatureAffiliationType[] = (integrationType) => {
    switch (integrationType) {
        case IntegrationType.Jira:
            return [FeatureAffiliationType.JiraLabel, FeatureAffiliationType.JiraFixVersion];
        case IntegrationType.Linear:
            return [FeatureAffiliationType.LinearLabel];
        case IntegrationType.Pivotal:
            return [FeatureAffiliationType.PivotalLabel];
        case IntegrationType.Shortcut:
            return [FeatureAffiliationType.ShortcutLabel];
        case IntegrationType.Asana:
            return [FeatureAffiliationType.AsanaTag];
        case IntegrationType.AzureIT:
            return [FeatureAffiliationType.AzureBoardsTag];
        case IntegrationType.Monday:
            return [FeatureAffiliationType.MondayColumn];
        case IntegrationType.GitHubIT:
            return [FeatureAffiliationType.GitHubLabel, FeatureAffiliationType.GitHubMilestone];
        default:
            return [];
    }
};

export const availableAutoTransitionTicketsStatusesForIntegration: (
    integration: Integration,
    orgId: string,
) => [string, string][] = (integration, orgId) => {
    const featureManagementProvider = useSelector((state: RootState) =>
        selectProviderForIntegration(state, orgId, integration),
    );

    switch (integration?.id) {
        case IntegrationType.Jira:
            return (
                featureManagementProvider?.data?.doneStatuses?.concat(
                    (integration?.data as JiraIntegrationData).additionalDoneStatuses,
                ) ?? []
            ).map((status) => [status, status]);

        case IntegrationType.Shortcut: {
            const statuses =
                featureManagementProvider?.data?.doneStatuses.concat(integration?.data?.additionalDoneStatuses) ?? [];
            return statuses.map((state) => [String(state.id), state.name]);
        }
        case IntegrationType.Linear:
            return (
                featureManagementProvider?.data?.doneStatuses?.concat(
                    (integration?.data as LinearIntegrationData).additionalDoneStatuses,
                ) ?? []
            ).map((status) => [status, status]);

        case IntegrationType.Asana:
        case IntegrationType.AzureIT:
        case IntegrationType.GitHubIT:
        case IntegrationType.Pivotal:
        case IntegrationType.Monday:
        default:
            return [];
    }
};

export const stabilityIssuesSupportedForIntegration: (integrationId: IntegrationType) => boolean = (integrationId) => {
    switch (integrationId) {
        case IntegrationType.Bugsnag:
        case IntegrationType.Sentry:
        case IntegrationType.DatadogStabilityMonitoring:
        case IntegrationType.NewRelicStabilityMonitoring:
            return true;
        default:
            return false;
    }
};

export const nonFatalStabilityIssuesSupportedForIntegration: (integrationId: IntegrationType) => boolean = (
    integrationId,
) => {
    switch (integrationId) {
        case IntegrationType.Bugsnag:
        case IntegrationType.Sentry:
        case IntegrationType.DatadogStabilityMonitoring:
            return true;
        default:
            return false;
    }
};

export const statisticsForOverviewSection: (
    overviewSection: OverviewSection,
    codeIntegrationType?: IntegrationType,
) => StatisticType[] = (overviewSection, codeIntegrationType) => {
    switch (overviewSection) {
        case OverviewSection.Highlights:
            return [StatisticType.ReleaseDuration];
        case OverviewSection.ProductSprint:
            return [
                StatisticType.WaitingForReviewDuration,
                StatisticType.InReviewDuration,
                StatisticType.AppStoreBuildCount,
                StatisticType.ItemsCompleted,
                StatisticType.FixesCount,
                StatisticType.FixRequestsCount,
                StatisticType.FixRequestsApproved,
                StatisticType.FixRequestsRejected,
                StatisticType.PercentWorkItemsInFixRequests,
            ];
        case OverviewSection.Code: {
            const baseStats = [
                StatisticType.CIAverageBuildTime,
                StatisticType.CIWorkflowSuccessPercent,
                StatisticType.CommitCount,
                StatisticType.AICommitsPercentage,
                StatisticType.LinesOfCodeChanged,
                StatisticType.AppStoreBuildBundleDownloadSize,
                StatisticType.AppStoreBuildBundleInstallSize,
            ];

            if (codeIntegrationType === IntegrationType.GitLabVCS) {
                // filter out certain stats not well supported by GitLab right now
                return baseStats.filter(
                    (stat) =>
                        ![
                            StatisticType.CommitCount,
                            StatisticType.AICommitsPercentage,
                            StatisticType.LinesOfCodeChanged,
                            StatisticType.LinesOfCodeDeleted,
                        ].includes(stat),
                );
            }

            return baseStats;
        }
    }
};

export const statusChangeForStatType: (args: { value: number; type: StatisticType }) => StatChangeStatus = ({
    value,
    type,
}) => {
    if (value === 0) {
        return StatChangeStatus.Neutral;
    }

    switch (type) {
        case StatisticType.AppStoreBuildBundleDownloadSize:
        case StatisticType.AppStoreBuildBundleInstallSize: {
            // Less is better but if value is below 1MB we consider it neutral
            if (value >= 1) {
                return StatChangeStatus.Bad;
            }

            if (value < 0) {
                return StatChangeStatus.Good;
            }

            return StatChangeStatus.Neutral;
        }
        case StatisticType.CIAverageBuildTime:
        case StatisticType.WaitingForReviewDuration:
        case StatisticType.ReleaseDuration:
        case StatisticType.InReviewDuration: {
            // Less is better
            return value > 0 ? StatChangeStatus.Bad : StatChangeStatus.Good;
        }
        case StatisticType.CIWorkflowSuccessPercent:
        case StatisticType.BetaCrashFreeUsers:
        case StatisticType.BetaCrashFreeSessions:
        case StatisticType.CrashFreeUsers:
        case StatisticType.CrashFreeSessions: {
            // More is better
            return value > 0 ? StatChangeStatus.Good : StatChangeStatus.Bad;
        }
        case StatisticType.CommitCount:
        case StatisticType.LinesOfCodeChanged:
        case StatisticType.LinesOfCodeAdded:
        case StatisticType.LinesOfCodeDeleted:
        case StatisticType.LinesOfCodeAddedForHotfixes:
        case StatisticType.LinesOfCodeChangedForHotfixes:
        case StatisticType.LinesOfCodeDeletedForHotfixes:
        case StatisticType.FilesChangedCount:
        case StatisticType.AppStoreBuildCount:
        case StatisticType.ItemsCompleted:
        case StatisticType.CIBuildsCount:
        default:
            return StatChangeStatus.Neutral;
    }
};

export const statusTrendForStatType: (args: { value: number; type: StatisticType }) => TrendStatus = ({
    value,
    type,
}) => {
    if (value === 0) {
        return TrendStatus.Neutral;
    }

    switch (type) {
        case StatisticType.AppStoreBuildBundleDownloadSize:
        case StatisticType.AppStoreBuildBundleInstallSize: {
            // Less is better but if value is below 1MB we consider it neutral
            if (value >= 1) {
                return TrendStatus.Bad;
            }

            if (value < 0) {
                return TrendStatus.Good;
            }

            return TrendStatus.Neutral;
        }
        case StatisticType.CIAverageBuildTime:
        case StatisticType.WaitingForReviewDuration:
        case StatisticType.ReleaseDuration:
        case StatisticType.InReviewDuration: {
            // Less is better
            return value > 0 ? TrendStatus.Bad : TrendStatus.Good;
        }
        case StatisticType.CIWorkflowSuccessPercent:
        case StatisticType.BetaCrashFreeUsers:
        case StatisticType.BetaCrashFreeSessions:
        case StatisticType.CrashFreeUsers:
        case StatisticType.CrashFreeSessions: {
            // More is better
            return value > 0 ? TrendStatus.Good : TrendStatus.Bad;
        }
        case StatisticType.CommitCount:
        case StatisticType.LinesOfCodeChanged:
        case StatisticType.LinesOfCodeAdded:
        case StatisticType.LinesOfCodeDeleted:
        case StatisticType.LinesOfCodeAddedForHotfixes:
        case StatisticType.LinesOfCodeChangedForHotfixes:
        case StatisticType.LinesOfCodeDeletedForHotfixes:
        case StatisticType.FilesChangedCount:
        case StatisticType.AppStoreBuildCount:
        case StatisticType.ItemsCompleted:
        case StatisticType.CIBuildsCount:
        default:
            return TrendStatus.Neutral;
    }
};

export const colorForChangeStatArrow: (statChangeStatus: StatChangeStatus) => string = (statChangeStatus) => {
    switch (statChangeStatus) {
        case StatChangeStatus.Bad:
            return runwayColors.statusRed;
        case StatChangeStatus.Good:
            return runwayColors.statusGreen;
        case StatChangeStatus.Neutral:
            return antGrey.grey6;
    }
};

export const colorForTrendStatArrow: (trendStatus: TrendStatus) => string = (trendStatus) => {
    switch (trendStatus) {
        case TrendStatus.Bad:
            return runwayColors.statusRed;
        case TrendStatus.Good:
            return runwayColors.statusGreen;
        case TrendStatus.Neutral:
            return antGrey.grey6;
    }
};

export const isStatTrendValueSignificant: (trend: number, type: StatisticType) => boolean = (trend, type) => {
    switch (type) {
        case StatisticType.CrashFreeSessions:
        case StatisticType.CrashFreeUsers:
        case StatisticType.BetaCrashFreeSessions:
        case StatisticType.BetaCrashFreeUsers:
            return Math.abs(trend) > 0.001;
        case StatisticType.AppStoreBuildBundleDownloadSize:
        case StatisticType.AppStoreBuildBundleInstallSize:
            return Math.abs(trend) > 0;
        default:
            return Math.abs(trend).toFixed(0) !== '0';
    }
};

export const displayStatValue: (statType: StatisticType, statValue?: number, forcedUnit?: StatisticUnit) => string = (
    statType,
    statValue,
    forcedUnit,
) => {
    return displayStatValuePrivate(statType, true, statValue, forcedUnit);
};

export const displayStatValueWithSign: (
    statType: StatisticType,
    statValue?: number,
    forcedUnit?: StatisticUnit,
) => string = (statType, statValue, forcedUnit) => {
    return displayStatValuePrivate(statType, false, statValue, forcedUnit);
};

export const decimalPlacesForStatValue: (unit: StatisticUnit, value: number, type: StatisticType) => number = (
    unit,
    value,
    type,
) => {
    let decimalPlaces;
    const isDefaultSession =
        type === StatisticType.CrashFreeSessions ||
        type === StatisticType.CrashFreeUsers ||
        type === StatisticType.BetaCrashFreeSessions ||
        type === StatisticType.BetaCrashFreeUsers;
    const isOBAAValue =
        type === StatisticType.AverageEventsPerDailyActiveUser ||
        type === StatisticType.AverageEventsPerSession ||
        type === StatisticType.AveragePropertyValues ||
        type === StatisticType.MedianPropertyValues ||
        type === StatisticType.P90PropertyValues ||
        type === StatisticType.P95PropertyValues ||
        type === StatisticType.P99PropertyValues ||
        type == StatisticType.Composed ||
        type == StatisticType.RawValue;

    if (isDefaultSession || isOBAAValue) {
        decimalPlaces = 3;
    } else if (unit == StatisticUnit.Percent) {
        decimalPlaces = value >= 0.01 && value < 1 ? 3 : 0;
    }

    if (unit === StatisticUnit.Count) {
        const minDisplayValue = 1 / Math.pow(10, decimalPlaces ?? 0);
        if (value < minDisplayValue) {
            decimalPlaces = 6; // for very small numbers, show more decimal places
        }
    }

    return decimalPlaces;
};

const displayStatValuePrivate: (
    statType: StatisticType,
    removeSign: boolean,
    statValue?: number,
    forcedUnit?: StatisticUnit,
) => string = (statType, removeSign, statValue, forcedUnit) => {
    if (statValue === undefined || statValue === null) {
        return nilTextForStatisticType(statType);
    }

    const unit = forcedUnit ?? unitForStatisticType(statType);
    const decimalPlaces = decimalPlacesForStatValue(unit, statValue, statType);

    switch (unit) {
        //assumes only change value can be negative..
        case StatisticUnit.Count: {
            let value = statValue;
            if (removeSign) {
                value = Math.abs(statValue);
            }

            return `${Number(value.toFixed(decimalPlaces ?? 0))}`;
        }
        case StatisticUnit.Ratio: {
            let absoluteValue = statValue;
            if (removeSign) {
                absoluteValue = Number(Math.abs(statValue));
            }
            return absoluteValue >= 1 ? absoluteValue.toFixed(0) : absoluteValue.toFixed(2);
        }
        case StatisticUnit.Percent: {
            if (removeSign) {
                return `${Number(Math.abs(statValue).toFixed(decimalPlaces))}%`;
            } else {
                return `${Number(statValue.toFixed(decimalPlaces))}%`;
            }
        }
        case StatisticUnit.Seconds: {
            if (removeSign) {
                return timeStringFromDuration(statValue, statType as StatisticType);
            } else {
                // TODO: Handle this?
                return timeStringFromDuration(statValue, statType as StatisticType);
            }
        }
        case StatisticUnit.Cents: {
            if (removeSign) {
                return dollarsFromCents(statValue);
            } else {
                // TODO: Handle this?
                return dollarsFromCents(statValue);
            }
        }
        case StatisticUnit.Megabytes: {
            if (removeSign) {
                const bytes = statValue * 1_024 * 1_024;
                return formatBytes(Math.abs(bytes), 2);
            } else {
                // TODO: Handle this?
                const bytes = statValue * 1_024 * 1_024;
                return formatBytes(Math.abs(bytes), 2);
            }
        }
        case StatisticUnit.Rating: {
            if (removeSign) {
                return `${Number(Math.abs(statValue).toFixed(1))}`;
            } else {
                return `${Number(statValue.toFixed(1))}`;
            }
        }
        case StatisticUnit.Days: {
            let days = statValue;
            if (removeSign) {
                days = Math.abs(statValue);
            }
            return `${Number(days.toFixed(decimalPlaces ?? 0))} ${days === 1 ? 'day' : 'days'}`;
        }
        case StatisticUnit.Cadence: {
            const numberOfWeeks = Math.round(statValue / 7);
            if (numberOfWeeks <= 1) {
                return 'Weekly';
            } else if (numberOfWeeks <= 2) {
                return 'Bi-weekly';
            } else if (numberOfWeeks <= 4) {
                return 'Monthly';
            } else if (numberOfWeeks <= 8) {
                return 'Bi-monthly';
            } else if (numberOfWeeks <= 12) {
                return 'Quarterly';
            } else if (numberOfWeeks <= 24) {
                return 'Bi-annually';
            } else {
                return 'Annually';
            }
        }
        default:
            return 'Unknown unit type';
    }
};

export const categoryForStatisticType = (statType: StatisticType): StatisticCategory => {
    switch (statType) {
        case StatisticType.StatAverageTimeToRecover:
        case StatisticType.StatFailureRate:
        case StatisticType.StatAverageCLIApprovalTime:
        case StatisticType.StatAverageReleaseStepCompletionTime:
        case StatisticType.AverageHotfixStepCompletionTime:
        case StatisticType.StatReleaseFrequency:
        case StatisticType.StatReleaseDurations:
        case StatisticType.TargetDateSuccessRate:
        case StatisticType.TargetDateSuccessRateKickoff:
        case StatisticType.TargetDateSuccessRateSubmission:
        case StatisticType.TargetDateSuccessRateRelease:
            return StatisticCategory.DevOps;
        case StatisticType.StatAverageCustomerRating:
        case StatisticType.StatAverageAppCustomerRating:
        case StatisticType.CrashFreeUsers:
        case StatisticType.CrashFreeSessions:
        case StatisticType.BetaCrashFreeUsers:
        case StatisticType.BetaCrashFreeSessions:
        case StatisticType.AdoptionRate:
        case StatisticType.AverageEventsPerDailyActiveUser:
        case StatisticType.AverageEventsPerSession:
        case StatisticType.AveragePropertyValues:
        case StatisticType.MedianPropertyValues:
        case StatisticType.P90PropertyValues:
        case StatisticType.P95PropertyValues:
        case StatisticType.P99PropertyValues:
        case StatisticType.RawValue:
        case StatisticType.Composed:
            return StatisticCategory.StabilityAndHealth;
        case StatisticType.CommitCount:
        case StatisticType.AICommitsPercentage:
        case StatisticType.AIAuthorDistribution:
        case StatisticType.LinesOfCodeAdded:
        case StatisticType.LinesOfCodeAddedForHotfixes:
        case StatisticType.LinesOfCodeChanged:
        case StatisticType.LinesOfCodeChangedForHotfixes:
        case StatisticType.LinesOfCodeDeleted:
        case StatisticType.LinesOfCodeDeletedForHotfixes:
        case StatisticType.FilesChangedCount:
        case StatisticType.ReleaseDuration:
        case StatisticType.WaitingForReviewDuration:
        case StatisticType.InReviewDuration:
        case StatisticType.ItemsCompleted:
        case StatisticType.FixesCount:
        case StatisticType.FixRequestsCount:
        case StatisticType.FixRequestsApproved:
        case StatisticType.FixRequestsRejected:
        case StatisticType.PercentWorkItemsInFixRequests:
        case StatisticType.HotfixReleaseDuration:
        case StatisticType.TotalHotfixesCount:
            return StatisticCategory.Work;
        case StatisticType.CIWorkflowSuccessPercent:
        case StatisticType.CIAverageBuildTime:
        case StatisticType.AppStoreBuildCount:
        case StatisticType.CIBuildsCount:
        case StatisticType.AppStoreBuildBundleDownloadSize:
        case StatisticType.AppStoreBuildBundleInstallSize:
            return StatisticCategory.Build;
        case StatisticType.StatTriageIssuesDetected:
        case StatisticType.StatTriageTimeToFixMerged:
            return StatisticCategory.Triage;
        default:
            return StatisticCategory.Work;
    }
};

export const unitForStatisticType = (statType: StatisticType): StatisticUnit => {
    switch (statType) {
        case StatisticType.StatReleaseDurations:
        case StatisticType.StatAverageTimeToRecover:
        case StatisticType.StatAverageCLIApprovalTime:
        case StatisticType.StatAverageReleaseStepCompletionTime:
        case StatisticType.AverageHotfixStepCompletionTime:
        case StatisticType.CIAverageBuildTime:
        case StatisticType.ReleaseDuration:
        case StatisticType.InReviewDuration:
        case StatisticType.WaitingForReviewDuration:
        case StatisticType.HotfixReleaseDuration:
        case StatisticType.StatAverageTimeSavedFromAutomations:
        case StatisticType.StatTotalTimeSavedFromAutomations:
            return StatisticUnit.Seconds;
        case StatisticType.AppStoreBuildCount:
        case StatisticType.CommitCount:
        case StatisticType.FilesChangedCount:
        case StatisticType.ItemsCompleted:
        case StatisticType.FixesCount:
        case StatisticType.FixRequestsCount:
        case StatisticType.FixRequestsApproved:
        case StatisticType.FixRequestsRejected:
        case StatisticType.LinesOfCodeAdded:
        case StatisticType.LinesOfCodeChanged:
        case StatisticType.LinesOfCodeDeleted:
        case StatisticType.LinesOfCodeAddedForHotfixes:
        case StatisticType.LinesOfCodeChangedForHotfixes:
        case StatisticType.LinesOfCodeDeletedForHotfixes:
        case StatisticType.StatTotalAutomationsCount:
        case StatisticType.StatAverageAutomationsCount:
        case StatisticType.TotalHotfixesCount:
        case StatisticType.AverageEventsPerDailyActiveUser:
        case StatisticType.AverageEventsPerSession:
        case StatisticType.AveragePropertyValues:
        case StatisticType.MedianPropertyValues:
        case StatisticType.P90PropertyValues:
        case StatisticType.P95PropertyValues:
        case StatisticType.P99PropertyValues:
        case StatisticType.RawValue:
        case StatisticType.Composed:
        case StatisticType.CIBuildsCount:
            return StatisticUnit.Count;
        case StatisticType.AppStoreBuildBundleInstallSize:
        case StatisticType.AppStoreBuildBundleDownloadSize:
            return StatisticUnit.Megabytes;
        case StatisticType.CIWorkflowSuccessPercent:
        case StatisticType.AICommitsPercentage:
        case StatisticType.AIAuthorDistribution:
        case StatisticType.TargetDateSuccessRateRelease:
        case StatisticType.CrashFreeUsers:
        case StatisticType.CrashFreeSessions:
        case StatisticType.BetaCrashFreeUsers:
        case StatisticType.BetaCrashFreeSessions:
        case StatisticType.AdoptionRate:
        case StatisticType.StatFailureRate:
        case StatisticType.PercentWorkItemsInFixRequests:
            return StatisticUnit.Percent;
        case StatisticType.StatTotalCostSavingsFromAutomations:
        case StatisticType.StatAverageCostSavingsFromAutomations:
            return StatisticUnit.Cents;
        case StatisticType.StatAverageCustomerRating:
        case StatisticType.StatAverageAppCustomerRating:
            return StatisticUnit.Rating;
        case StatisticType.StatReleaseFrequency:
            return StatisticUnit.Days;
        default:
            return StatisticUnit.Count;
    }
};

export const nilTextForStatisticType = (statType: StatisticType): string => {
    switch (statType) {
        case StatisticType.StatAverageTimeToRecover:
            return 'No hotfixes';
        case StatisticType.StatFailureRate:
            return 'No failures';
        case StatisticType.StatAverageCLIApprovalTime:
            return 'No CLIs';
        default:
            return '--';
    }
};

export const displayMonitoringStatisticFormattedValue = (monitoringStatistic: MonitoringStatistic) => {
    if (isNil(monitoringStatistic.currentValue)) {
        return '--';
    }

    // Special cases
    if (monitoringStatistic.integrationId == IntegrationType.AndroidVitals) {
        return displayStatValue(StatisticType.RawValue, monitoringStatistic.currentValue, StatisticUnit.Percent);
    }
    if (monitoringStatistic.integrationId == IntegrationType.ApplePowerPerformanceMetrics) {
        // In future could handle more real units for Apple Power Performance Metrics, but start with generic
        return displayStatValue(StatisticType.RawValue, monitoringStatistic.currentValue, StatisticUnit.Count);
    }

    switch (monitoringStatistic.type) {
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUser:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.AverageEventsPerDailyActiveUser,
                monitoringStatistic.currentValue,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.EventsPerSession:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.AverageEventsPerSession,
                monitoringStatistic.currentValue,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValues:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.AveragePropertyValues,
                monitoringStatistic.currentValue,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValues:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.MedianPropertyValues,
                monitoringStatistic.currentValue,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.P90PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.P90PropertyValues,
                monitoringStatistic.currentValue,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.P95PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.P95PropertyValues,
                monitoringStatistic.currentValue,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.P99PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.P99PropertyValues,
                monitoringStatistic.currentValue,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.GenericObaaValue:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousValue:
            return displayStatValue(StatisticType.RawValue, monitoringStatistic.currentValue, StatisticUnit.Count);
        case ObservabilityAndAnalyticsMetricType.Composed:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousValue:
            return displayStatValue(StatisticType.Composed, monitoringStatistic.currentValue, StatisticUnit.Count);
        case StabilityMetricType.UserStability:
        case StabilityMetricType.UserStabilityDeltaFromPreviousPercentage:
        case StabilityMetricType.UserStabilityDeltaFromPreviousValue:
        case StabilityMetricType.MergedUserStability:
            return displayStatValue(
                StatisticType.CrashFreeUsers,
                monitoringStatistic.currentValue,
                StatisticUnit.Percent,
            );
        case StabilityMetricType.SessionStability:
        case StabilityMetricType.SessionStabilityDeltaFromPreviousPercentage:
        case StabilityMetricType.SessionStabilityDeltaFromPreviousValue:
        case StabilityMetricType.MergedSessionStability:
            return displayStatValue(
                StatisticType.CrashFreeSessions,
                monitoringStatistic.currentValue,
                StatisticUnit.Percent,
            );
        case StabilityMetricType.AdoptionRate:
            return displayStatValue(StatisticType.RawValue, monitoringStatistic.currentValue, StatisticUnit.Percent);
        case UserRatingsMetricType.AvgUserRating:
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousPercentage:
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.StatAverageCustomerRating,
                monitoringStatistic.currentValue,
                StatisticUnit.Rating,
            );
    }
};

export const displayMonitoringStatisticFormattedDelta = (monitoringStatistic: MonitoringStatistic) => {
    switch (monitoringStatistic.type) {
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUser:
            return null;
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousPercentage:
            return displayStatValue(
                StatisticType.AverageEventsPerDailyActiveUser,
                monitoringStatistic.delta,
                StatisticUnit.Percent,
            );
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.AverageEventsPerDailyActiveUser,
                monitoringStatistic.delta,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.EventsPerSession:
            return null;
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousPercentage:
            return displayStatValue(
                StatisticType.AverageEventsPerSession,
                monitoringStatistic.delta,
                StatisticUnit.Percent,
            );
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.AverageEventsPerSession,
                monitoringStatistic.delta,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValues:
            return null;
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousPercentage:
            return displayStatValue(
                StatisticType.AveragePropertyValues,
                monitoringStatistic.delta,
                StatisticUnit.Percent,
            );
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.AveragePropertyValues,
                monitoringStatistic.delta,
                StatisticUnit.Count,
            );
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValues:
            return null;
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousPercentage:
            return displayStatValue(
                StatisticType.MedianPropertyValues,
                monitoringStatistic.delta,
                StatisticUnit.Percent,
            );
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousValue:
            return displayStatValue(StatisticType.MedianPropertyValues, monitoringStatistic.delta, StatisticUnit.Count);
        case ObservabilityAndAnalyticsMetricType.P90PropertyValues:
            return null;
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousPercentage:
            return displayStatValue(StatisticType.P90PropertyValues, monitoringStatistic.delta, StatisticUnit.Percent);
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousValue:
            return displayStatValue(StatisticType.P90PropertyValues, monitoringStatistic.delta, StatisticUnit.Count);
        case ObservabilityAndAnalyticsMetricType.P95PropertyValues:
            return null;
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousPercentage:
            return displayStatValue(StatisticType.P95PropertyValues, monitoringStatistic.delta, StatisticUnit.Percent);
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousValue:
            return displayStatValue(StatisticType.P95PropertyValues, monitoringStatistic.delta, StatisticUnit.Count);
        case ObservabilityAndAnalyticsMetricType.P99PropertyValues:
            return null;
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousPercentage:
            return displayStatValue(StatisticType.P99PropertyValues, monitoringStatistic.delta, StatisticUnit.Percent);
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousValue:
            return displayStatValue(StatisticType.P99PropertyValues, monitoringStatistic.delta, StatisticUnit.Count);
        case ObservabilityAndAnalyticsMetricType.GenericObaaValue:
            return null;
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousPercentage:
            return displayStatValue(StatisticType.RawValue, monitoringStatistic.delta, StatisticUnit.Percent);
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousValue:
            return displayStatValue(StatisticType.RawValue, monitoringStatistic.delta, StatisticUnit.Count);
        case ObservabilityAndAnalyticsMetricType.Composed:
            return null;
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousPercentage:
            return displayStatValue(StatisticType.Composed, monitoringStatistic.delta, StatisticUnit.Percent);
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousValue:
            return displayStatValue(StatisticType.Composed, monitoringStatistic.delta, StatisticUnit.Count);
        case StabilityMetricType.UserStability:
        case StabilityMetricType.MergedUserStability:
        case StabilityMetricType.AdoptionRate:
            return null;
        case StabilityMetricType.UserStabilityDeltaFromPreviousPercentage:
        case StabilityMetricType.UserStabilityDeltaFromPreviousValue:
            return displayStatValue(StatisticType.CrashFreeUsers, monitoringStatistic.delta, StatisticUnit.Percent);
        case StabilityMetricType.SessionStability:
        case StabilityMetricType.MergedSessionStability:
            return null;
        case StabilityMetricType.SessionStabilityDeltaFromPreviousPercentage:
        case StabilityMetricType.SessionStabilityDeltaFromPreviousValue:
            return displayStatValue(StatisticType.CrashFreeSessions, monitoringStatistic.delta, StatisticUnit.Percent);
        case UserRatingsMetricType.AvgUserRating:
            return null;
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousPercentage:
            return displayStatValue(
                StatisticType.StatAverageCustomerRating,
                monitoringStatistic.delta,
                StatisticUnit.Percent,
            );
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousValue:
            return displayStatValue(
                StatisticType.StatAverageCustomerRating,
                monitoringStatistic.delta,
                StatisticUnit.Rating,
            );
    }
};

export const massageMonitoringData = ({
    monitoringStatistics,
    monitoringAutomations,
    metricsById,
    hasPartialData,
    shouldGroupStats = true,
    shouldGroupCrashFreeStats = true,
}: {
    monitoringStatistics: MonitoringStatistic[];
    monitoringAutomations: MonitoringAutomation[];
    metricsById: Record<string, AppMonitoringHealthMetric>;
    hasPartialData?: boolean;
    shouldGroupStats?: boolean;
    shouldGroupCrashFreeStats?: boolean;
}): GroupedMonitoringStatistic[] => {
    // group related stats
    const statsByBuildId = groupBy(monitoringStatistics, (stat) => stat.buildIdentifier ?? '');

    const groupedMonitoringStatistics: GroupedMonitoringStatistic[] = [];

    Object.entries(statsByBuildId).forEach(([buildIdentifier, stats]) => {
        const relatedMonitoringStatisticsByKey: Record<string, MonitoringStatistic[]> = groupBy(
            stats,
            groupKeyByMonitoringStatistic,
        );

        if (shouldGroupCrashFreeStats) {
            const sessionGroupEntries = Object.entries(relatedMonitoringStatisticsByKey).filter(
                ([, statsForKey]) =>
                    statsForKey.length === 1 && statsForKey[0].type === StabilityMetricType.SessionStability,
            );

            for (const [sessionKey, sessionStatsForKey] of sessionGroupEntries) {
                const installationId = sessionStatsForKey[0].integrationInstallationId;
                const userKey = stabilityMetricGroupKey(StabilityMetricType.UserStability, installationId);
                const userStatsForKey = relatedMonitoringStatisticsByKey[userKey];

                if (userStatsForKey?.length !== 1 || userStatsForKey[0].type !== StabilityMetricType.UserStability) {
                    continue;
                }

                const crashFreeSessionStat = { ...sessionStatsForKey[0] };
                const crashFreeUserStat = { ...userStatsForKey[0] };

                crashFreeSessionStat.type = StabilityMetricType.MergedSessionStability;
                crashFreeUserStat.type = StabilityMetricType.MergedUserStability;

                relatedMonitoringStatisticsByKey[sessionKey] = [crashFreeSessionStat, crashFreeUserStat];
                delete relatedMonitoringStatisticsByKey[userKey];
            }
        }

        const relatedMonitoringStatistics =
            shouldGroupStats ?
                Object.entries(relatedMonitoringStatisticsByKey)
            :   (stats.map((stat) => [stat.type, [stat]]) as [string, MonitoringStatistic[]][]);

        relatedMonitoringStatistics.forEach(([key, multipleMonitoringStatistics]) => {
            if (multipleMonitoringStatistics.length === 0) {
                return;
            }

            const filteredMultipleMonitoringStatistics = multipleMonitoringStatistics.filter(
                (monitoringStatistic) =>
                    !(
                        monitoringStatistic.monitoringMetricId &&
                        metricsById[monitoringStatistic.monitoringMetricId!]?.hideOnRolloutView
                    ),
            );
            if (filteredMultipleMonitoringStatistics.length === 0) {
                return;
            }
            const monitoringStatisticGroups: MonitoringStatisticGroup[] = filteredMultipleMonitoringStatistics.map(
                (monitoringStatistic) => {
                    const dataPoints: StatisticTimeSeriesDataPoint[] = [];

                    // data points data (for full stat objects only)
                    let hasRecentDataOnly = false;
                    if (!hasPartialData) {
                        if (monitoringStatistic.pastDataPoints && monitoringStatistic.pastDataPoints.length > 0) {
                            dataPoints.push(...monitoringStatistic.pastDataPoints);
                        } else if (
                            monitoringStatistic.recentDataPoints &&
                            monitoringStatistic.recentDataPoints.length > 0
                        ) {
                            hasRecentDataOnly = true;
                            dataPoints.push(...monitoringStatistic.recentDataPoints);
                        }
                    }

                    // automation usage data
                    const automationUsage: Record<
                        AutomationType.AutoHaltUnstablePhasedReleases | AutomationType.AutoPromoteStablePhasedReleases,
                        MonitoringStatisticAutomationUsage
                    > = {
                        [AutomationType.AutoHaltUnstablePhasedReleases]: {
                            isUsed: false,
                            triggeredAt: undefined,
                        },
                        [AutomationType.AutoPromoteStablePhasedReleases]: {
                            isUsed: false,
                            triggeredAt: undefined,
                        },
                    };

                    // associated health metric data
                    const associatedHealthMetric =
                        monitoringStatistic.monitoringMetricId ?
                            metricsById[monitoringStatistic.monitoringMetricId!]
                        :   undefined;

                    monitoringAutomations.forEach((monitoringAutomation) => {
                        if (
                            ['AutoHaltUnstablePhasedReleases', 'AutoPromoteStablePhasedReleases'].includes(
                                monitoringAutomation.type,
                            )
                        ) {
                            const associatedMetric = monitoringAutomation.associatedMetrics?.find(
                                (associatedMetric) => {
                                    return associatedMetric.id === monitoringStatistic.monitoringMetricId;
                                },
                            );

                            const isUsed = !!associatedMetric;
                            automationUsage[monitoringAutomation.type].isUsed = isUsed;

                            // for auto halt only
                            // if the current metric is associated with the auto halt automation and that metric is healthy
                            // skip it so only the unhealthy metrics have the triggeredAt timestamp (which shows the auto halt indicator)
                            if (
                                monitoringAutomation.type === AutomationType.AutoHaltUnstablePhasedReleases &&
                                isUsed &&
                                associatedMetric.status === MonitoringMetricHealthStatus.Healthy
                            ) {
                                return;
                            }

                            // otherwise...
                            automationUsage[monitoringAutomation.type].triggeredAt =
                                isUsed ? monitoringAutomation.triggeredAt : undefined;
                        }
                    });

                    let isMoreBetter: boolean | undefined = undefined;
                    let threshold: number | undefined = undefined;
                    let status: MonitoringMetricHealthStatus | undefined = undefined;
                    if (associatedHealthMetric && associatedHealthMetric.thresholds.length > 0) {
                        const thresholdData = associatedHealthMetric.thresholds[0];
                        isMoreBetter =
                            thresholdData.condition === MetricConditionOperator.GreaterThan ||
                            thresholdData.condition === MetricConditionOperator.GreaterThanOrEqualTo;
                        threshold = thresholdData.value;
                    }
                    status = monitoringStatistic.monitoringMetricStatus;

                    let change: number | undefined = undefined;
                    if (monitoringStatistic.previousValue && monitoringStatistic.currentValue) {
                        change = monitoringStatistic.currentValue - monitoringStatistic.previousValue;
                    }
                    // group formatting, unit and value
                    const group: MonitoringStatisticGroup = {
                        value: displayMonitoringStatisticFormattedValue(monitoringStatistic),
                        unit: displayMonitoringStatisticUnitLabel(monitoringStatistic),
                        type: monitoringStatistic.type,
                        dataPoints: dataPoints,
                        additionalDataSeries: monitoringStatistic.additionalDataSeries,
                        threshold: threshold,
                        hasRecentDataOnly: hasRecentDataOnly,
                        isMoreBetter: isMoreBetter,
                        status: status,
                        currentValue: monitoringStatistic.currentValue,
                        delta: displayMonitoringStatisticFormattedDelta(monitoringStatistic) ?? undefined,
                        change: change,
                        previousVersion: monitoringStatistic.previousVersion,
                        previousValue: displayMonitoringStatisticFormattedValue({
                            integrationId: monitoringStatistic.integrationId,
                            integrationInstallationId: monitoringStatistic.integrationInstallationId,
                            type: monitoringStatistic.type,
                            currentValue: monitoringStatistic.previousValue,
                        }),
                        automationUsage,
                    };

                    return group;
                },
            );

            const nonNullStatuses = compact(monitoringStatisticGroups.map(({ status }) => status));

            const mergedStatus =
                nonNullStatuses.some((predicate) => predicate === MonitoringMetricHealthStatus.Unhealthy) ?
                    MonitoringMetricHealthStatus.Unhealthy
                :   MonitoringMetricHealthStatus.Healthy;

            const firstStat = filteredMultipleMonitoringStatistics[0];
            // grouped stat data
            const associatedMetricDescription =
                firstStat.monitoringMetricId ? metricsById[firstStat.monitoringMetricId]?.description : undefined;
            const groupedMonitoringStatistic: GroupedMonitoringStatistic = {
                key,
                category: categoryForMonitoringStatisticType(firstStat.type),
                title:
                    shouldGroupStats ?
                        displayMonitoringStatisticTitle(firstStat)
                    :   displayUngroupedMonitoringStatisticTitle(firstStat),
                integrationType: firstStat.integrationId,
                groups: monitoringStatisticGroups,
                mergedStatus: nonNullStatuses.length > 0 ? mergedStatus : undefined,
                buildIdentifier: buildIdentifier,
                description: associatedMetricDescription ?? firstStat?.description,
            };

            groupedMonitoringStatistics.push(groupedMonitoringStatistic);
        });
    });

    const sortGroupedMonitoringStatistics = (a: GroupedMonitoringStatistic, b: GroupedMonitoringStatistic) => {
        if (a.category === b.category) {
            const integrationCompare = (a.integrationType ?? '').localeCompare(b.integrationType ?? '');
            if (integrationCompare !== 0) {
                return integrationCompare;
            }
            return a.title.localeCompare(b.title);
        }

        const categoryPriority: AppMonitoringHealthMetricCategory[] = [
            AppMonitoringHealthMetricCategory.Stability,
            AppMonitoringHealthMetricCategory.UserReviews,
            AppMonitoringHealthMetricCategory.ObservabilityAndAnalytics,
        ];

        return categoryPriority.indexOf(a.category) - categoryPriority.indexOf(b.category);
    };

    groupedMonitoringStatistics.sort(sortGroupedMonitoringStatistics);

    return groupedMonitoringStatistics;
};

export const dollarsFromCents: (cents: number) => string = (cents) => {
    const roundedCost =
        cents <= 10000 ? Math.round(cents / 1000) * 1000
        : cents <= 1000000 ? Math.round(cents / 10000) * 10000
        : Math.round(cents / 100000) * 100000;
    const options: Intl.NumberFormatOptions = {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    };

    const formatter = Intl.NumberFormat('en-US', options);
    return roundedCost >= 1000000 ? formatter.format(roundedCost / 100000) + 'k' : formatter.format(roundedCost / 100);
};

export const megabyteValueToBytes: (mbValue: number) => number = (mbValue) => {
    return mbValue * 1_024 * 1_024;
};

export const formatBytes: (bytes: number, decimals?: number) => string = (bytes, decimals = 0) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1_024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const timeStringFromDuration = (durationInSeconds: number, statType?: StatisticType): string => {
    const duration = dayjs.duration(durationInSeconds, 'seconds');

    if (statType === StatisticType.StatTotalTimeSavedFromAutomations) {
        const inHours = Math.floor(duration.asHours());

        return inHours + 'h';
    }

    //assumes only change value can be negative..
    const measurements: string[] = [];
    measurements.push(Math.abs(Math.floor(duration.years())) + 'y');
    measurements.push(Math.abs(Math.floor(duration.months())) + 'mo');
    measurements.push(Math.abs(Math.floor(duration.days())) + 'd');

    measurements.push(Math.abs(Math.floor(duration.hours())) + 'h');
    measurements.push(Math.abs(Math.floor(duration.minutes())) + 'm');
    measurements.push(Math.abs(Math.floor(duration.seconds())) + 's');

    //display largest two duration values after first non-zero duration
    let reducedMeasurements: string[] = [];
    if (measurements.every((item) => item.charAt(0) === '0')) {
        return '0s';
    }
    for (let i = 0; i < measurements.length; i++) {
        if (measurements[i].charAt(0) !== '0') {
            reducedMeasurements = measurements.slice(i, i + 2);
            break;
        }
    }
    return reducedMeasurements.join(' ');
};

export const isDevelopmentEnvironment: () => boolean = () => {
    const environment = process.env.NODE_ENV as Environment;
    const isDevEnvironment = environment === Environment.Development;

    return isDevEnvironment;
};

export const computePreviousVersionFromVersion = (version: string): string | null => {
    const [majorStr, minorStr, patchStr] = version.split('.');
    const major = parseInt(majorStr);
    const minor = parseInt(minorStr);
    const patch = parseInt(patchStr);

    if (patch > 0) {
        if (major > 0 || minor > 0 || patch > 1) {
            return `${major}.${minor}.${patch - 1}`;
        } else {
            return null;
        }
    } else if (minor > 0) {
        if (major > 0 || minor > 1) {
            return `${major}.${minor - 1}.${patch}`;
        } else {
            return '0.0.1';
        }
    } else if (major > 0) {
        if (major > 1) {
            return `${major - 1}.${minor}.${patch}`;
        } else {
            return '0.1.0';
        }
    } else {
        return '0.0.1';
    }
};

export const computeNextVersionFromVersion: (version: string, defaultReleaseType: ReleaseType) => string = (
    version,
    defaultReleaseType,
) => {
    const [majorStr, minorStr, patchStr] = version.split('.');
    const major = parseInt(majorStr);
    const minor = parseInt(minorStr);
    const patch = parseInt(patchStr);

    switch (defaultReleaseType) {
        case ReleaseType.Major: {
            const incrMajor = major + 1;
            return `${incrMajor}.${minor}.${patch}`;
        }
        case ReleaseType.Minor: {
            const incrMinor = minor + 1;
            return `${major}.${incrMinor}.${patch}`;
        }
        case ReleaseType.Hotfix:
        case ReleaseType.Point: {
            const incrPatch = patch + 1;
            return `${major}.${minor}.${incrPatch}`;
        }
        default:
            return version;
    }
};

const sortedIntegrationInstallationIds = <T>(
    valuesByIntegrationInstallationId?: Record<IntegrationInstallationId, T>,
): IntegrationInstallationId[] => {
    return Object.keys(valuesByIntegrationInstallationId ?? {}).sort() as IntegrationInstallationId[];
};

const isStabilityInfo = (value: unknown): value is StabilityInfo => {
    return !!value && typeof value === 'object' && 'integrationId' in value;
};

type BuildWithStabilityInfo = Pick<AppStoreBuild, 'stabilityInfo' | 'stabilityInfos'>;

export const getStabilityInfos = (build?: BuildWithStabilityInfo): StabilityInfo[] => {
    const keyedStabilityInfos = sortedIntegrationInstallationIds(build?.stabilityInfos)
        .map((integrationInstallationId) => build?.stabilityInfos?.[integrationInstallationId])
        .filter(isStabilityInfo);
    if (keyedStabilityInfos.length > 0) return keyedStabilityInfos;

    return isStabilityInfo(build?.stabilityInfo) ? [build.stabilityInfo] : [];
};

export const getBuildsWithStabilityInfo = (
    appStoreSelectedBuilds?: AppStoreAvailableBuild[],
): AppStoreAvailableBuild[] | null => {
    if (!appStoreSelectedBuilds) return null;
    return compact(
        appStoreSelectedBuilds.map((build) => {
            if (getStabilityInfos(build).length > 0) {
                return build;
            } else {
                return null;
            }
        }),
    );
};

export const getStabilityInfoForIntegration = (
    build: BuildWithStabilityInfo | undefined,
    integrationInstallationId: IntegrationInstallationId | undefined,
): StabilityInfo | undefined => {
    if (integrationInstallationId) {
        const keyedStabilityInfo = build?.stabilityInfos?.[integrationInstallationId];
        if (isStabilityInfo(keyedStabilityInfo)) return keyedStabilityInfo;
    }

    return isStabilityInfo(build?.stabilityInfo) ? build.stabilityInfo : undefined;
};

export const releaseAdoptionsForIntegration = (
    releaseAdoptions: Record<IntegrationInstallationId, ReleaseAdoption[]> | undefined,
    integrationInstallationId: IntegrationInstallationId | undefined,
): ReleaseAdoption[] => {
    if (!releaseAdoptions || !integrationInstallationId) return [];
    return releaseAdoptions[integrationInstallationId] ?? [];
};

export const hasAnyReleaseAdoptions = (
    releaseAdoptions: Record<IntegrationInstallationId, ReleaseAdoption[]> | undefined,
): boolean => {
    return sortedIntegrationInstallationIds(releaseAdoptions).some(
        (integrationInstallationId) => (releaseAdoptions?.[integrationInstallationId]?.length ?? 0) > 0,
    );
};

export const calculatePercentComplete: (completedItemsCount: number, totalItemsCount: number) => number = (
    completedItemsCount,
    totalItemsCount,
) => {
    if (totalItemsCount > 0) {
        const percentComplete = (completedItemsCount / totalItemsCount) * 100.0;

        if (percentComplete > 99) {
            // don't round if percent is between 99 and 100
            return parseInt(Math.trunc(percentComplete).toFixed());
        }

        return parseInt(percentComplete.toFixed());
    }

    return 0;
};

export const groupStatistics = (
    statistics: StatisticWithAssociatedInfo[],
): Record<ExtendedStatisticType, Statistic[]> | null => {
    if (statistics?.length === 0) {
        return null;
    }

    // group them by type
    const allStatisticsByType = groupBy(statistics, (stat) => {
        const extendedType = extendedStatTypeForReleaseStatistic(stat);
        return extendedType;
    });

    return allStatisticsByType as unknown as Record<ExtendedStatisticType, StatisticWithAssociatedInfo[]>;
};

export const calculateStatistics = ({
    statistics,
    totals = false,
}: {
    statistics?: StatisticWithAssociatedInfo[];
    totals?: boolean;
}): {
    calculatedStatistics: Statistic[];
    samplesByStatisticType: Record<ExtendedStatisticType, StatisticWithAssociatedInfo[]>;
} => {
    const samplesByStatisticType = groupStatistics(statistics ?? []);

    if (!samplesByStatisticType) {
        return {
            calculatedStatistics: [],
            samplesByStatisticType: {} as Record<ExtendedStatisticType, StatisticWithAssociatedInfo[]>,
        };
    }

    const finalStatistics: Statistic[] = [];

    Object.values(samplesByStatisticType).forEach((statistics) => {
        if (statistics.length === 0) {
            return;
        }

        let finalStatistic = statistics[0];

        if (totals) {
            if (
                finalStatistic.unit === StatisticUnit.Ratio &&
                finalStatistic.secondaryValue !== null &&
                finalStatistic.secondaryValue !== undefined
            ) {
                let finalRatio = 0;

                let hotfixesCount = 0;
                let releasesCount = 0;
                statistics.forEach((stat) => {
                    hotfixesCount += stat.value ?? 0;
                    releasesCount += stat.secondaryValue ?? 0;
                });

                if (releasesCount > 0) {
                    finalRatio = hotfixesCount / releasesCount;
                } else {
                    finalRatio = hotfixesCount;
                }

                finalStatistic = {
                    ...finalStatistic,
                    value: finalRatio,
                };
            } else {
                finalStatistic = {
                    ...finalStatistic,
                    value: statistics.reduce((acc, stat) => acc + stat.value, 0),
                };
            }
        } else {
            let value = statistics.reduce((acc, stat) => acc + stat.value, 0) / statistics.length;
            let trend = calculateTrend({ values: statistics.map((stat) => stat.value) });

            if (
                statistics[0].type === StatisticType.AppStoreBuildBundleDownloadSize ||
                statistics[0].type === StatisticType.AppStoreBuildBundleInstallSize
            ) {
                value = Math.round(value);
                trend = trend != null ? Math.round(trend) : null;
            }

            finalStatistic = {
                ...finalStatistic,
                value,
                trend: trend ?? undefined,
            };
        }

        finalStatistics.push(finalStatistic);
    });

    return {
        calculatedStatistics: finalStatistics,
        samplesByStatisticType,
    };
};

// a function that calculates the trend (slope of line of best fit) of a statistic
// Based on https://www.varsitytutors.com/hotmath/hotmath_help/topics/line-of-best-fit
export const calculateTrend = ({ values }: { values: number[] }): number | null => {
    if (values.length < 2) {
        return null;
    }

    let xTotal = 0;
    let yTotal = 0;
    values.forEach((yValue, i) => {
        xTotal += i;
        yTotal += yValue;
    });

    const xAvg = xTotal / values.length;
    const yAvg = yTotal / values.length;

    const xiMinusXAvg: number[] = [];
    const yiMinusYAvg: number[] = [];

    values.forEach((yValue, i) => {
        xiMinusXAvg.push(i - xAvg);
        yiMinusYAvg.push(yValue - yAvg);
    });

    let multipliedValuesSum = 0;
    let xiMinusXAvgSquaredSum = 0;
    values.forEach((_, i) => {
        multipliedValuesSum += xiMinusXAvg[i] * yiMinusYAvg[i];
        xiMinusXAvgSquaredSum += Math.pow(i - xAvg, 2);
    });

    if (xiMinusXAvgSquaredSum === 0) {
        return null;
    }

    const slope = multipliedValuesSum / xiMinusXAvgSquaredSum;

    return slope;
};

export const getReleaseLifecycleStepDisplayInfo = (step: LifecycleStep, nextReleaseSummary: NextReleaseSummary) => {
    const targetDate = getLifecycleStepTargetDate(step, nextReleaseSummary);
    const targetDay = targetDate.isValid() && targetDate.format(DatetimeFormat.MonthDate);

    const isComplete = isLifecycleStepCompleted(step, nextReleaseSummary);

    const completedAt = isLifecycleStepCompletedDate(step, nextReleaseSummary);

    const completedDate = dayjs(completedAt);
    const completedDay = completedDate.isValid() && completedDate.format(DatetimeFormat.MonthDate);

    const displayText = getLifecycleStepDisplayText(step, isComplete, false);

    const emptyDate = '--';

    const displayDate =
        completedDate.isValid() ? completedDay
        : targetDate.isValid() ? targetDay
        : emptyDate;

    const hasDate = completedDate.isValid() || targetDate.isValid();

    return {
        isComplete,
        targetDate,
        displayText,
        hasDate,
        displayDate,
    };
};

export const STRING_FOR_CHECKLIST_ITEM_PLACEMENT: Record<ChecklistItemPlacement, string> = {
    [ChecklistItemPlacement.Approvals]: 'approval',
    [ChecklistItemPlacement.RegressionTesting]: 'regression',
    [ChecklistItemPlacement.StepChecklist]: 'step checklist',
};

export const STRING_FOR_REGRESSION_STATUS: Record<RegressionStatus, string> = {
    [RegressionStatus.NotStarted]: 'not started',
    [RegressionStatus.InProgress]: 'in progress',
    [RegressionStatus.Passed]: 'passed',
    [RegressionStatus.Failed]: 'failed',
};

export const STRING_FOR_RELEASE_STEP_STATUS: Record<ReleaseStepStatus, string> = {
    [ReleaseStepStatus.Blocked]: 'Blocked',
    [ReleaseStepStatus.Inactive]: 'Inactive',
    [ReleaseStepStatus.Pending]: 'Pending',
    [ReleaseStepStatus.PendingChecklistOnly]: 'Pending checklist',
    [ReleaseStepStatus.Ready]: 'Ready',
    [ReleaseStepStatus.Skipped]: 'Skipped',
};

export const STRING_FOR_APP_STORE_STATE: Record<AppStoreState | GooglePlayReleaseLifecycleState, string> = {
    [AppleAppStoreState.ReadyForSale]: 'Ready for sale',
    [AppleAppStoreState.PreorderReadyForSale]: 'Preorder ready for sale',
    [AppleAppStoreState.ProcessingForAppStore]: 'Processing for app store',
    [AppleAppStoreState.PendingDeveloperRelease]: 'Pending developer release',
    [AppleAppStoreState.PendingAppleRelease]: 'Pending apple release',
    [AppleAppStoreState.InReview]: 'In review',
    [AppleAppStoreState.WaitingForReview]: 'Waiting for review',
    [AppleAppStoreState.DeveloperRejected]: 'Developer rejected',
    [AppleAppStoreState.Rejected]: 'Rejected',
    [AppleAppStoreState.Accepted]: 'Accepted',
    [AppleAppStoreState.PrepareForSubmission]: 'Prepare for submission',
    [AppleAppStoreState.MetadataRejected]: 'Metadata rejected',
    [AppleAppStoreState.InvalidBinary]: 'Invalid binary',
    [AppleAppStoreState.ReplacedWithNewVersion]: 'Replaced with new version',
    [AppleAppStoreState.WaitingForExportCompliance]: 'Waiting for export compliance',
    [AppleAppStoreState.PendingContract]: 'Pending contract',
    [AppleAppStoreState.RemovedFromSale]: 'Removed from sale',
    [AppleAppStoreState.DeveloperRemovedFromSale]: 'Developer removed from sale',
    [AppleAppStoreState.ReadyForReview]: 'Prepare for submission',
    [GooglePlayStoreState.Completed]: 'Completed',
    [GooglePlayStoreState.StatusUnspecified]: 'Status unspecified',
    [GooglePlayStoreState.Draft]: 'Draft',
    [GooglePlayStoreState.InProgress]: 'In progress',
    [GooglePlayStoreState.Halted]: 'Halted',
    [GooglePlayReleaseLifecycleState.Unspecified]: 'Status unspecified',
    [GooglePlayReleaseLifecycleState.Draft]: 'Draft',
    [GooglePlayReleaseLifecycleState.NotSentForReview]: 'Not sent for review',
    [GooglePlayReleaseLifecycleState.InReview]: 'In review',
    [GooglePlayReleaseLifecycleState.ApprovedNotPublished]: 'Approved but not published',
    [GooglePlayReleaseLifecycleState.NotApproved]: 'Not approved',
    [GooglePlayReleaseLifecycleState.Published]: 'Published',
    [AmazonAppStoreState.Completed]: 'Completed',
    [AmazonAppStoreState.InProgress]: 'In progress',
    [AmazonAppStoreState.Live]: 'Live',
    [AmazonAppStoreState.Submitted]: 'Submitted',
    [AmazonAppStoreState.NotReadyToSubmit]: 'Not ready to submit',
    [AmazonAppStoreState.ReadyToSubmit]: 'Ready to submit',
    [AmazonAppStoreState.Review]: 'Waiting for review',
    [HuaweiAppStoreState.Released]: 'Released',
    [HuaweiAppStoreState.ReleaseRejected]: 'Release rejected',
    [HuaweiAppStoreState.Removed]: 'Removed',
    [HuaweiAppStoreState.Releasing]: 'Releasing',
    [HuaweiAppStoreState.Reviewing]: 'Reviewing',
    [HuaweiAppStoreState.Updating]: 'Updating',
    [HuaweiAppStoreState.RemovalRequested]: 'Removal requested',
    [HuaweiAppStoreState.Draft]: 'Draft',
    [HuaweiAppStoreState.UpdateRejected]: 'Update rejected',
    [HuaweiAppStoreState.RemovalRejected]: 'Removal rejected',
    [HuaweiAppStoreState.RemovedByDeveloper]: 'Removed by developer',
    [HuaweiAppStoreState.ReleaseCanceled]: 'Release canceled',
    [SamsungAppStoreState.Registering]: 'Registering',
    [SamsungAppStoreState.ForSale]: 'For sale',
    [SamsungAppStoreState.ReadyForChange]: 'Ready for change',
    [SamsungAppStoreState.ReadyToPreExamination]: 'Ready for pre-examination',
    [SamsungAppStoreState.ReadyToPreReviews]: 'Ready to pre-reviews',
    [SamsungAppStoreState.UnderPreReviews]: 'Under pre-reviews',
    [SamsungAppStoreState.ReadyForContentReview]: 'Ready for content review',
    [SamsungAppStoreState.UnderContentReview]: 'Under content review',
    [SamsungAppStoreState.ReadyForDeviceTest]: 'Ready for device test',
    [SamsungAppStoreState.UnderDeviceTest]: 'Under device test',
    [SamsungAppStoreState.ReadyForTestConfirmation]: 'Ready for test confirmation',
    [SamsungAppStoreState.UnderTestConfirmation]: 'Under test confirmation',
    [SamsungAppStoreState.Canceled]: 'Canceled',
};

export const STRING_FOR_APP_STORE_REVIEW_SUBMISSION_STATE: Record<AppStoreReviewSubmissionState, string> = {
    [AppStoreReviewSubmissionState.ReadyForReview]: 'Ready to submit',
    [AppStoreReviewSubmissionState.WaitingForReview]: 'Waiting for review',
    [AppStoreReviewSubmissionState.InReview]: 'In review',
    [AppStoreReviewSubmissionState.UnresolvedIssues]: 'Unresolved issues',
    [AppStoreReviewSubmissionState.Canceling]: 'Canceling',
    [AppStoreReviewSubmissionState.Completing]: 'Completing',
    [AppStoreReviewSubmissionState.Complete]: 'Approved',
    [AppStoreReviewSubmissionState.Blocked]: 'Blocked',
};

export const STRING_FOR_PHASED_RELEASE_STATE: Record<PhasedReleaseState | GooglePlayReleaseLifecycleState, string> = {
    [AppleAppStorePhasedReleaseState.Inactive]: 'inactive',
    [AppleAppStorePhasedReleaseState.Active]: 'active',
    [AppleAppStorePhasedReleaseState.Paused]: 'paused',
    [AppleAppStorePhasedReleaseState.Complete]: 'complete',
    [GooglePlayStoreState.StatusUnspecified]: 'status unspecified',
    [GooglePlayStoreState.Draft]: 'draft',
    [GooglePlayStoreState.InProgress]: 'in progress',
    [GooglePlayStoreState.Halted]: 'halted',
    [GooglePlayStoreState.Completed]: 'completed',
    [GooglePlayReleaseLifecycleState.Unspecified]: 'status unspecified',
    [GooglePlayReleaseLifecycleState.Draft]: 'draft',
    [GooglePlayReleaseLifecycleState.NotSentForReview]: 'not sent for review',
    [GooglePlayReleaseLifecycleState.InReview]: 'in review',
    [GooglePlayReleaseLifecycleState.ApprovedNotPublished]: 'approved but not published',
    [GooglePlayReleaseLifecycleState.NotApproved]: 'not approved',
    [GooglePlayReleaseLifecycleState.Published]: 'published',
    [HuaweiPhasedReleaseState.Suspended]: 'suspended',
    [HuaweiPhasedReleaseState.Canceled]: 'canceled',
    [HuaweiPhasedReleaseState.Draft]: 'draft',
    [HuaweiPhasedReleaseState.Released]: 'released',
};

export const displayTextForCodePromotionStatus: (status: KickoffActionStatus) => string = (
    status: KickoffActionStatus,
) => {
    switch (status) {
        case KickoffActionStatus.Detected:
            return 'Code promotion detected';
        case KickoffActionStatus.NotDetected:
            return 'Code promotion not detected';
        case KickoffActionStatus.Incomplete:
            return 'Code promotion incomplete, review needed';
    }
};

export const displayTextForBumpVersionStatus: (status: KickoffActionStatus) => string = (
    status: KickoffActionStatus,
) => {
    switch (status) {
        case KickoffActionStatus.Detected:
            return 'Bumped';
        case KickoffActionStatus.NotDetected:
            return 'Not bumped';
        case KickoffActionStatus.Incomplete:
            return 'Bump incomplete, review needed';
    }
};

export const betaIntegrationTypeSupportsIndividualTesters: (integrationType: IntegrationType) => boolean = (
    integrationType,
) => {
    switch (integrationType) {
        case IntegrationType.AppCenterBeta:
        case IntegrationType.TestFlight:
        case IntegrationType.FirebaseBeta:
        case IntegrationType.RunwayBuildDistroBeta:
            return true;
        case IntegrationType.GoogleBeta:
            return false;
        default:
            return false;
    }
};

export const getAvailableAppsFromAppDataMap: (args: {
    appDataMap: Record<string, UserAppData>;
    appIds: string[];
}) => UserAppData[] = ({ appDataMap: appEntityMap, appIds }) => {
    if (!appIds || appIds.length === 0) {
        return [];
    }
    return appIds.map((appId) => appEntityMap[appId]).filter((app) => !!app);
};

export type EffectiveAppInfo = {
    appId: string;
    inherited: boolean;
    inheritedFromGroups?: string[];
};

// Returns the union of direct grants and group-inherited grants. Direct grants always win over group grants.
export const getEffectiveAppsForUser = (
    user: { appIds?: string[]; groups?: UserGroupId[] } | null | undefined,
    orgGroupsById: Record<UserGroupId, UserGroup>,
): EffectiveAppInfo[] => {
    if (!user) {
        return [];
    }
    const directAppIds = new Set(user.appIds ?? []);
    const byAppId: Record<string, EffectiveAppInfo> = {};
    const result: EffectiveAppInfo[] = [];
    for (const appId of user.appIds ?? []) {
        const info: EffectiveAppInfo = { appId, inherited: false };
        byAppId[appId] = info;
        result.push(info);
    }
    for (const groupId of user.groups ?? []) {
        const group = orgGroupsById[groupId];
        if (!group) continue;
        for (const appId of group.appIds ?? []) {
            if (directAppIds.has(appId)) continue;
            const existing = byAppId[appId];
            if (existing) {
                existing.inheritedFromGroups = [...(existing.inheritedFromGroups ?? []), group.name];
            } else {
                const info: EffectiveAppInfo = {
                    appId,
                    inherited: true,
                    inheritedFromGroups: [group.name],
                };
                byAppId[appId] = info;
                result.push(info);
            }
        }
    }
    return result;
};

export const computeCompletedChecklistItemsCount: (items: ChecklistItem[]) => number = (items) => {
    return items.reduce((completedCount, item) => {
        if (item.status) {
            const isCompletedStatus = isCompleteChecklistItemStatus(item.status.status);

            if (isCompletedStatus) {
                return completedCount + 1;
            } else {
                return completedCount;
            }
        }

        return completedCount;
    }, 0);
};

export const betaIntegrationTypeIsAppStore: (integrationType: IntegrationType) => boolean = (integrationType) => {
    switch (integrationType) {
        case IntegrationType.TestFlight:
        case IntegrationType.GoogleBeta:
            return true;
        case IntegrationType.AppCenterBeta:
        case IntegrationType.FirebaseBeta:
            return false;
        default:
            return false;
    }
};

export const extendedStatTypeForReleaseStatistic = (stat: Statistic): ExtendedStatisticType => {
    if (stat.category !== StatisticCategory.StabilityAndHealth) {
        return stat.type;
    }
    return makeExtendedStatType(stat.type, stat.additionalData?.integrationId, stat.additionalData?.eventName);
};

export const extendedStatisticTypeForMonitoringMetric = (
    type: AppMonitoringHealthMetricType,
    integrationId: IntegrationType,
    eventName?: string,
): ExtendedStatisticType => {
    const baseType = statTypeForMonitoringMetricType(type);
    switch (type) {
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUser:
        case ObservabilityAndAnalyticsMetricType.EventsPerSession:
            return makeExtendedStatType(baseType, integrationId, eventName);
    }
    return baseType;
};

const makeExtendedStatType = (
    base: StatisticType,
    integrationId: IntegrationType | undefined,
    eventName?: string,
): ExtendedStatisticType => {
    if (eventName) {
        return `${base}.${integrationId}.${eventName}`;
    }
    return `${base}.${integrationId}`;
};

export const statTypeForMonitoringMetricType = (type: AppMonitoringHealthMetricType): StatisticType => {
    switch (type) {
        case StabilityMetricType.UserStability:
        case StabilityMetricType.UserStabilityDeltaFromPreviousPercentage:
        case StabilityMetricType.UserStabilityDeltaFromPreviousValue:
        case StabilityMetricType.MergedUserStability:
            return StatisticType.CrashFreeUsers;
        case StabilityMetricType.SessionStability:
        case StabilityMetricType.SessionStabilityDeltaFromPreviousPercentage:
        case StabilityMetricType.SessionStabilityDeltaFromPreviousValue:
        case StabilityMetricType.MergedSessionStability:
            return StatisticType.CrashFreeSessions;
        case StabilityMetricType.AdoptionRate:
            return StatisticType.RawValue;
        case UserRatingsMetricType.AvgUserRating:
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousPercentage:
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousValue:
            return StatisticType.StatAverageCustomerRating;
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUser:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousValue:
            return StatisticType.AverageEventsPerDailyActiveUser;
        case ObservabilityAndAnalyticsMetricType.EventsPerSession:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousValue:
            return StatisticType.AverageEventsPerSession;
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValues:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousValue:
            return StatisticType.AveragePropertyValues;
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValues:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousValue:
            return StatisticType.MedianPropertyValues;
        case ObservabilityAndAnalyticsMetricType.P90PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousValue:
            return StatisticType.P90PropertyValues;
        case ObservabilityAndAnalyticsMetricType.P95PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousValue:
            return StatisticType.P95PropertyValues;
        case ObservabilityAndAnalyticsMetricType.P99PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousValue:
            return StatisticType.P99PropertyValues;
        case ObservabilityAndAnalyticsMetricType.GenericObaaValue:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousValue:
            return StatisticType.RawValue;
        case ObservabilityAndAnalyticsMetricType.Composed:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousValue:
            return StatisticType.Composed;
    }
};

export const unitForMonitoringMetricType = (type: AppMonitoringHealthMetricType): StatisticUnit => {
    switch (type) {
        case StabilityMetricType.UserStability:
        case StabilityMetricType.UserStabilityDeltaFromPreviousPercentage:
        case StabilityMetricType.UserStabilityDeltaFromPreviousValue:
        case StabilityMetricType.MergedUserStability:
        case StabilityMetricType.SessionStability:
        case StabilityMetricType.SessionStabilityDeltaFromPreviousPercentage:
        case StabilityMetricType.SessionStabilityDeltaFromPreviousValue:
        case StabilityMetricType.MergedSessionStability:
        case StabilityMetricType.AdoptionRate:
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousPercentage:
            return StatisticUnit.Percent;
        case UserRatingsMetricType.AvgUserRating:
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousValue:
            return StatisticUnit.Rating;
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUser:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.EventsPerSession:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValues:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValues:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValue:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.Composed:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousValue:
            return StatisticUnit.Count;
    }
};

export const limitsPerUnit = (unit: StatisticUnit): [number | null, number | null] => {
    switch (unit) {
        case StatisticUnit.Percent:
            return [0, 100];
        case StatisticUnit.Rating:
            return [0, 5];
        default:
            return [null, null];
    }
};

export const specificUnitForMetricType: (type: AppMonitoringHealthMetricType) => string = (type) => {
    switch (type) {
        case StabilityMetricType.SessionStability:
        case StabilityMetricType.MergedSessionStability:
        case StabilityMetricType.MergedUserStability:
        case UserRatingsMetricType.AvgUserRating:
        case StabilityMetricType.UserStability:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValues:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValues:
        case ObservabilityAndAnalyticsMetricType.EventsPerSession:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUser:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValues:
            return '';
        case StabilityMetricType.SessionStabilityDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousPercentage:
        case StabilityMetricType.UserStabilityDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousPercentage:
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousPercentage:
            return '(delta as %)';
        case StabilityMetricType.SessionStabilityDeltaFromPreviousValue:
        case UserRatingsMetricType.AvgUserRatingDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousValue:
        case StabilityMetricType.UserStabilityDeltaFromPreviousValue:
            return '(delta)';
        default:
            return '';
    }
};

export const metricTypeSupportsBenchmark = (type: AppMonitoringHealthMetricType): boolean => {
    switch (type) {
        case StabilityMetricType.AdoptionRate:
        case StabilityMetricType.SessionStability:
        case StabilityMetricType.UserStability:
        case StabilityMetricType.MergedSessionStability:
        case StabilityMetricType.MergedUserStability:
        case UserRatingsMetricType.AvgUserRating:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUser:
        case ObservabilityAndAnalyticsMetricType.EventsPerSession:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValues:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValues:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValues:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValue:
        case ObservabilityAndAnalyticsMetricType.Composed:
            return true;
        default:
            return false;
    }
};

export const currentReleaseSeriesLabelForMetricType = (type: AppMonitoringHealthMetricType): string => {
    switch (type) {
        case StabilityMetricType.AdoptionRate:
            return 'Current release adoption';
        case StabilityMetricType.SessionStability:
        case StabilityMetricType.MergedSessionStability:
            return 'Current release session stability';
        case StabilityMetricType.UserStability:
        case StabilityMetricType.MergedUserStability:
            return 'Current release user stability';
        case UserRatingsMetricType.AvgUserRating:
            return 'Current release rating';
        default:
            return 'Current release';
    }
};

export const requiredCapabilityForMonitoringMetricCategory: (
    category: AppMonitoringHealthMetricCategory,
) => IntegrationCapability = (category) => {
    switch (category) {
        case AppMonitoringHealthMetricCategory.ObservabilityAndAnalytics:
            return IntegrationCapability.ObservabilityAndAnalytics;
        case AppMonitoringHealthMetricCategory.Stability:
            return IntegrationCapability.StabilityMonitoring;
        case AppMonitoringHealthMetricCategory.UserReviews:
            return IntegrationCapability.AppStore;
    }
};

export const automationConditionsForAutomationType: (
    type: AutomationType,
    appStoreType: AppStoreType,
) => MonitoringAutomationConditionType[] = (type, appStoreType) => {
    switch (appStoreType) {
        case AppStoreType.Apple:
            return [MonitoringAutomationConditionType.Adoption, MonitoringAutomationConditionType.PhasedReleaseDay];
        case AppStoreType.Google:
            return [
                MonitoringAutomationConditionType.Adoption,
                MonitoringAutomationConditionType.StagedRolloutPercentage,
            ];
        case AppStoreType.Huawei:
            return [MonitoringAutomationConditionType.StagedRolloutPercentage];
        case AppStoreType.Amazon:
        case AppStoreType.Samsung:
            return [];
        default:
            return [MonitoringAutomationConditionType.Adoption];
    }
};

export const categoryForAutomation: (automation: AutomationType) => AutomationCategory = (automation) => {
    switch (automation) {
        case AutomationType.AutoBumpVersion:
        case AutomationType.AutoBackmergeReleaseBranches:
        case AutomationType.AutoPromoteStablePhasedReleases:
        case AutomationType.AutoHaltUnstablePhasedReleases:
        case AutomationType.AutoCreateReleaseChannels:
        case AutomationType.AutoKickoffRelease:
        case AutomationType.AutoRelease:
        case AutomationType.AutoSubmitRelease:
        case AutomationType.AutoKickoffTriggerWorkflow:
        case AutomationType.AutoTriggerCIWorkflow:
        case AutomationType.AutoCreateIncidents:
        case AutomationType.AutoUploadBinaryArtifactToAppStore:
        case AutomationType.AutoUploadDsymsToStabilityMonitoring:
        case AutomationType.AutoCherryPickFromWorkingBranch:
        case AutomationType.AutoDistributeReleaseSummary:
        case AutomationType.AutoResignRollbackBuild:
        case AutomationType.AutoPrepareRollbackRelease:
        case AutomationType.AutoCreateTestRuns:
        case AutomationType.AutoSyncTranslations:
        case AutomationType.AutoSyncMetadataTranslations:
        case AutomationType.AutoPostBuildInfoOnPMTickets:
            return AutomationCategory.ReleaseCycle;
        case AutomationType.AutoCreateAppStoreVersions:
        case AutomationType.AutoSelectLatestBuild:
        case AutomationType.AutoApplyMetadata:
        case AutomationType.AutoApplyReviewAttachments:
        case AutomationType.AutoStagedRollout:
        case AutomationType.AutoSyncMetadataFromVCS:
            return AutomationCategory.AppStoreTasks;
        case AutomationType.AutoSubmitBetaBuilds:
        case AutomationType.AutoAssignBetaBuilds:
        case AutomationType.AutoApplyBetaBuildNotes:
        case AutomationType.AutoPromoteBuildsToTestTrack:
        case AutomationType.AutoSyncAppleDevices:
        case AutomationType.AutoSyncAppleProvisioningProfilesDevices:
            return AutomationCategory.BetaTesting;
        case AutomationType.AutoAddMissingFAs:
        case AutomationType.AutoTagReleases:
        case AutomationType.AutoUploadReleaseAssets:
        case AutomationType.AutoDeleteReleaseBranch:
        case AutomationType.AutoCompleteIssueTrackingReleases:
        case AutomationType.AutoTransitionIssueTrackingTickets:
        case AutomationType.AutoCherryPickLocalizableStrings:
        case AutomationType.AutoCreatePMTicketOnTriageIssueFixRequest:
        case AutomationType.AutoAssignTriageIssue:
            return AutomationCategory.ReleaseHygiene;
        case AutomationType.AutoSyncAppStoreUsers:
        case AutomationType.AutoMergeRunwayPRs:
        case AutomationType.AutoCreateRunwayReleases:
        case AutomationType.AutoDownloadArtifacts:
        case AutomationType.AutoSyncSlackGroups:
        case AutomationType.AutoSyncSlackPilotUserGroup:
        case AutomationType.AutoSyncTeamsTags:
        case AutomationType.AutoSyncTeamsPilotTag:
        case AutomationType.AutoTranslateUserReviews:
            return AutomationCategory.General;
        default:
            return AutomationCategory.Unknown;
    }
};

export const categoryForAppNotification = (
    appNotificationId: AppNotificationType | BuildDistroNotificationType,
): AppNotificationCategory | null => {
    switch (appNotificationId) {
        case AppNotificationType.TargetKickoffReminder:
        case AppNotificationType.ReleaseKickoff:
        case AppNotificationType.ReleaseKickoffFailed:
        case AppNotificationType.BumpVersionPRMerged:
        case AppNotificationType.NextUpPilotReminder:
        case AppNotificationType.PauseResumeScheduleCadence:
        case AppNotificationType.VcsDistributionPublished:
        case AppNotificationType.ManualSubmitToAppStore:
        case AppNotificationType.TargetSubmitReminder:
        case AppNotificationType.AutoSubmitToAppStore:
        case AppNotificationType.AutoSubmitFailedIncompleteSteps:
        case AppNotificationType.AutoSubmitFailed:
        case AppNotificationType.AppStoreStatusUpdate:
        case AppNotificationType.TargetReleaseReminder:
        case AppNotificationType.ManualReleaseToAppStore:
        case AppNotificationType.AutoReleaseToAppStore:
        case AppNotificationType.AutoReleaseFailedIncompleteSteps:
        case AppNotificationType.AutoReleaseFailed:
        case AppNotificationType.AppStorePhasedReleaseUpdate:
        case AppNotificationType.AppStorePhasedReleaseComplete:
        case AppNotificationType.UnstablePhasedReleaseHalted:
        case AppNotificationType.StablePhasedReleasePromoted:
        case AppNotificationType.GoogleCustomStagedRolloutManuallyStarted:
        case AppNotificationType.GoogleCustomStageRolloutFailedToStart:
        case AppNotificationType.ReleaseComplete:
            return AppNotificationCategory.ReleaseCycle;
        case AppNotificationType.DailyUserReviewsDigest:
        case AppNotificationType.IndividualReview:
        case AppNotificationType.WeeklyUserReviewsIssuesDigest:
            return AppNotificationCategory.AppReviews;
        case AppNotificationType.ReleaseAnnouncement:
            return AppNotificationCategory.ReleaseAnnouncement;
        case AppNotificationType.ChecklistItemIncomplete:
        case AppNotificationType.ChecklistItemApproved:
        case AppNotificationType.ChecklistItemComment:
        case AppNotificationType.ChecklistItemsReminder:
        case AppNotificationType.RegressionItemsReminder:
        case AppNotificationType.ApprovalItemsReminder:
        case AppNotificationType.ChecklistItemOwnerChanged:
        case AppNotificationType.ChecklistItemReminder:
        case AppNotificationType.BulkApproveChecklistItems:
            return AppNotificationCategory.ChecklistItems;
        case AppNotificationType.BetaReadyForInternalTesting:
        case AppNotificationType.BetaSubmittedForReview:
        case AppNotificationType.BetaReadyForExternalTesting:
        case AppNotificationType.BetaSoakStart:
        case AppNotificationType.BetaSoakEnd:
        case AppNotificationType.BetaSoakManualEnd:
        case AppNotificationType.BetaBuildAvail:
        case AppNotificationType.RegStatusUpdate:
            return AppNotificationCategory.Testing;
        case AppNotificationType.BuildStarted:
        case AppNotificationType.BuildStopped:
        case AppNotificationType.BuildFailed:
        case AppNotificationType.BuildAvail:
        case AppNotificationType.BuildAvailArtifacts:
        case AppNotificationType.ProductionWorkflowSucceeded:
        case AppNotificationType.AutoUploadBuildToAppStoreFailed:
        case AppNotificationType.AutoUploadBuildToAppStoreSucceeded:
        case AppNotificationType.BundleSizeIncrease:
            return AppNotificationCategory.Builds;
        case AppNotificationType.StepApproval:
        case AppNotificationType.FrNotReady:
        case AppNotificationType.FaApplied:
        case AppNotificationType.FrReady:
        case AppNotificationType.MetadataEditable:
        case AppNotificationType.MetaDataApplied:
        case AppNotificationType.AutoCreatedIncident:
        case AppNotificationType.ReleaseTagged:
        case AppNotificationType.ReleaseAutotagFail:
        case AppNotificationType.SetSelectedBuildAppStore:
        case AppNotificationType.HealthMetricsWarning:
        case AppNotificationType.AutoMergeFailure:
            return AppNotificationCategory.ReleaseProcessTasks;
        default:
            return null;
    }
};

export const baseUrlWithQueryParams: (baseUrl: string, queryParams: Record<string, unknown>) => string = (
    baseUrl,
    queryParams,
) => {
    const encodedParams = qs.stringify(queryParams);

    return `${baseUrl}?${encodedParams}`;
};

export const orgOverviewStatsRequestId = (filters: OrgOverviewFilters): string | null => {
    if (filters.orgId) {
        return `org-${filters.orgId}`;
    } else if (filters.appGroupId) {
        return `appGroup-${filters.appGroupId}`;
    } else if (filters.appId) {
        return `app-${filters.appId}`;
    }

    return null;
};

// whether the release step is of the general "release"/"takeoff" step type (this varies across platforms)

export const isReleaseStepType: (type: ReleaseStepType) => boolean = (type) => {
    return [ReleaseStepType.Takeoff, ReleaseStepType.VCSDistribution, ReleaseStepType.CIDistribution].includes(type);
};

export const displayTextForIntegrationStatus = (integration: Integration, allowIncompleteData = false) => {
    if (integration.integrationError) {
        switch (integration.integrationError.status) {
            case IntegrationErrorType.AuthInvalid:
                return 'Invalid auth';
            case IntegrationErrorType.IncompleteData:
                if (allowIncompleteData) {
                    break;
                }
                return 'Setup incomplete';
            case IntegrationErrorType.IncorrectData:
                return 'Review settings';
            case IntegrationErrorType.Unreachable:
                return 'Unreachable';
            case IntegrationErrorType.InternalError:
                return 'Internal error';
        }
    }
    return 'Connected';
};

export const tagColorForIntegrationStatus = (integration: Integration, allowIncompleteData = false) => {
    if (integration.integrationError) {
        switch (integration.integrationError.status) {
            case IntegrationErrorType.AuthInvalid:
                return runwayColors.statusYellow;
            case IntegrationErrorType.IncompleteData:
                if (allowIncompleteData) {
                    break;
                }
                return runwayColors.statusYellow;
            case IntegrationErrorType.IncorrectData:
                return runwayColors.statusYellow;
            case IntegrationErrorType.InternalError:
            case IntegrationErrorType.Unreachable:
                return runwayColors.statusRed;
        }
    }
    return runwayColors.statusGreen;
};

export const sanitizeTrackName: (trackName: string) => string = (trackName) => {
    const lowercasedTrack = trackName?.toLowerCase();

    // always send lowercased default tracks, but custom tracks keep their casing
    switch (lowercasedTrack) {
        case 'internal':
        case 'alpha':
            return lowercasedTrack;
        default:
            return trackName;
    }
};

export const getLowestPlanWithFeature = (params: {
    feature?: SubscriptionFeatureType;
    automationType?: AutomationType;
    integrationCapability?: IntegrationCapability;
    featuresAndCapabilitiesPerSubscriptionStatus: Record<SubscriptionStatus, SubscriptionFeaturesAndCapabilities>;
}): SubscriptionStatus | null => {
    const { feature, automationType, integrationCapability, featuresAndCapabilitiesPerSubscriptionStatus } = params;

    const planHierarchy = [
        SubscriptionStatus.CustomerTeam,
        SubscriptionStatus.CustomerBusiness,
        SubscriptionStatus.CustomerEnterprise,
    ];

    for (const plan of planHierarchy) {
        let relevantMap: Partial<
            Record<SubscriptionFeatureType | AutomationType | IntegrationCapability, unknown>
        > | null = null;

        const currentFeaturesAndCapabilities = featuresAndCapabilitiesPerSubscriptionStatus[plan];

        if (feature) {
            // special case for add apps, return first plan
            if (feature === SubscriptionFeatureType.AddApps) {
                return plan;
            }

            relevantMap = currentFeaturesAndCapabilities.disabledOrLimitedFeaturesMap;
            if (relevantMap && !relevantMap[feature]) {
                return plan;
            }
        }
        if (automationType) {
            relevantMap = currentFeaturesAndCapabilities.disabledAutomationsMap;
            if (relevantMap && !relevantMap[automationType]) {
                return plan;
            }
        }
        if (integrationCapability) {
            relevantMap = currentFeaturesAndCapabilities.disabledIntegrationCapabilitiesMap;
            if (relevantMap && !relevantMap[integrationCapability]) {
                return plan;
            }
        }
    }

    return null;
};

export const screenshotSpecificationsURLForPlatform = (platform: AppPlatform): string | null => {
    switch (platform) {
        case AppPlatform.TvOS:
        case AppPlatform.Ios:
        case AppPlatform.VisionOS:
            return 'https://developer.apple.com/help/app-store-connect/reference/screenshot-specifications/';
        case AppPlatform.WearOS:
        case AppPlatform.Android:
            return 'https://support.google.com/googleplay/android-developer/answer/9866151?hl=en#zippy=%2Cscreenshots';
        default:
            return null;
    }
};

export const isStabilityMonitoringService: (integrationId: IntegrationType) => boolean = (id) => {
    switch (id) {
        case IntegrationType.Sentry:
        case IntegrationType.Bugsnag:
        case IntegrationType.Firebase:
        case IntegrationType.EmbraceStabilityMonitoring:
        case IntegrationType.DatadogStabilityMonitoring:
        case IntegrationType.DynatraceStabilityMonitoring:
            return true;
        default:
            return false;
    }
};

export const isCalendarService: (integrationId: IntegrationType) => boolean = (id) => {
    switch (id) {
        case IntegrationType.GoogleCalendar:
        case IntegrationType.GooglePersonalCalendar:
            return true;
        default:
            return false;
    }
};

export const isAppDistributionService: (integrationId: IntegrationType) => boolean = (id) => {
    switch (id) {
        case IntegrationType.Apple:
        case IntegrationType.Google:
        case IntegrationType.TestFlight:
        case IntegrationType.GoogleBeta:
        case IntegrationType.Samsung:
        case IntegrationType.Amazon:
            return true;
        default:
            return false;
    }
};

export const getAllowedMobileRoutes = () => {
    return [
        routes.buildDetails,
        routes.appBuilds,
        routes.appBucket,
        routes.sharedWithMeBucket,
        routes.user,
        routes.mobile,
        routes.mobileAddTestDevice,
    ];
};

export const getShouldDisableInstallationForBinaryType: (type: BuildArtifactType) => boolean = (type) => {
    switch (type) {
        case BuildArtifactType.IOSAppStore:
        case BuildArtifactType.AndroidDebuggableUnsigned:
        case BuildArtifactType.AndroidReleaseUnsigned:
        case BuildArtifactType.AndroidAAB:
            return true; // app store builds can only be installed via testflight, unsigned APKs cannot be installed directly, AABs aren't installable files
        default:
            return false;
    }
};

export const showArtifactsModuleEvenIfEmpty: (
    artifactUploadAutomations: Partial<Record<AutomationType, Automation>>,
) => boolean = (artifactUploadAutomations) => {
    if (
        artifactUploadAutomations.AutoUploadDsymsToStabilityMonitoring?.enabled ||
        artifactUploadAutomations.AutoUploadBinaryArtifactToAppStore?.enabled ||
        artifactUploadAutomations.AutoDownloadArtifacts?.enabled
    ) {
        return true;
    }

    return false;
};

export const getSeparatedWorkflowFields: (
    workflowEnabledSteps: WorkflowEnabledSteps,
    integration: Integration,
    platform: AppPlatform,
    appStoreType: AppStoreType,
    appId: string,
    appName: string,
    forBuildDistro: boolean,
    integrationProvider?: IntegrationProvider,
    bitriseIsPipeline?: boolean,
    bitriseIsPipelineDev?: boolean,
    bitriseIsPipelineProd?: boolean,
) => {
    workingBranchWorkflowFields: FormFieldData[];
    RCWorkflowFields: FormFieldData[];
    productionWorkflowFields: FormFieldData[];
} = (
    workflowEnabledSteps,
    integration,
    platform,
    appStoreType,
    appId,
    appName,
    forBuildDistro,
    integrationProvider,
    bitriseIsPipeline,
    bitriseIsPipelineDev,
    bitriseIsPipelineProd,
) => {
    let workingBranchWorkflowFields: FormFieldData[] = [];
    let RCWorkflowFields: FormFieldData[] = [];
    let productionWorkflowFields: FormFieldData[] = [];

    if (!integration || !platform) {
        return {
            workingBranchWorkflowFields,
            RCWorkflowFields,
            productionWorkflowFields,
        };
    }

    const originalFields = updateIntegrationFormDataForIntegration(
        integration,
        platform,
        appStoreType,
        appId,
        appName,
        workflowEnabledSteps,
        integrationProvider,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        bitriseIsPipeline,
        bitriseIsPipelineDev,
        bitriseIsPipelineProd,
    );
    const fieldsByName: Record<string, FormFieldData> = {};
    originalFields.map((field) => {
        // no dependencies
        field['extraFormItemProps'] = undefined;
        fieldsByName[field.name] = field;
        return field;
    }) as FormFieldData[];

    switch (integration.id) {
        case IntegrationType.AzureCI: {
            workingBranchWorkflowFields = [fieldsByName['projectIdAndDevWorkflowId']];
            RCWorkflowFields = [
                fieldsByName['projectIdAndWorkflowId'],
                fieldsByName['allowMatchingMultipleAppStoreBuilds'],
            ];
            productionWorkflowFields = [fieldsByName['projectIdAndProdWorkflowId']];
            break;
        }
        case IntegrationType.Codemagic: {
            workingBranchWorkflowFields = [fieldsByName['slugAndDevWorkflowId']];
            RCWorkflowFields = [fieldsByName['slugAndWorkflowId'], fieldsByName['allowMatchingMultipleAppStoreBuilds']];
            productionWorkflowFields = [fieldsByName['slugAndProdWorkflowId']];
            break;
        }
        case IntegrationType.BitbucketCI: {
            workingBranchWorkflowFields = [fieldsByName['devWorkflowId']];
            RCWorkflowFields = [
                fieldsByName['workspaceIdAndRepoId'],
                fieldsByName['workflowId'],
                fieldsByName['allowMatchingMultipleAppStoreBuilds'],
            ];
            productionWorkflowFields = [fieldsByName['prodWorkflowId']];
            break;
        }
        case IntegrationType.Bitrise: {
            if (!forBuildDistro) {
                workingBranchWorkflowFields.push(fieldsByName['bitriseIsPipelineDev']);
            }
            workingBranchWorkflowFields.push(
                fieldsByName['slugAndDevWorkflowId'],
                fieldsByName['appSlugDev'],
                fieldsByName['workflowIdDev'],
            );
            RCWorkflowFields = [
                fieldsByName['bitriseIsPipeline'],
                fieldsByName['slugAndWorkflowId'],
                fieldsByName['appSlug'],
                fieldsByName['workflowId'],
                fieldsByName['allowMatchingMultipleAppStoreBuilds'],
            ];
            productionWorkflowFields = [
                fieldsByName['bitriseIsPipelineProd'],
                fieldsByName['slugAndProdWorkflowId'],
                fieldsByName['appSlugProd'],
                fieldsByName['workflowIdProd'],
            ];
            break;
        }
        case IntegrationType.Buildkite: {
            workingBranchWorkflowFields = [fieldsByName['orgIdAndDevWorkflowId']];
            RCWorkflowFields = [
                fieldsByName['orgIdAndWorkflowId'],
                fieldsByName['allowMatchingMultipleAppStoreBuilds'],
            ];
            productionWorkflowFields = [fieldsByName['orgIdAndProdWorkflowId']];
            break;
        }
        case IntegrationType.CircleCI: {
            workingBranchWorkflowFields = [fieldsByName['devWorkflowId']];
            RCWorkflowFields = [
                fieldsByName['collaborationId'],
                fieldsByName['repoName'],
                fieldsByName['workflowId'],
                fieldsByName['allowMatchingMultipleAppStoreBuilds'],
            ];
            productionWorkflowFields = [fieldsByName['prodWorkflowId']];
            break;
        }
        case IntegrationType.GenericCI: {
            workingBranchWorkflowFields = [fieldsByName['devWorkflowId']];
            RCWorkflowFields = [fieldsByName['workflowId'], fieldsByName['allowMatchingMultipleAppStoreBuilds']];
            productionWorkflowFields = [fieldsByName['prodWorkflowId']];
            break;
        }
        case IntegrationType.GitHubCI: {
            workingBranchWorkflowFields = [fieldsByName['repoNameAndDevWorkflow']];
            RCWorkflowFields = [fieldsByName['repoNameAndWorkflow']];
            productionWorkflowFields = [fieldsByName['repoNameAndProdWorkflow']];
            break;
        }
        case IntegrationType.GitLabCI: {
            workingBranchWorkflowFields = [fieldsByName['devWorkflowId']];
            RCWorkflowFields = [fieldsByName['projectId'], fieldsByName['workflowId']];
            productionWorkflowFields = [fieldsByName['prodWorkflowId']];
            break;
        }
        case IntegrationType.Jenkins: {
            workingBranchWorkflowFields = [fieldsByName['devWorkflowId'], fieldsByName['devSubWorkflowId']];
            RCWorkflowFields = [fieldsByName['workflowId'], fieldsByName['subWorkflowId']];
            productionWorkflowFields = [fieldsByName['prodWorkflowId'], fieldsByName['prodSubWorkflowId']];
            break;
        }
        case IntegrationType.TravisCI: {
            workingBranchWorkflowFields = [];
            RCWorkflowFields = [fieldsByName['repoName'], fieldsByName['allowMatchingMultipleAppStoreBuilds']];
            productionWorkflowFields = [];
            break;
        }
        case IntegrationType.AppCenterCI: {
            workingBranchWorkflowFields = [];
            RCWorkflowFields = [fieldsByName['repoName'], fieldsByName['allowMatchingMultipleAppStoreBuilds']];
            productionWorkflowFields = [];
            break;
        }
        case IntegrationType.XcodeCloud: {
            workingBranchWorkflowFields = [fieldsByName['devProductIdAndWorkflowId']];
            RCWorkflowFields = [
                fieldsByName['productIdAndWorkflowId'],
                fieldsByName['allowMatchingMultipleAppStoreBuilds'],
            ];
            productionWorkflowFields = [fieldsByName['prodProductIdAndWorkflowId']];
            break;
        }
    }

    return {
        workingBranchWorkflowFields: compact(workingBranchWorkflowFields),
        RCWorkflowFields: compact(RCWorkflowFields),
        productionWorkflowFields: compact(productionWorkflowFields),
    };
};

export const defaultAppStoreTypeForPlatform = (platform: AppPlatform) => {
    if (getIsApplePlatform(platform)) {
        return AppStoreType.Apple;
    } else if (isGooglePlatform(platform)) {
        return AppStoreType.Google;
    }
    return null;
};

export const defaultStoreIntegrationForPlatform = (platform: AppPlatform) => {
    if (getIsApplePlatform(platform)) {
        return IntegrationType.Apple;
    } else if (isGooglePlatform(platform)) {
        return IntegrationType.Google;
    }
    return null;
};

export const sortBucketMembers = (a: BucketMember, b: BucketMember) => {
    if (a.type === b.type) {
        return a.id.localeCompare(b.id);
    } else if (a.type === BuildDistroMemberType.User) {
        return -1;
    } else if (b.type === BuildDistroMemberType.User) {
        return 1;
    }

    return 0;
};

export const isBucketAutomation: (automationType: AutomationType) => boolean = (automationType) => {
    switch (automationType) {
        case AutomationType.BAAutoGenerateBuildTesterNotes:
        case AutomationType.BAAutoUpdatePRWithArtifactLink:
        case AutomationType.BAAutoTriggerBuildSystemWorkflow:
        case AutomationType.BAAutoUploadBinaryArtifactToAppStore:
        case AutomationType.BAAutoPostBuildInfoOnPMTickets:
        case AutomationType.BAAutoAssignBetaBuilds:
            return true;
        default:
            return automationType.startsWith('BA_');
    }
};

export const isBucketMember = (user: User, bucket: BuildDistroBucketBase) => {
    for (const member of bucket.members) {
        if (member.type === BuildDistroMemberType.User && member.id === user.id) {
            return true;
        }

        if (member.type === BuildDistroMemberType.Group && user.groups.includes(member.id as UserGroupId)) {
            return true;
        }
    }

    return false;
};

export const isBucketAdmin = (user: User, bucket: BuildDistroBucketBase) => {
    for (const member of bucket.members) {
        if (
            member.type === BuildDistroMemberType.User &&
            member.id === user.id &&
            member.permissionLevel === BuildDistroMemberPermissionLevel.Admin
        ) {
            return true;
        }
    }

    return false;
};

export const buildDistroSharedBuildSort = (a: BuildDistroBuild, b: BuildDistroBuild) => {
    const aShared = a as BuildDistroBuildSharedWithMe;
    const bShared = b as BuildDistroBuildSharedWithMe;
    if (!aShared || !bShared) {
        return buildDistroBuildSort(a, b);
    }
    return dayjs(bShared.sharedOn).unix() - dayjs(aShared.sharedOn).unix();
};

export const buildDistroBuildSort = (a: BuildDistroBuild, b: BuildDistroBuild) => {
    return dayjs(b.uploadedAt).unix() - dayjs(a.uploadedAt).unix();
};

export const buildBucketSort = (a: BuildDistroBucketBase, b: BuildDistroBucketBase) => {
    if (a.explicitSortOrder != null && b.explicitSortOrder != null) {
        return a.explicitSortOrder - b.explicitSortOrder;
    }
    if (a.explicitSortOrder != null && b.explicitSortOrder == null) {
        return -1;
    }
    if (a.explicitSortOrder == null && b.explicitSortOrder != null) {
        return 1;
    }

    if (a.type === b.type) {
        return dayjs(b.createdAt).unix() - dayjs(a.createdAt).unix();
    }

    const typePriorities = {
        [BucketType.RC]: 3,
        [BucketType.Development]: 2,
        [BucketType.Personal]: 1,
    };

    const aTypePriority = typePriorities[a.type] ?? 0;
    const bTypePriority = typePriorities[b.type] ?? 0;
    return bTypePriority - aTypePriority;
};

export const isSameSet: <T>(set1: Set<T>, set2: Set<T>) => boolean = (set1, set2) => {
    if (set1.size !== set2.size) {
        return false;
    }
    for (const item of set1) {
        if (!set2.has(item)) {
            return false;
        }
    }
    return true;
};

export const isIntegrationBuildDistroSupported: (integrationType: IntegrationType) => boolean = (integrationType) => {
    const unsupportedBuildDistroIntegrations = [
        IntegrationType.GenericCI,
        IntegrationType.TravisCI,
        IntegrationType.AppCenterCI,
        IntegrationType.BitbucketCI,
        IntegrationType.CustomCI,
    ];

    return !unsupportedBuildDistroIntegrations.includes(integrationType);
};

export const getIsBuildDistroSupportedPlatform: (platform: AppPlatform) => boolean = (platform) => {
    return [
        AppPlatform.Android,
        AppPlatform.Ios,
        AppPlatform.VisionOS,
        AppPlatform.AndroidSDK,
        AppPlatform.IosSDK,
        AppPlatform.TvOS,
        AppPlatform.WearOS,
        AppPlatform.ReactNativeOTA,
    ].includes(platform);
};

export const shareLink = (url: string) => {
    if (navigator.share && navigator.canShare?.({ url })) {
        navigator
            .share({
                url,
            })
            .catch((err) => {
                // just log to avoid unhandled exception logging to sentry
                console.log(`Error sharing link: ${err}`);
            });
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url);
        globalMessage.success('Copied link to clipboard!');
    }
};

export const isBuildDistroBucketPRRule = (rule: BucketRule): rule is BuildDistroBucketPRRule => {
    return rule.type === BuildDistroBucketRuleType.PR;
};

export const workflowsAndBranchesFromBuildDistroBucketRules = (rules: BucketRule[]): WorkflowAndBranchData[] => {
    if (!rules) {
        return [];
    }

    return rules.map((rule) => {
        const branch = isBuildDistroBucketPRRule(rule) ? rule.baseBranch : rule.branch;
        return {
            workflowName: rule.workflowData?.workflowName ?? '',
            branch,
            vcsUsers: rule.filterByVCSUsers ?? [],
            type: rule.type,
        };
    });
};

export const canInstallMultipleIntegrationsForCapability = (
    capability: IntegrationCapability,
    workflowsMigratedSteps: WorkflowEnabledSteps,
): boolean => {
    switch (capability) {
        case IntegrationCapability.ObservabilityAndAnalytics:
            return true;
        case IntegrationCapability.BetaTesting: {
            return !!workflowsMigratedSteps[ReleaseStepType.BetaTesting];
        }
        case IntegrationCapability.AppStore: {
            return !!(
                workflowsMigratedSteps[ReleaseStepType.Takeoff] ||
                workflowsMigratedSteps[ReleaseStepType.StoreReview] ||
                workflowsMigratedSteps[ReleaseStepType.Submission]
            );
        }
        case IntegrationCapability.BuildSystem: {
            return !!workflowsMigratedSteps[ReleaseStepType.ReleaseCandidate];
        }
        case IntegrationCapability.StabilityMonitoring: {
            return !!workflowsMigratedSteps[ReleaseStepType.Rollout];
        }
        default:
            return false;
    }
};

export const makeEventAndParam = (eventName: string, paramName?: string): EventAndParam => {
    return {
        eventName: eventName,
        paramName: paramName,
    };
};

export const eventNameFromEventAndParam = (eventAndParam: EventAndParam): string => {
    if (!eventAndParam.paramName) {
        return eventAndParam.eventName;
    }
    return `${eventAndParam.eventName} - ${eventAndParam.paramName}`;
};

export const eventIdFromEventAndParam = (eventAndParam: EventAndParam): string => {
    if (!eventAndParam.paramName) {
        return eventAndParam.eventName;
    }
    return `${eventAndParam.eventName}#${eventAndParam.paramName}`;
};

export const separateEventAndParam = (eventId: string): EventAndParam => {
    const eventAndParam = eventId.split('#');
    const eventName = eventAndParam[0];
    const paramName = eventAndParam.length > 1 ? eventAndParam[1] : undefined;

    return {
        eventName,
        paramName,
    };
};

export const doesObaaMetricTypeRequireParam = (metricType: ObservabilityAndAnalyticsMetricType): boolean => {
    switch (metricType) {
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUser:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerActiveUserDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.EventsPerSession:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.EventsPerSessionDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValue:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.GenericObaaValueDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.Composed:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousValue:
            return false;
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValues:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.AveragePropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValues:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.MedianPropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P90PropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P95PropertyValuesDeltaFromPreviousValue:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValues:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.P99PropertyValuesDeltaFromPreviousValue:
            return true;
    }
};

export const isMetricTypeComposed = (metricType: AppMonitoringHealthMetricType): boolean => {
    switch (metricType) {
        case ObservabilityAndAnalyticsMetricType.Composed:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousPercentage:
        case ObservabilityAndAnalyticsMetricType.ComposedDeltaFromPreviousValue:
            return true;
        default:
            return false;
    }
};

type AutoStagedRolloutBlackoutSegmentsByDayValues = Partial<
    Record<
        DayOfTheWeek,
        {
            isBlackedOut: boolean;
            segments: {
                blackoutSegment: [dayjs.Dayjs, dayjs.Dayjs];
            }[];
        }
    >
>;

export const encodeAutoStagedRolloutBlackoutSegmentsByDay = (
    autoStagedRolloutBlackoutSegmentsByDay: AutoStagedRolloutBlackoutSegmentsByDayValues,
    autoStagedRolloutBlackoutTimezone: string,
): AutoStagedRolloutBlackoutSegmentsByDay => {
    return Object.entries(autoStagedRolloutBlackoutSegmentsByDay ?? {}).reduce<AutoStagedRolloutBlackoutSegmentsByDay>(
        (acc, [day, { isBlackedOut = false, segments = [] }]) => {
            return {
                ...acc,
                [day]: {
                    isBlackedOut,
                    segments: segments
                        .filter(({ blackoutSegment }) => blackoutSegment)
                        .map(({ blackoutSegment }) => {
                            return {
                                startTime: blackoutSegment[0]
                                    .tz(autoStagedRolloutBlackoutTimezone || 'UTC', true)
                                    .format(),
                                endTime: blackoutSegment[1]
                                    .tz(autoStagedRolloutBlackoutTimezone || 'UTC', true)
                                    .format(),
                            };
                        }),
                },
            };
        },
        {},
    );
};

export const decodeAutoStagedRolloutBlackoutSegmentsByDay = (
    autoStagedRolloutBlackoutSegmentsByDay: AutoStagedRolloutBlackoutSegmentsByDay,
): AutoStagedRolloutBlackoutSegmentsByDayValues => {
    return Object.entries(
        autoStagedRolloutBlackoutSegmentsByDay ?? {},
    ).reduce<AutoStagedRolloutBlackoutSegmentsByDayValues>((acc, [day, { isBlackedOut = false, segments = [] }]) => {
        return {
            ...acc,
            [day]: {
                isBlackedOut,
                segments: segments.map((blackoutSegment) => {
                    return {
                        blackoutSegment: [
                            dayjs.parseZone(blackoutSegment.startTime),
                            dayjs.parseZone(blackoutSegment.endTime),
                        ] as [dayjs.Dayjs, dayjs.Dayjs],
                    };
                }),
            },
        };
    }, {} as AutoStagedRolloutBlackoutSegmentsByDayValues);
};

export const docsLinkForAutomationType: (automationType: AutomationType) => string = (automationType) => {
    const baseUrl = 'https://docs.runway.team/automations/types-of-automations';
    let hash = '';
    switch (automationType) {
        case AutomationType.AutoSelectLatestBuild:
            hash = `#select-the-latest-build-in-app-store-connect`;
            break;
        case AutomationType.AutoCreateAppStoreVersions:
            hash = '#create-and-sync-app-store-connect-play-console-versions-to-match-current-runway-release';
            break;
        case AutomationType.AutoCreateRunwayReleases:
            hash = '#prepare-next-version-in-runway-when-current-release-is-kicked-off';
            break;
        case AutomationType.AutoTagReleases:
            hash = '#tag-releases-at-the-end-of-the-release-cycle';
            break;
        case AutomationType.AutoMergeRunwayPRs:
            hash = '#merge-pull-requests-opened-by-runway';
            break;
        case AutomationType.AutoAddMissingFAs:
            hash = '#add-missing-labels-or-fix-versions-to-tickets';
            break;
        case AutomationType.AutoDownloadArtifacts:
            hash = '#enable-artifact-downloads';
            break;
        case AutomationType.AutoUploadReleaseAssets:
            hash = '#attach-build-artifacts-to-vcs-release-record-when-tagging';
            break;
        case AutomationType.AutoApplyMetadata:
            hash = '#apply-release-notes-to-new-releases-in-app-store-connect-or-play-console';
            break;
        case AutomationType.AutoKickoffRelease:
            hash = '#kick-off-release-on-target-date';
            break;
        case AutomationType.AutoSubmitRelease:
            hash = '#submit-app-for-review';
            break;
        case AutomationType.AutoRelease:
            hash = '#release-app-on-target-date';
            break;
        case AutomationType.AutoBumpVersion:
            hash = '#bump-version-in-code';
            break;
        case AutomationType.AutoAssignBetaBuilds:
            hash = '#assign-beta-testing-builds-to-default-testing-groups';
            break;
        case AutomationType.AutoSubmitBetaBuilds:
            hash = '#submit-new-builds-for-beta-review';
            break;
        case AutomationType.AutoPromoteBuildsToTestTrack:
            hash = '#promote-new-builds-to-testing-track';
            break;
        case AutomationType.AutoPromoteStablePhasedReleases:
            hash = '#release-stable-phased-releases-staged-rollouts-to-100-of-users';
            break;
        case AutomationType.AutoHaltUnstablePhasedReleases:
            hash = '#halt-unstable-phased-releases';
            break;
        case AutomationType.AutoCreateReleaseChannels:
            hash = '#create-release-specific-channel-s';
            break;
        case AutomationType.AutoCompleteIssueTrackingReleases:
            hash = '#mark-releases-complete-in-project-management-tool';
            break;
        case AutomationType.AutoApplyReviewAttachments:
            hash = '#apply-default-review-attachment-to-new-app-versions-in-app-store-connect';
            break;
        case AutomationType.AutoBackmergeReleaseBranches:
            hash = '#backmerge-changes-from-the-release-branch';
            break;
        case AutomationType.AutoApplyBetaBuildNotes:
            hash = '#carry-over-testflight-what-to-test-notes-or-beta-track-release-notes-to-new-beta-builds';
            break;
        case AutomationType.AutoTriggerCIWorkflow:
            // TODO(RUN-12540): Create a new section for this automation in our documentation
            hash = '#trigger-workflow-after-release-kickoff';
            break;
        case AutomationType.AutoCreateIncidents:
            hash = '#create-incidents-in-scheduling-integration';
            break;
        case AutomationType.AutoKickoffTriggerWorkflow:
            hash = '#trigger-workflow-after-release-kickoff';
            break;
        case AutomationType.AutoSyncAppStoreUsers:
            hash = '#sync-users-and-roles-from-runway-to-app-store-connect-play-console';
            break;
        case AutomationType.AutoDeleteReleaseBranch:
            hash = '#delete-version-specific-release-branches-at-the-end-of-the-release-cycle';
            break;
        case AutomationType.AutoUploadBinaryArtifactToAppStore:
            hash = '#upload-build-artifacts-for-distribution';
            break;
        case AutomationType.AutoUploadDsymsToStabilityMonitoring:
            hash = '#upload-dsyms-to-your-stability-monitoring-provider-ios';
            break;
        case AutomationType.AutoCherryPickFromWorkingBranch:
            hash = '#cherry-pick-work-from-the-working-branch-to-the-release-branch';
            break;
        case AutomationType.AutoTransitionIssueTrackingTickets:
            hash = '#update-status-of-issue-tracking-tickets-upon-release-completion';
            break;
        case AutomationType.AutoDistributeReleaseSummary:
            hash = '#distribute-release-summary-at-the-end-of-each-release-cycle';
            break;
        case AutomationType.AutoPostBuildInfoOnPMTickets:
            hash = '#post-build-info-to-project-management-tickets';
            break;
        case AutomationType.AutoSyncSlackPilotUserGroup:
            hash = '#sync-slack-release-pilot-handle';
            break;
        case AutomationType.AutoSyncTeamsPilotTag:
            hash = '#sync-teams-release-pilot-handle';
            break;
        // Bucket automations
        case AutomationType.BAAutoUpdatePRWithArtifactLink:
            hash = '#post-installation-qr-codes-on-open-prs';
            break;
        case AutomationType.BAAutoGenerateBuildTesterNotes:
            hash = '#generate-tester-notes-from-the-work-items-diff';
            break;
        case AutomationType.BAAutoTriggerBuildSystemWorkflow:
            hash = '#trigger-build-workflow';
            break;
        case AutomationType.BAAutoUploadBinaryArtifactToAppStore:
            hash = '#upload-build-artifacts-for-further-distribution';
            break;
        case AutomationType.BAAutoPostBuildInfoOnPMTickets:
            hash = '#TODO#'; // TODO: Add link
            break;
    }

    return `${baseUrl}${hash}`;
};

export const availableMetricTypesForObservabilityAndAnalyticsIntegration: (
    integration?: Integration,
) => ObservabilityAndAnalyticsMetricType[] = (integration) => {
    if (integration) {
        const metricsData = integration.data as AppMonitoringHealthMetrics;
        if (metricsData && metricsData.supportedMetricTypes) {
            return metricsData.supportedMetricTypes.filter((metric) => {
                const obaaType = metric as ObservabilityAndAnalyticsMetricType;
                return AllObservabilityAndAnalyticsMetricTypes.includes(obaaType);
            }) as ObservabilityAndAnalyticsMetricType[];
        }
    }

    return AllObservabilityAndAnalyticsMetricTypes;
};

export const availableMetricTypesForStabilityMonitoringIntegration: (
    integration: Integration,
) => StabilityMetricType[] = (integration) => {
    if (integration) {
        const metricsData = integration.data as AppMonitoringHealthMetrics;
        if (metricsData && metricsData.supportedMetricTypes) {
            return metricsData.supportedMetricTypes.filter((metric) => {
                const stabMetric = metric as StabilityMetricType;
                return AllStabilityMetricTypes.includes(stabMetric);
            }) as StabilityMetricType[];
        }
    }

    return AllStabilityMetricTypes;
};

export const releaseTypeToCreateEditReleaseType: (releaseType: ReleaseType) => CreateEditReleaseType = (
    releaseType,
) => {
    switch (releaseType) {
        case ReleaseType.Hotfix:
            return CreateEditReleaseType.Hotfix;
        case ReleaseType.Rollback:
            return CreateEditReleaseType.Rollback;
        default:
            return CreateEditReleaseType.Standard;
    }
};

export const getSlackHandleUIFormat: (slackHandle: string) => string = (slackHandle) => {
    if (!slackHandle || slackHandle.trim().length === 0) {
        return '';
    }
    return slackHandle[0] == '@' ? slackHandle : `@${slackHandle}`;
};

export const shouldDisableMetadataScreenshotsEditing = (
    appStoreType: AppStoreType,
    releaseStatus: ReleaseStatus,
    releaseType: ReleaseType,
) => {
    if (releaseType === ReleaseType.Rollback) {
        return true;
    }

    if (appStoreType === AppStoreType.Google) {
        return releaseStatus === ReleaseStatus.Skipped;
    } else {
        return [ReleaseStatus.Completed, ReleaseStatus.Skipped].includes(releaseStatus);
    }
};

export const isReleaseTimelinePhaseCurrentOrRollback: (phase: ReleaseTimelinePhase) => boolean = (phase) => {
    return phase === ReleaseTimelinePhase.Current || phase === ReleaseTimelinePhase.Rollback;
};

export const isReleaseTypeHotfixOrRollback: (type: ReleaseType) => boolean = (type) => {
    return [ReleaseType.Hotfix, ReleaseType.Rollback].includes(type);
};

export const isWearOsTrack: (track: string) => boolean = (track) => {
    return track.startsWith('wear:');
};

export const filterTrackByPlatform: (track: string, platform: AppPlatform) => boolean = (track, platform) => {
    if (platform == AppPlatform.Android) {
        // only non-wear tracks
        return isWearOsTrack(track) === false;
    } else if (platform === AppPlatform.WearOS) {
        return isWearOsTrack(track);
    } else {
        return true;
    }
};

export const syncableProvisioningProfileTypesForPlatform = (platform: AppPlatform) => {
    switch (platform) {
        case AppPlatform.Ios:
        case AppPlatform.VisionOS:
            return [ProvisioningProfileType.IosDevelopment, ProvisioningProfileType.IosAdHoc];
        case AppPlatform.TvOS:
            return [ProvisioningProfileType.TvosDevelopment, ProvisioningProfileType.TvosAppStore];
        default:
            return [];
    }
};

export const appleReleaseTypeForReleaseMethod: (method: ReleaseMethod) => AppleAppStoreReleaseType = (method) => {
    switch (method) {
        case ReleaseMethod.AutomaticOnApproval:
            return AppleAppStoreReleaseType.AfterApproval;
        case ReleaseMethod.AutomaticOnDate:
            return AppleAppStoreReleaseType.Scheduled;
        case ReleaseMethod.Manual:
            return AppleAppStoreReleaseType.Manual;
    }
};

export const releaseMethodForAppleReleaseType: (releaseType: AppleAppStoreReleaseType) => ReleaseMethod = (
    releaseType,
) => {
    switch (releaseType) {
        case AppleAppStoreReleaseType.AfterApproval:
            return ReleaseMethod.AutomaticOnApproval;
        case AppleAppStoreReleaseType.Scheduled:
            return ReleaseMethod.AutomaticOnDate;
        case AppleAppStoreReleaseType.Manual:
            return ReleaseMethod.Manual;
    }
};

export const releaseSettingsNeedPhasedReleaseWarning: (
    platform: AppPlatform,
    isRollback: boolean,
    defaultAppStoreSettings?: AppStoreDefaultSettings,
    releaseSettings?: AppStoreDefaultSettings,
) => boolean = (platform, isRollback, defaultAppStoreSettings, releaseSettings) => {
    if (isGooglePlatform(platform)) {
        const androidAppStoreDefaultSettings = defaultAppStoreSettings as GoogleAppStoreSettings;
        const androidReleaseSettings = releaseSettings as GoogleAppStoreSettings;

        return (
            !!androidReleaseSettings &&
            !!androidAppStoreDefaultSettings &&
            !androidReleaseSettings.stagedRelease &&
            androidAppStoreDefaultSettings.stagedRelease &&
            isRollback
        );
    } else if (getIsApplePlatform(platform)) {
        const iosAppStoreDefaultSettings = defaultAppStoreSettings as AppleAppStoreDefaultSettings;
        const iosReleaseSettings = releaseSettings as AppleAppStoreDefaultSettings;

        return (
            !!iosReleaseSettings &&
            !!iosAppStoreDefaultSettings &&
            !iosReleaseSettings.phasedRelease &&
            iosAppStoreDefaultSettings.phasedRelease &&
            isRollback
        );
    }

    return false;
};

export const groupReleasesByTimelinePhase: (releases: Release[]) => {
    completedReleases: Release[];
    currentReleases: Release[];
    upcomingReleases: Release[];
} = (releases) => {
    const releasesByGroup = groupBy(releases, (release) => release.timelinePhase);

    const rollbacks = releasesByGroup['rollback'];
    let initialCurrentReleases: Release[] = releasesByGroup['current'];

    // rollbacks appear in the same group as the current release
    if (rollbacks) {
        const rollbacksToShow = rollbacks.filter((_release) => {
            // disabling for now to show rollbacks even if the target version isn't completed
            // if (release.createdOrigin === ReleaseCreatedOrigin.AutoCreatedByRunway) {
            // if (release.rollbackTargetVersionInfo) {
            //     // only rollbacks with a completed target version should show
            //     return release.rollbackTargetVersionInfo.status === ReleaseStatus.Completed;
            // }
            //
            // return false; // rollbacks with no target info should be hidden, though this shouldn't happen
            // }

            return true; // rollbacks that were manually created should always be shown
        });

        initialCurrentReleases = [...(releasesByGroup['current'] ?? []), ...rollbacksToShow];
    }

    const completedReleases =
        releasesByGroup['completed'] ?
            releasesByGroup['completed'].sort((releaseA, releaseB) =>
                compareVersions(releaseA.version, releaseB.version),
            )
        :   [];
    const currentReleases =
        initialCurrentReleases ?
            initialCurrentReleases.sort((releaseA, releaseB) => compareVersions(releaseA.version, releaseB.version))
        :   [];
    const upcomingReleases =
        releasesByGroup['upcoming'] ?
            releasesByGroup['upcoming']
                .filter((release) => release.type !== ReleaseType.Rollback) // never want to see rollbacks in this timeline phase
                .sort((releaseA, releaseB) => compareVersions(releaseA.version, releaseB.version))
        :   [];

    return {
        upcomingReleases,
        completedReleases,
        currentReleases,
    };
};

export const updatePilotRotationIndexes = (
    firstCycleRotationValues: ReleasePilotRotationItem[],
    editViewPilots: EditViewPilot[],
): EditViewPilot[] => {
    const editViewPilotRotationIndexes = firstCycleRotationValues.map((obj) => obj.pilotRotationIndex);
    const updatedPilotRotation = editViewPilots.map((obj, index) => {
        return { ...obj, pilotRotationIndex: editViewPilotRotationIndexes[index] ?? obj.pilotRotationIndex };
    });
    return updatedPilotRotation;
};

export const getRequiredIntegrationCapabilitiesForReleaseStep: (
    releaseStepType: ReleaseStepType,
) => IntegrationCapability[] = (releaseStepType) => {
    switch (releaseStepType) {
        case ReleaseStepType.Kickoff:
            return [IntegrationCapability.VersionControl];
        case ReleaseStepType.FeatureReadiness:
            return [IntegrationCapability.VersionControl, IntegrationCapability.FeatureManagement];
        case ReleaseStepType.ReleaseCandidate:
            return [IntegrationCapability.BuildSystem];
        case ReleaseStepType.RegressionTesting:
            return [IntegrationCapability.RegressionTesting];
        case ReleaseStepType.BetaTesting:
            return [IntegrationCapability.BetaTesting];
        case ReleaseStepType.Metadata:
        case ReleaseStepType.Screenshots:
        case ReleaseStepType.Submission:
        case ReleaseStepType.StoreReview:
            return [IntegrationCapability.AppStore];
        default:
            return [];
    }
};

export const getRequiredIntegrationsInErrorStateForReleaseStep: (
    releaseStepType: ReleaseStepType,
    appIntegrations: Integration[],
) => Integration[] = (releaseStepType, appIntegrations) => {
    const requiredIntegrationCapabilitiesForReleaseStep =
        getRequiredIntegrationCapabilitiesForReleaseStep(releaseStepType);

    const appIntegrationsForStepRequiredCapabilities = appIntegrations.filter((integration) =>
        integration.capabilities.some((capability) =>
            requiredIntegrationCapabilitiesForReleaseStep.includes(capability),
        ),
    );
    const requiredIntegrationsInErrorState = appIntegrationsForStepRequiredCapabilities.filter(
        (integration) => integration.integrationError,
    );

    return requiredIntegrationsInErrorState;
};

export const isSubscriptionPlanPaidCustomer: (subscriptionStatus: SubscriptionStatus) => boolean = (
    subscriptionStatus,
) => {
    const paidPlans = [
        SubscriptionStatus.CustomerTeam,
        SubscriptionStatus.CustomerBusiness,
        SubscriptionStatus.CustomerEnterprise,
        SubscriptionStatus.CustomerTeamBD,
        SubscriptionStatus.CustomerBusinessBD,
        SubscriptionStatus.CustomerEnterpriseBD,
    ];

    return paidPlans.includes(subscriptionStatus);
};

export const canPlatformInstallBinaries = (platform: AppPlatform) => {
    switch (platform) {
        case AppPlatform.Ios:
        case AppPlatform.Android:
        case AppPlatform.ReactNativeOTA:
            return true;
        case AppPlatform.WearOS:
        case AppPlatform.AndroidSDK:
        case AppPlatform.IosSDK:
        case AppPlatform.TvOS:
        case AppPlatform.AndroidTV:
        case AppPlatform.VisionOS:
            return false;
        default:
            return false;
    }
};

export const isDoneTranslationStatus = (status: TranslationStringStatus) => {
    switch (status) {
        case TranslationStringStatus.Synced:
        case TranslationStringStatus.Inconclusive:
        case TranslationStringStatus.UnsupportedFileType:
            return true;
        default:
            return false;
    }
};

export const getSortedCommitsOnlyOnWorkingBranch = (
    workingBranchItems: FeatureItem[],
    releaseBranchItems: FeatureItem[],
) => {
    const commitsOnWorkingBranch = workingBranchItems.filter(
        (item) => codeIsCommit(item.code) && item.code.status === FeatureItemCodeStatus.Merged,
    );
    const commitsOnReleaseBranch = releaseBranchItems.filter(
        (item) => codeIsCommit(item.code) && item.code.status === FeatureItemCodeStatus.Merged,
    );

    const commitsOnlyOnWorkingBranch = differenceBy(
        commitsOnWorkingBranch,
        commitsOnReleaseBranch,
        (item) => item.code?.identifier,
    );

    const sortedCommitsOnlyOnWorkingBranch = commitsOnlyOnWorkingBranch.sort((a, b) => {
        if (a.code && b.code && 'committedAt' in a.code && 'committedAt' in b.code) {
            return new Date(b.code.committedAt).getTime() - new Date(a.code.committedAt).getTime();
        }
        return 0;
    });

    return sortedCommitsOnlyOnWorkingBranch;
};

export const getSortedOpenPRs = (
    openPRsAgainstWorkingBranch: FeatureItem[],
    openPRsAgainstReleaseBranch: FeatureItem[],
) => {
    const openPRs = openPRsAgainstWorkingBranch.concat(openPRsAgainstReleaseBranch);

    const sortedOpenPRs = openPRs.sort((a, b) => {
        if (a.code && b.code && 'updatedAt' in a.code && 'updatedAt' in b.code) {
            return new Date(b.code.updatedAt as string).getTime() - new Date(a.code.updatedAt as string).getTime();
        }
        return 0;
    });

    return sortedOpenPRs;
};

export const isMetadataFieldPendingTranslationStatus = (
    status: MetadataTranslationStatus,
    translations: MetadataTranslationLocale,
    localizationsForSourceLocale: LocalizedMetadata,
) => {
    return (
        translations.appName === status ||
        (localizationsForSourceLocale?.description != null && translations.description === status) ||
        (localizationsForSourceLocale?.keywords != null && translations.keywords === status) ||
        (localizationsForSourceLocale?.promotionalText != null && translations.promotionalText === status) ||
        (localizationsForSourceLocale?.shortDescription != null && translations.shortDescription === status) ||
        translations.whatsNew === status ||
        (localizationsForSourceLocale?.subtitle != null && translations.subtitle === status)
    );
};

export const translationIntegrationHasMetadataProject: (integration: Integration) => boolean = (integration) => {
    switch (integration.id) {
        case IntegrationType.Crowdin: {
            const data = integration.data as CrowdinIntegrationData;
            return !!data.selectedMetadataProject;
        }
        case IntegrationType.Lokalise: {
            const data = integration.data as LokaliseIntegrationData;
            return !!data.selectedMetadataProject;
        }
        default:
            return false;
    }
};

export const getIsReleaseAutomationInactiveBecauseOfASCSetting = (
    releaseAutomation: AutomationRun,
    ascData: AppleAppStoreData,
    appStoreType: AppStoreType,
    releaseType: ReleaseType,
): boolean => {
    if (getIsAppleAppStore(appStoreType)) {
        return !!(
            releaseAutomation &&
            automationIsBlocked(releaseAutomation) &&
            ascData &&
            ascData.versionReviewSubmissionItem?.releaseType != AppleAppStoreReleaseType.Manual &&
            releaseType != ReleaseType.Hotfix
        );
    }

    return false;
};

export const isDefaultUserGroup = (userGroup: UserGroup) => {
    return AllDefaultUserGroupIds.includes(userGroup?.id as DefaultUserGroupId);
};

export interface CalendarEventBaseData {
    id: string;
    groupId: string;
    title: string;
    allDay: boolean;
    start: string;
    end?: string;
    backgroundColor: string;
    appId?: string;
}

export interface ReleaseCalendarLifecycleEventData extends CalendarEventBaseData {
    isEventComplete: boolean;
    eventType: LifecycleEventType;
    eventDateType: ReleaseCalendarEventType;
    targetDateSetByCadence: boolean;
    isEventAutomated: boolean;
    displayVersion: string;
    incrementDayNumber?: number;
    stagedRolloutPercentage?: number;
    status: ReleaseStatus;
    stepId?: ReleaseStepType;
    stepConfigId?: string;
    customStepLabel?: string;
    destinationId?: string;
    destinationColor?: string;
    workflowRunId?: string;
    destinationIds?: string[];
    groupedEvents?: ReleaseCalendarLifecycleEventData[];
}

export interface ReleaseCalendarReleaseCycleEventData extends CalendarEventBaseData {
    parentEventColor: string;
    displayVersion: string;
    isReleaseCompleted: boolean;
    canReleaseBeSubmitted: boolean;
    scheduledAutomationsPaused: boolean;
    isHotfix: boolean;
    releasePilotId?: string;
    releaseDescription?: string;
    status: ReleaseStatus;
    eventDateType?: ReleaseCalendarEventType;
}

export interface ReleaseCalendarExternalEventData extends CalendarEventBaseData {
    description?: string;
    organizer?: string;
    link: string;
    eventDateType: ReleaseCalendarEventType;
    connectedIntegrationType: IntegrationType;
}

export interface ReleaseCalendarLifecycleFreezeEventData extends CalendarEventBaseData {
    timezone: string;
    eventDateType: ReleaseCalendarEventType;
}

export interface ReleaseCalendarLifecycleEventDataWithOrder extends ReleaseCalendarLifecycleEventData {
    customOrder: number;
}

export const formatLifecycleEvent = (
    color: string,
    releaseStatus: ReleaseStatus,
    releaseDisplayVersion: string,
    releaseId: string,
    stepLifecycleEvent: ReleaseCalendarLifecycleEvent,
): ReleaseCalendarLifecycleEventData => {
    const isEventComplete = stepLifecycleEvent.dateType === ReleaseCalendarEventType.ReleaseCalendarEventTypeActualDate;
    let eventTitle = displayLifecycleEventName(stepLifecycleEvent.lifecycleEventType);

    if (
        stepLifecycleEvent.lifecycleEventType === LifecycleEventType.LifecycleEventTypeRolloutIncrement &&
        !!stepLifecycleEvent.incrementDayNumber
    ) {
        eventTitle = eventTitle + ' ' + stepLifecycleEvent.incrementDayNumber;
    }

    return {
        id: stepLifecycleEvent.id,
        title: eventTitle,
        start: stepLifecycleEvent.startDate,
        end: stepLifecycleEvent.endDate,
        isEventComplete,
        targetDateSetByCadence: stepLifecycleEvent.targetDateSetByCadence,
        isEventAutomated: !!stepLifecycleEvent.isEventAutomated,
        eventType: stepLifecycleEvent.lifecycleEventType,
        eventDateType: stepLifecycleEvent.dateType,
        groupId: releaseId,
        allDay: false,
        displayVersion: releaseDisplayVersion,
        backgroundColor: color,
        incrementDayNumber: stepLifecycleEvent.incrementDayNumber,
        stagedRolloutPercentage: stepLifecycleEvent.stagedRolloutPercentage,
        status: releaseStatus,
        stepId: stepLifecycleEvent.stepId,
        stepConfigId: stepLifecycleEvent.stepConfigId,
        customStepLabel: stepLifecycleEvent.customStepLabel,
        destinationId: stepLifecycleEvent.destinationId,
        destinationColor: stepLifecycleEvent.destinationColor,
        workflowRunId: stepLifecycleEvent.workflowRunId,
    };
};

export const getExternalEventsForReleaseCalendar = (
    releaseCalendarValues: Record<string, ExternalCalendarEvent>,
    connectedIntegrationType: IntegrationType,
    releaseCycleEvent?: ReleaseCalendarReleaseCycleEventData,
): ReleaseCalendarExternalEventData[] => {
    if (releaseCalendarValues == null) {
        return [];
    }
    let allExternalEvents: ReleaseCalendarExternalEventData[] = [];
    const isAtReleaseLevel = !!releaseCycleEvent;

    const releaseCycleEventStart = releaseCycleEvent ? dayjs(releaseCycleEvent.start) : null;
    const releaseCycleEventEnd = releaseCycleEvent ? dayjs(releaseCycleEvent.end) : null;

    Object.entries(releaseCalendarValues).forEach(([eventId, externalEventCalendarData]) => {
        const externalEventStart = dayjs(externalEventCalendarData.startDate);
        const externalEventEnd = dayjs(externalEventCalendarData.endDate);
        const isEventWithinReleaseCycle =
            releaseCycleEventEnd &&
            releaseCycleEventStart &&
            externalEventStart <= releaseCycleEventEnd! &&
            externalEventEnd >= releaseCycleEventStart!;

        if (!isAtReleaseLevel || isEventWithinReleaseCycle) {
            let newExternalEvent: ReleaseCalendarExternalEventData = {
                id: eventId,
                groupId: '',
                title: externalEventCalendarData.title,
                allDay: false,
                start: externalEventCalendarData.startDate,
                end: externalEventCalendarData.endDate,
                backgroundColor: antGrey.grey5,
                description: externalEventCalendarData.description,
                organizer: externalEventCalendarData.organizer,
                link: externalEventCalendarData.externalEventUrl,
                eventDateType: ReleaseCalendarEventType.ReleaseCalendarExternalEvent,
                connectedIntegrationType: connectedIntegrationType,
            };

            allExternalEvents.push(newExternalEvent);
        }
    });

    return allExternalEvents;
};

export const getLifecycleAndReleaseCycleEvents = (
    releaseCalendarValues: Record<string, ReleaseCalendarData>,
): [ReleaseCalendarReleaseCycleEventData[], ReleaseCalendarLifecycleEventData[]] => {
    let releaseCycleEventData: ReleaseCalendarReleaseCycleEventData[] = [];
    let lifecycleEventData: ReleaseCalendarLifecycleEventData[] = [];
    Object.entries(releaseCalendarValues).forEach(([releaseId, releaseCalendarData]) => {
        if ((releaseCalendarData?.stepLifecycleEvents?.length ?? 0) > 0) {
            const colorResult = mapReleaseCalendarColorToAntColor(
                releaseCalendarData.color,
                releaseCalendarData.status,
            );
            if (!colorResult) return;
            const [color, parentEventColor] = colorResult;
            let startDate: string | null = null;
            let endDate: string | null = null;
            //  Loop thru all the step lifecycle events and set them
            forEach(releaseCalendarData.stepLifecycleEvents, (stepLifecycleEvent: ReleaseCalendarLifecycleEvent) => {
                if (stepLifecycleEvent.lifecycleEventType != LifecycleEventType.LifecycleEventTypeReleaseCycle) {
                    const lifecycleEvent = formatLifecycleEvent(
                        color,
                        releaseCalendarData.status,
                        releaseCalendarData.displayVersion,
                        releaseId,
                        stepLifecycleEvent,
                    );
                    lifecycleEventData.push(lifecycleEvent);
                } else {
                    startDate = stepLifecycleEvent.startDate;
                    const formattedEndDate = dayjs(stepLifecycleEvent.endDate).add(1, 'day');
                    endDate = formattedEndDate.format();
                }
            });

            const releaseEvent: ReleaseCalendarReleaseCycleEventData = {
                id: releaseId,
                title: releaseId,
                start: startDate ?? '',
                end: endDate ?? undefined,
                allDay: true,
                eventDateType: ReleaseCalendarEventType.ReleaseCalendarEventTypeParent,
                groupId: releaseId,
                backgroundColor: parentEventColor,
                parentEventColor: color,
                displayVersion: releaseCalendarData.displayVersion,
                isReleaseCompleted: releaseCalendarData.isReleaseCompleted,
                canReleaseBeSubmitted: releaseCalendarData.canReleaseBeSubmitted,
                scheduledAutomationsPaused: releaseCalendarData.scheduledAutomationsPaused,
                isHotfix: releaseCalendarData.isHotfix,
                releasePilotId: releaseCalendarData.releasePilotId,
                releaseDescription: releaseCalendarData.releaseDescription,
                status: releaseCalendarData.status,
            };

            releaseCycleEventData.push(releaseEvent);
        }
    });

    return [releaseCycleEventData, lifecycleEventData];
};

export const getStepForLifecycleEvent = (lifecycleEventType: LifecycleEventType) => {
    switch (lifecycleEventType) {
        case LifecycleEventType.LifecycleEventTypeKickoff:
            return LifecycleStep.Kickoff;
        case LifecycleEventType.LifecycleEventTypeSubmit:
            return LifecycleStep.Submission;
        case LifecycleEventType.LifecycleEventTypeRelease:
            return LifecycleStep.Release;
        default:
            return null;
    }
};

const sortByTime = (a: { start: string }, b: { start: string }) => {
    const timeA = dayjs(a.start);
    const timeB = dayjs(b.start);
    return timeA.diff(timeB);
};

const addCustomOrder = (events: ReleaseCalendarLifecycleEventData[]): ReleaseCalendarLifecycleEventDataWithOrder[] =>
    events.map((event, index) => ({ ...event, customOrder: index }));

const sortEventsByTimeAndAddOrder = (
    events: ReleaseCalendarLifecycleEventData[],
): ReleaseCalendarLifecycleEventDataWithOrder[] => {
    return addCustomOrder(events.sort(sortByTime));
};

const sortLifecycleEventsOnHoverEvent = (
    calendarLifecycleEvents: ReleaseCalendarLifecycleEventData[],
    calendarReleaseCycleEvents: ReleaseCalendarReleaseCycleEventData[],
    hoveredReleaseVersion: string | null,
): ReleaseCalendarLifecycleEventDataWithOrder[] => {
    if (!hoveredReleaseVersion) {
        return sortEventsByTimeAndAddOrder(calendarLifecycleEvents);
    }

    const hoveredRelease = calendarReleaseCycleEvents.find((event) => event.displayVersion === hoveredReleaseVersion);
    if (!hoveredRelease) {
        return sortEventsByTimeAndAddOrder(calendarLifecycleEvents);
    }

    const hoveredEvents = calendarLifecycleEvents.filter((event) => event.groupId === hoveredRelease.id);
    const otherEvents = calendarLifecycleEvents.filter((event) => event.groupId !== hoveredRelease.id);

    if (hoveredEvents.length === 0) {
        return sortEventsByTimeAndAddOrder(calendarLifecycleEvents);
    }

    const sortedEvents = [...hoveredEvents.sort(sortByTime), ...otherEvents.sort(sortByTime)];

    return addCustomOrder(sortedEvents);
};

export const sortCalendarEvents = (
    calendarLifecycleEvents: ReleaseCalendarLifecycleEventData[],
    calendarReleaseCycleEvents: ReleaseCalendarReleaseCycleEventData[],
    calendarLifecycleFreezeEvents: ReleaseCalendarLifecycleFreezeEventData[],
    hoveredReleaseVersion: string | null,
    hideSkippedReleases: boolean,
): {
    sortedLifecycleEvents: ReleaseCalendarLifecycleEventDataWithOrder[];
    sortedReleaseCycleEvents: ReleaseCalendarReleaseCycleEventData[];
    sortedLifecycleFreezeEvents: ReleaseCalendarLifecycleFreezeEventData[];
} => {
    const sortedReleaseCycleEvents =
        hideSkippedReleases ?
            calendarReleaseCycleEvents.filter((event) => event.status !== ReleaseStatus.Skipped)
        :   [
                ...calendarReleaseCycleEvents
                    .filter((event) => event.status !== ReleaseStatus.Skipped)
                    .sort(sortByTime),
                ...calendarReleaseCycleEvents
                    .filter((event) => event.status === ReleaseStatus.Skipped)
                    .sort(sortByTime),
            ];
    const sortedLifecycleFreezeEvents = calendarLifecycleFreezeEvents.sort(sortByTime);

    if (hideSkippedReleases) {
        const skippedReleaseIds = new Set(
            calendarReleaseCycleEvents.reduce((ids, event) => {
                if (event.status === ReleaseStatus.Skipped) {
                    ids.add(event.id);
                }
                return ids;
            }, new Set()),
        );

        const filteredEvents = calendarLifecycleEvents.filter((event) => !skippedReleaseIds.has(event.groupId));

        return {
            sortedLifecycleEvents: sortLifecycleEventsOnHoverEvent(
                filteredEvents,
                sortedReleaseCycleEvents,
                hoveredReleaseVersion,
            ),
            sortedReleaseCycleEvents,
            sortedLifecycleFreezeEvents,
        };
    }

    const skippedReleaseIds = new Set(
        calendarReleaseCycleEvents.filter((event) => event.status === ReleaseStatus.Skipped).map((event) => event.id),
    );

    const nonSkippedEvents = calendarLifecycleEvents.filter((event) => !skippedReleaseIds.has(event.groupId));
    const skippedEvents = calendarLifecycleEvents.filter((event) => skippedReleaseIds.has(event.groupId));

    const sortedNonSkipped = sortLifecycleEventsOnHoverEvent(
        nonSkippedEvents,
        sortedReleaseCycleEvents,
        hoveredReleaseVersion,
    );

    const sortedSkipped = sortLifecycleEventsOnHoverEvent(
        skippedEvents,
        sortedReleaseCycleEvents,
        hoveredReleaseVersion,
    );

    const maxOrder = Math.max(...sortedNonSkipped.map((e) => e.customOrder || 0), 0);
    const reorderedSkipped = sortedSkipped.map((event, index) => ({
        ...event,
        customOrder: maxOrder + 1 + index,
    }));

    return {
        sortedLifecycleEvents: [...sortedNonSkipped, ...reorderedSkipped],
        sortedReleaseCycleEvents,
        sortedLifecycleFreezeEvents,
    };
};

export const mapReleaseCalendarColorToAntColor = (color: string, status: ReleaseStatus): [string, string] | null => {
    if (status === ReleaseStatus.Skipped) {
        return ['#BFBFBF', '#BFBFBF10'];
    }

    let mainColor = '';
    let secondaryColor = '';

    switch (color) {
        case 'blue':
            mainColor = '#1890FF';
            secondaryColor = '#1890FF10';
            break;
        case 'orange':
            mainColor = '#FA8C16';
            secondaryColor = '#FA8C1610';
            break;
        case 'green':
            mainColor = '#52C41A';
            secondaryColor = '#52C41A10';
            break;
        case 'purple':
            mainColor = '#722ED1';
            secondaryColor = '#722ED110';
            break;
        case 'pink':
            mainColor = '#EB2F96';
            secondaryColor = '#EB2F9610';
            break;
        case 'teal':
            mainColor = '#08979C';
            secondaryColor = '#08979C10';
            break;
        case 'brown':
            mainColor = '#613400';
            secondaryColor = '#61340010';
            break;
        default:
            return null;
    }

    if (status === ReleaseStatus.Predicted) {
        secondaryColor = '#rgb(255, 255, 255, 0)';
    }

    return [mainColor, secondaryColor];
};

export const weekdayNumberFromDayOfWeek: (dayOfTheWeek: DayOfTheWeek) => number = (dayOfTheWeek: DayOfTheWeek) => {
    switch (dayOfTheWeek) {
        case DayOfTheWeek.Sunday:
            return 0;
        case DayOfTheWeek.Monday:
            return 1;
        case DayOfTheWeek.Tuesday:
            return 2;
        case DayOfTheWeek.Wednesday:
            return 3;
        case DayOfTheWeek.Thursday:
            return 4;
        case DayOfTheWeek.Friday:
            return 5;
        case DayOfTheWeek.Saturday:
            return 6;
    }
};

export const isMultipleReleasesCadence = (cadenceSettings: ReleaseScheduleCadenceSettings) => {
    if (
        cadenceSettings?.scheduleCadence === ReleaseScheduleCadenceStyle.Weekly &&
        !!cadenceSettings.cadenceTargetDateSets &&
        cadenceSettings.cadenceTargetDateSets.length > 1
    ) {
        return true;
    } else {
        return false;
    }
};

export const getTargetsConfiguredForStepTypeFromDateSet = (
    dateSet: CadenceTargetDateSet,
    stepType: LifecycleStep,
): [DayOfTheWeek, number, number?] | null => {
    switch (stepType) {
        case LifecycleStep.Kickoff:
            if (dateSetHasFullTargetConfigurationForStepType(dateSet, LifecycleStep.Kickoff)) {
                return [dateSet.kickoffDayOfWeek!, dateSet.kickoffTimeHour!, dateSet.kickoffTimeMinute];
            } else {
                return null;
            }
        case LifecycleStep.Submission:
            if (dateSetHasFullTargetConfigurationForStepType(dateSet, LifecycleStep.Submission)) {
                return [dateSet.submitDayOfWeek!, dateSet.submitTimeHour!, dateSet.submitTimeMinute];
            } else {
                return null;
            }
        case LifecycleStep.Release:
            if (dateSetHasFullTargetConfigurationForStepType(dateSet, LifecycleStep.Release)) {
                return [dateSet.releaseDayOfWeek!, dateSet.releaseTimeHour!, dateSet.releaseTimeMinute];
            } else {
                return null;
            }
        default:
            return null;
    }
};

export const dateSetHasFullTargetConfigurationForStepType = (
    dateSet: CadenceTargetDateSet,
    stepType: LifecycleStep,
): boolean => {
    switch (stepType) {
        case LifecycleStep.Kickoff:
            return !(dateSet.kickoffDayOfWeek == null || dateSet.kickoffTimeHour == null);
        case LifecycleStep.Submission:
            return !(dateSet.submitDayOfWeek == null || dateSet.submitTimeHour == null);
        case LifecycleStep.Release:
            return !(dateSet.releaseDayOfWeek == null || dateSet.releaseTimeHour == null);
        default:
            return false;
    }
};

export const copyToClipboard = async (key: string) => {
    try {
        await navigator.clipboard.writeText(key);
        globalMessage.success('Copied to clipboard!');
    } catch {
        // No-op
    }
};

export const capitalizeFirstLetter = (word: string) => {
    if (!word || word == '') {
        return '';
    } else if (word.length == 1) {
        return word.charAt(0).toUpperCase();
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const bytesToMB = (bytes: number) => {
    const mb = bytes / 1024 / 1024;
    if (mb < 1) {
        const truncatedMB = Math.floor(mb * 100) / 100;
        return parseFloat(truncatedMB.toFixed(2));
    }

    return Math.ceil(bytes / 1024 / 1024);
};

// Returns unique IntegrationProviders that match the given userAppIds and are of the supported VCS types
export const getUniqueIntegrationProvidersForVCSUserData = (
    orgProviders: IntegrationProvider[],
    userAppIds: string[],
    supportedVCSTypes: IntegrationType[],
): IntegrationProvider[] => {
    const uniqueProviders = new Map<string, IntegrationProvider>();

    for (const provider of orgProviders) {
        for (const appId of provider.appIds) {
            if (
                userAppIds.includes(appId) &&
                supportedVCSTypes.some((type) => provider.installedIntegrationTypesByAppId[appId].includes(type))
            ) {
                uniqueProviders.set(provider.id, provider);
            }
        }
    }

    return Array.from(uniqueProviders.values()).sort((a, b) => a.name.localeCompare(b.name));
};

export const getFeatureItemsIgnoredCount = (featureItems: FeatureItem[]) => {
    return featureItems.reduce((acc, item) => (item.ignored ? acc + 1 : acc), 0);
};

export const getAppUsesWorkflows = (app: AppEntity): boolean => {
    return app.appSettings?.isWorkflowsMigratedAndEnabled ?
            (app.workflowOverview?.workflowDestinationStepIds?.length ?? 0) > 1
        :   false;
};

export const getPausedPhasedReleaseWarning = (lastCompletedVersion: string, lastPhasedReleasePercent: number) => {
    return `Your previous release (${lastCompletedVersion}) was halted at ${displayStringForRolloutPercentage(
        lastPhasedReleasePercent,
    )}. Exercise caution before releasing it to all users.`;
};

export const getReleasePreviousVersionToAllUsersTooltip = (lastPhasedReleasePercent: number) => {
    return `Your previous release has only rolled out to ${displayStringForRolloutPercentage(
        lastPhasedReleasePercent,
    )} of users.

    By default, your prior release will NOT automatically accelerate to 100% when releasing the next version. With multiple subsequent incomplete rollouts, this may mean that some of your users will continue on older (n-2, n-3) versions even if they have enabled automatic updates.

    Choose this option to ensure all your users will be on at least your prior release when they update.`;
};

// Surface any "UserFriendlyErrors" from our backend
export const formatErrorMessageForDisplay = (prefix: string, error: string) => {
    if (USER_FRIENDLY_ERRORS.includes(error)) {
        return `${prefix}. ${error}`;
    }

    return `${prefix}. Please try again later`;
};

export const sortLifecycleFreezeSets = (dateSets: LifecycleFreezeSet[]): LifecycleFreezeSet[] =>
    dateSets.sort((a, b) => {
        const dateA = new Date(a.startDate);
        const dateB = new Date(b.startDate);
        return dateA.getTime() - dateB.getTime();
    });

const appleAppStoreTitleForState = (state: AppleAppStoreState): string => {
    const isApprovedOrReleased = appleAppIsApprovedOrReleased(state);

    if (isApprovedOrReleased) {
        return 'Approved';
    }

    switch (state) {
        case AppleAppStoreState.WaitingForReview:
            return 'Waiting for review';
        case AppleAppStoreState.WaitingForExportCompliance:
            return 'Waiting for export compliance';
        case AppleAppStoreState.InReview:
            return 'In review';
        case AppleAppStoreState.Accepted:
        case AppleAppStoreState.Rejected:
            return 'Unresolved issues';
        case AppleAppStoreState.MetadataRejected:
            return 'Metadata rejected';
        default:
            return '';
    }
};

const googleAppStoreTitleForState = (state: GooglePlayStoreState): string => {
    const isReleased = googleAppIsReleased(state);

    if (isReleased) {
        return 'Submitted for review';
    }

    return 'Nothing to review';
};

const samsungAppStoreTitleForState = (state: SamsungAppStoreState): string => {
    switch (state) {
        case SamsungAppStoreState.Registering:
            return 'Registering';
        case SamsungAppStoreState.ForSale:
            return 'For sale';
        case SamsungAppStoreState.ReadyForChange:
            return 'Ready for change';
        case SamsungAppStoreState.ReadyToPreExamination:
            return 'Ready for pre-examination';
        case SamsungAppStoreState.UnderContentReview:
            return 'Under content review';
        case SamsungAppStoreState.ReadyForReview:
        case SamsungAppStoreState.ReadyToPreReviews:
        case SamsungAppStoreState.UnderPreReviews:
        case SamsungAppStoreState.ReadyForContentReview:
        case SamsungAppStoreState.ReadyForDeviceTest:
        case SamsungAppStoreState.UnderDeviceTest:
        case SamsungAppStoreState.ReadyForTestConfirmation:
        case SamsungAppStoreState.UnderTestConfirmation:
            return 'In review';
        case SamsungAppStoreState.Canceled:
            return 'Canceled';
        default:
            return 'Waiting for submission';
    }
};

const huaweiAppStoreTitleForState = (state: HuaweiAppStoreState): string => {
    switch (state) {
        case HuaweiAppStoreState.Released:
            return 'Approved';
        case HuaweiAppStoreState.Reviewing:
            return 'In review';
        case HuaweiAppStoreState.ReleaseCanceled:
            return 'Canceled';
        case HuaweiAppStoreState.ReleaseRejected:
        case HuaweiAppStoreState.RemovalRejected:
        case HuaweiAppStoreState.Removed:
        case HuaweiAppStoreState.UpdateRejected:
            return 'Unresolved issues';
        case HuaweiAppStoreState.Releasing:
            return 'Releasing';
        case HuaweiAppStoreState.Updating:
            return 'Updating';
        default:
            return 'Waiting for submission';
    }
};

const amazonAppStoreTitleForState = (state: AmazonAppStoreState): string => {
    switch (state) {
        case AmazonAppStoreState.Completed:
        case AmazonAppStoreState.Live:
            return 'Approved';
        case AmazonAppStoreState.Review:
            return 'In review';
        case AmazonAppStoreState.Submitted:
            return 'Submitted for review';
        default:
            return 'Waiting for submission';
    }
};

export const appStoreTitleForState = (
    appStoreType: AppStoreType,
    appStoreState?: AppStoreState | null,
    markedRejectedAt?: string,
): string => {
    if (!appStoreType || !appStoreState) {
        return '';
    }

    switch (appStoreType) {
        case AppStoreType.Apple:
            return appleAppStoreTitleForState(appStoreState as AppleAppStoreState);
        case AppStoreType.Google:
            return markedRejectedAt ? 'Rejected by Google' : (
                    googleAppStoreTitleForState(appStoreState as GooglePlayStoreState)
                );
        case AppStoreType.Amazon:
            return amazonAppStoreTitleForState(appStoreState as AmazonAppStoreState);
        case AppStoreType.Huawei:
            return huaweiAppStoreTitleForState(appStoreState as HuaweiAppStoreState);
        case AppStoreType.Samsung:
            return samsungAppStoreTitleForState(appStoreState as SamsungAppStoreState);
        default:
            return '';
    }
};

export const transactionTypesForStepArchetype: (archetype: ReleaseStepType) => TransactionType[] = (archetype) => {
    switch (archetype) {
        case ReleaseStepType.Submission:
            return [TransactionType.SubmitVersion];
        case ReleaseStepType.Rollout:
            return [
                TransactionType.StartHotfix,
                TransactionType.HaltRollout,
                TransactionType.ResumeRollout,
                TransactionType.AccelerateRollout,
            ];
        case ReleaseStepType.Kickoff:
            return [];
        case ReleaseStepType.FeatureReadiness:
            return [];
        case ReleaseStepType.ReleaseCandidate:
            return [TransactionType.RunWorkflow];
        case ReleaseStepType.RegressionTesting:
            return [TransactionType.PingPendingRegressionItems, TransactionType.UpdateRegressionStatus];
        case ReleaseStepType.BetaTesting:
            return [];
        case ReleaseStepType.Metadata:
            return [TransactionType.PopulateReleaseNotes, TransactionType.ApproveMetadata];
        case ReleaseStepType.Screenshots:
            return [];
        case ReleaseStepType.Approvals:
            return [TransactionType.PingPendingApprovalItems];
        case ReleaseStepType.StoreReview:
            return [TransactionType.RejectAppStoreRelease];
        case ReleaseStepType.Takeoff:
            return [TransactionType.ReleaseVersion];
        case ReleaseStepType.CIDistribution:
            return [];
        case ReleaseStepType.VCSDistribution:
            return [];
        case ReleaseStepType.RollbackBuild:
            return [];
        case ReleaseStepType.Translations:
            return [];
        case ReleaseStepType.ReleaseCycle:
            return [];
        default:
            throw new Error(`Unknown ReleaseStepType: ${archetype} for transactionTypesForStepArchetype`);
    }
};

export const GetFixRequestAuthorIds = (status: FixRequestStatusInfo): string[] => {
    return (
        status?.authorIds?.length ? status.authorIds
        : status?.authorId && status?.status !== FixRequestStatusType.FixRequestPending ? [status.authorId]
        : []
    );
};

export const GetFixRequestCurrentApprovals = (status: FixRequestStatusInfo): number => {
    return GetFixRequestAuthorIds(status)?.length ?? 0;
};
